var ia = Object.defineProperty;
var ca = (n, r, e) => r in n ? ia(n, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[r] = e;
var k = (n, r, e) => (ca(n, typeof r != "symbol" ? r + "" : r, e), e);
import { jsxs as Q, jsx as v, Fragment as wt } from "react/jsx-runtime";
import _, { keyframes as ro, css as ce, ThemeProvider as la } from "styled-components";
import { Link as ua, NavLink as da } from "react-router-dom";
import * as T from "react";
import m, { useMemo as pa, forwardRef as Et, useCallback as fa, useState as oo, createElement as ha, Component as ma, useLayoutEffect as ao, useEffect as so, createRef as ga, Fragment as ya } from "react";
import ba, { components as wa } from "react-select";
import * as va from "react-dom";
import ka, { findDOMNode as Da } from "react-dom";
const He = {
  borderRadius: {
    m: {
      "border-radius": "4px"
    },
    l: {
      "border-radius": "8px"
    },
    xl: {
      "border-radius": "12px"
    }
  },
  breakpoints: {
    mobileAndLower: "@media only screen and (max-width: 700px)",
    tabletAndLower: "@media only screen and (max-width: 1023px)"
  },
  bezierCurve: "cubic-bezier(.26,.11,.26,1)",
  headingFont: "Plus Jakarta Sans, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  bodyFont: "Inter, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  fonts: {
    xs: {
      "font-size": "0.75rem"
      // 12px
    },
    s: {
      "font-size": "0.875rem"
      // 14px
    },
    m: {
      "font-size": "1rem"
      // 16px
    },
    l: {
      "font-size": "1.25rem"
      // 20px
    },
    xl: {
      "font-size": "1.5rem"
      // 24px
    },
    xl2: {
      "font-size": "2rem"
      // 32px
    },
    xl3: {
      "font-size": "2.5rem"
      // 40px
    },
    xl4: {
      "font-size": "3rem"
      // 48px
    },
    xl5: {
      "font-size": "3.5rem"
      // 56p
    }
  },
  colors: {
    primary: "#2552EC",
    success: "#24D39F",
    danger: "#E52E37",
    warning: "#FF9F1C",
    black: "#000",
    white: "#fff",
    grey: "#607995",
    // legacy grey should probably be replaced
    grey100: "#E1E5F2",
    grey200: "#A1AAC7",
    grey300: "#68718C",
    grey400: "#4B526B",
    grey500: "#282E42",
    grey600: "#161C30",
    grey800: "#050B1F"
  }
}, xa = ro({
  "0%": {
    strokeDashoffset: "0",
    strokeDasharray: "150 100"
  },
  "50%": {
    strokeDasharray: "1 250"
  },
  "100%": {
    strokeDashoffset: "502",
    strokeDasharray: "150 100"
  }
}), ur = _.circle`
  animation: ${xa} 2s linear infinite;
  fill: none;
  stroke: ${({ theme: n, color: r }) => n.colors[r ?? "primary"]};
`, Vn = ({ color: n, size: r }) => /* @__PURE__ */ Q("svg", { role: "alert", "aria-busy": "true", width: r, height: r, viewBox: "0 0 100 100", children: [
  /* @__PURE__ */ v(ur, { cx: 50, cy: 50, r: 40 }),
  /* @__PURE__ */ v(ur, { cx: 50, cy: 50, r: 40, color: n, strokeWidth: 12, strokeLinecap: "round" })
] }), Ca = ro({
  "0%": { opacity: 0 },
  "100%": { opacity: 1 }
}), Sa = _.div`
  display: inline-block;
  animation: ${Ca} 250ms ease-in-out;
  width: ${({ size: n }) => n}px;
  height: ${({ size: n }) => n}px;

  ${({ centered: n, size: r }) => n && r && ce`
      position: absolute;
      top: calc(50% - ${r / 2}px);
      left: calc(50% - ${r / 2}px);
    `}
`, Cd = ({
  size: n = 80,
  centered: r = !1,
  color: e,
  ...t
}) => /* @__PURE__ */ v(Sa, { size: n, centered: r, ...t, children: /* @__PURE__ */ v(Vn, { size: n, color: e ?? "primary" }) });
function jt() {
  return jt = Object.assign ? Object.assign.bind() : function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    }
    return n;
  }, jt.apply(this, arguments);
}
function Ma(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function vt(n, r) {
  return vt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, o) {
    return t.__proto__ = o, t;
  }, vt(n, r);
}
function Pa(n, r) {
  n.prototype = Object.create(r.prototype), n.prototype.constructor = n, vt(n, r);
}
function Tn(n) {
  return Tn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Tn(n);
}
function _a(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function Ea() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ft(n, r, e) {
  return Ea() ? Ft = Reflect.construct.bind() : Ft = function(o, s, a) {
    var i = [null];
    i.push.apply(i, s);
    var c = Function.bind.apply(o, i), l = new c();
    return a && vt(l, a.prototype), l;
  }, Ft.apply(null, arguments);
}
function Nn(n) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Nn = function(t) {
    if (t === null || !_a(t))
      return t;
    if (typeof t != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(t))
        return r.get(t);
      r.set(t, o);
    }
    function o() {
      return Ft(t, arguments, Tn(this).constructor);
    }
    return o.prototype = Object.create(t.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), vt(o, t);
  }, Nn(n);
}
var Oa = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function Ta() {
  for (var n = arguments.length, r = new Array(n), e = 0; e < n; e++)
    r[e] = arguments[e];
  var t = r[0], o = [], s;
  for (s = 1; s < r.length; s += 1)
    o.push(r[s]);
  return o.forEach(function(a) {
    t = t.replace(/%[a-z]/, a);
  }), t;
}
var ke = /* @__PURE__ */ function(n) {
  Pa(r, n);
  function r(e) {
    var t;
    if (process.env.NODE_ENV === "production")
      t = n.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + e + " for more information.") || this;
    else {
      for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
        s[a - 1] = arguments[a];
      t = n.call(this, Ta.apply(void 0, [Oa[e]].concat(s))) || this;
    }
    return Ma(t);
  }
  return r;
}(/* @__PURE__ */ Nn(Error));
function fn(n) {
  return Math.round(n * 255);
}
function Na(n, r, e) {
  return fn(n) + "," + fn(r) + "," + fn(e);
}
function kt(n, r, e, t) {
  if (t === void 0 && (t = Na), r === 0)
    return t(e, e, e);
  var o = (n % 360 + 360) % 360 / 60, s = (1 - Math.abs(2 * e - 1)) * r, a = s * (1 - Math.abs(o % 2 - 1)), i = 0, c = 0, l = 0;
  o >= 0 && o < 1 ? (i = s, c = a) : o >= 1 && o < 2 ? (i = a, c = s) : o >= 2 && o < 3 ? (c = s, l = a) : o >= 3 && o < 4 ? (c = a, l = s) : o >= 4 && o < 5 ? (i = a, l = s) : o >= 5 && o < 6 && (i = s, l = a);
  var d = e - s / 2, f = i + d, g = c + d, h = l + d;
  return t(f, g, h);
}
var dr = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function Ra(n) {
  if (typeof n != "string")
    return n;
  var r = n.toLowerCase();
  return dr[r] ? "#" + dr[r] : n;
}
var Ia = /^#[a-fA-F0-9]{6}$/, Ya = /^#[a-fA-F0-9]{8}$/, La = /^#[a-fA-F0-9]{3}$/, Fa = /^#[a-fA-F0-9]{4}$/, hn = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, $a = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, Aa = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, Wa = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function io(n) {
  if (typeof n != "string")
    throw new ke(3);
  var r = Ra(n);
  if (r.match(Ia))
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16)
    };
  if (r.match(Ya)) {
    var e = parseFloat((parseInt("" + r[7] + r[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16),
      alpha: e
    };
  }
  if (r.match(La))
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16)
    };
  if (r.match(Fa)) {
    var t = parseFloat((parseInt("" + r[4] + r[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16),
      alpha: t
    };
  }
  var o = hn.exec(r);
  if (o)
    return {
      red: parseInt("" + o[1], 10),
      green: parseInt("" + o[2], 10),
      blue: parseInt("" + o[3], 10)
    };
  var s = $a.exec(r.substring(0, 50));
  if (s)
    return {
      red: parseInt("" + s[1], 10),
      green: parseInt("" + s[2], 10),
      blue: parseInt("" + s[3], 10),
      alpha: parseFloat("" + s[4]) > 1 ? parseFloat("" + s[4]) / 100 : parseFloat("" + s[4])
    };
  var a = Aa.exec(r);
  if (a) {
    var i = parseInt("" + a[1], 10), c = parseInt("" + a[2], 10) / 100, l = parseInt("" + a[3], 10) / 100, d = "rgb(" + kt(i, c, l) + ")", f = hn.exec(d);
    if (!f)
      throw new ke(4, r, d);
    return {
      red: parseInt("" + f[1], 10),
      green: parseInt("" + f[2], 10),
      blue: parseInt("" + f[3], 10)
    };
  }
  var g = Wa.exec(r.substring(0, 50));
  if (g) {
    var h = parseInt("" + g[1], 10), y = parseInt("" + g[2], 10) / 100, b = parseInt("" + g[3], 10) / 100, C = "rgb(" + kt(h, y, b) + ")", D = hn.exec(C);
    if (!D)
      throw new ke(4, r, C);
    return {
      red: parseInt("" + D[1], 10),
      green: parseInt("" + D[2], 10),
      blue: parseInt("" + D[3], 10),
      alpha: parseFloat("" + g[4]) > 1 ? parseFloat("" + g[4]) / 100 : parseFloat("" + g[4])
    };
  }
  throw new ke(5);
}
function Ha(n) {
  var r = n.red / 255, e = n.green / 255, t = n.blue / 255, o = Math.max(r, e, t), s = Math.min(r, e, t), a = (o + s) / 2;
  if (o === s)
    return n.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: a,
      alpha: n.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: a
    };
  var i, c = o - s, l = a > 0.5 ? c / (2 - o - s) : c / (o + s);
  switch (o) {
    case r:
      i = (e - t) / c + (e < t ? 6 : 0);
      break;
    case e:
      i = (t - r) / c + 2;
      break;
    default:
      i = (r - e) / c + 4;
      break;
  }
  return i *= 60, n.alpha !== void 0 ? {
    hue: i,
    saturation: l,
    lightness: a,
    alpha: n.alpha
  } : {
    hue: i,
    saturation: l,
    lightness: a
  };
}
function co(n) {
  return Ha(io(n));
}
var ja = function(r) {
  return r.length === 7 && r[1] === r[2] && r[3] === r[4] && r[5] === r[6] ? "#" + r[1] + r[3] + r[5] : r;
}, Rn = ja;
function je(n) {
  var r = n.toString(16);
  return r.length === 1 ? "0" + r : r;
}
function mn(n) {
  return je(Math.round(n * 255));
}
function Ba(n, r, e) {
  return Rn("#" + mn(n) + mn(r) + mn(e));
}
function Bt(n, r, e) {
  return kt(n, r, e, Ba);
}
function qa(n, r, e) {
  if (typeof n == "number" && typeof r == "number" && typeof e == "number")
    return Bt(n, r, e);
  if (typeof n == "object" && r === void 0 && e === void 0)
    return Bt(n.hue, n.saturation, n.lightness);
  throw new ke(1);
}
function Qa(n, r, e, t) {
  if (typeof n == "number" && typeof r == "number" && typeof e == "number" && typeof t == "number")
    return t >= 1 ? Bt(n, r, e) : "rgba(" + kt(n, r, e) + "," + t + ")";
  if (typeof n == "object" && r === void 0 && e === void 0 && t === void 0)
    return n.alpha >= 1 ? Bt(n.hue, n.saturation, n.lightness) : "rgba(" + kt(n.hue, n.saturation, n.lightness) + "," + n.alpha + ")";
  throw new ke(2);
}
function In(n, r, e) {
  if (typeof n == "number" && typeof r == "number" && typeof e == "number")
    return Rn("#" + je(n) + je(r) + je(e));
  if (typeof n == "object" && r === void 0 && e === void 0)
    return Rn("#" + je(n.red) + je(n.green) + je(n.blue));
  throw new ke(6);
}
function Ka(n, r, e, t) {
  if (typeof n == "string" && typeof r == "number") {
    var o = io(n);
    return "rgba(" + o.red + "," + o.green + "," + o.blue + "," + r + ")";
  } else {
    if (typeof n == "number" && typeof r == "number" && typeof e == "number" && typeof t == "number")
      return t >= 1 ? In(n, r, e) : "rgba(" + n + "," + r + "," + e + "," + t + ")";
    if (typeof n == "object" && r === void 0 && e === void 0 && t === void 0)
      return n.alpha >= 1 ? In(n.red, n.green, n.blue) : "rgba(" + n.red + "," + n.green + "," + n.blue + "," + n.alpha + ")";
  }
  throw new ke(7);
}
var za = function(r) {
  return typeof r.red == "number" && typeof r.green == "number" && typeof r.blue == "number" && (typeof r.alpha != "number" || typeof r.alpha > "u");
}, Va = function(r) {
  return typeof r.red == "number" && typeof r.green == "number" && typeof r.blue == "number" && typeof r.alpha == "number";
}, Ua = function(r) {
  return typeof r.hue == "number" && typeof r.saturation == "number" && typeof r.lightness == "number" && (typeof r.alpha != "number" || typeof r.alpha > "u");
}, Ga = function(r) {
  return typeof r.hue == "number" && typeof r.saturation == "number" && typeof r.lightness == "number" && typeof r.alpha == "number";
};
function lo(n) {
  if (typeof n != "object")
    throw new ke(8);
  if (Va(n))
    return Ka(n);
  if (za(n))
    return In(n);
  if (Ga(n))
    return Qa(n);
  if (Ua(n))
    return qa(n);
  throw new ke(8);
}
function uo(n, r, e) {
  return function() {
    var o = e.concat(Array.prototype.slice.call(arguments));
    return o.length >= r ? n.apply(this, o) : uo(n, r, o);
  };
}
function po(n) {
  return uo(n, n.length, []);
}
function fo(n, r, e) {
  return Math.max(n, Math.min(r, e));
}
function Xa(n, r) {
  if (r === "transparent")
    return r;
  var e = co(r);
  return lo(jt({}, e, {
    lightness: fo(0, 1, e.lightness - parseFloat(n))
  }));
}
var Za = /* @__PURE__ */ po(Xa), Ot = Za;
function Ja(n, r) {
  if (r === "transparent")
    return r;
  var e = co(r);
  return lo(jt({}, e, {
    lightness: fo(0, 1, e.lightness + parseFloat(n))
  }));
}
var es = /* @__PURE__ */ po(Ja), Ze = es;
const Sd = (n) => Ze(0.5, n), ts = (n) => Ze(0.48, n), Dt = (n) => Ze(0.4, n), ho = (n) => Ze(0.32, n), Md = (n) => Ze(0.24, n), ns = (n) => Ze(0.16, n), Pd = (n) => Ze(0.08, n), _e = (n) => n, pe = (n) => Ot(0.08, n), ze = (n) => Ot(0.16, n), Un = (n) => Ot(0.24, n), _d = (n) => Ot(0.32, n), Ed = (n) => Ot(0.4, n), rs = (n, r) => {
  switch (n) {
    case "small":
      return { padding: "4px 8px", ...r.fonts.xs };
    case "medium":
      return { padding: "8px 16px", ...r.fonts.m };
    case "large":
      return { padding: "16px 24px", ...r.fonts.l };
  }
}, mo = _.button`
  font-weight: 600;
  border: 1px solid transparent;
  display: block;
  transition: ${({ theme: n }) => `background-color 125ms ${n.bezierCurve}, color 125ms ${n.bezierCurve}`};
  position: relative;
  pointer-events: ${(n) => n.isLoading ? "none" : void 0};
  white-space: nowrap;

  ${({ theme: n }) => n.borderRadius.m}
  ${({ theme: n }) => n.fonts.m};
  font-family: ${({ theme: n }) => n.bodyFont};
  ${({ theme: n, size: r }) => rs(r, n)};
  font-family: ${({ theme: n }) => n.bodyFont};
  ${({ variant: n }) => ss(n)};

  flex-grow: ${({ flexGrow: n }) => n ?? 0};

  > div {
    visibility: ${({ isLoading: n }) => n ? "hidden" : void 0};
  }

  > svg {
    display: ${({ isLoading: n }) => n ? "flex" : "none"};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`, os = (n) => ce`
    &:not(:disabled) {
      cursor: pointer;
    }

    &:hover:not(:disabled) {
      background-color: ${({ theme: r }) => pe(r.colors[n])};
    }

    &:focus:not(:disabled) {
      background-color: ${({ theme: r }) => pe(r.colors[n])};
    }

    &:active:not(:disabled) {
      background-color: ${({ theme: r }) => ze(r.colors[n])};
    }

    &:disabled {
      opacity: 32%;
    }
  `, gn = (n) => n === "text" ? "primary" : "grey", as = (n) => ce`
    background: transparent;
    padding-left: 4px;
    padding-right: 4px;

    &:only-of-type {
      padding-left: 0px;
    }

    &:not(:disabled) {
      cursor: pointer;
    }

    &:hover:not(:disabled) {
      color: ${({ theme: r }) => pe(r.colors[gn(n)])};
    }

    &:focus:not(:disabled) {
      color: ${({ theme: r }) => pe(r.colors[gn(n)])};
    }

    &:active:not(:disabled) {
      color: ${({ theme: r }) => ze(r.colors[gn(n)])};
    }

    &:disabled {
      opacity: 32%;
    }
  `, pr = (n) => n === "text" || n === "secondaryText" ? ce`
      ${as(n)}
    ` : ce`
    ${os(n)};
    background: ${({ theme: r }) => _e(r.colors[n])};
  `, ss = (n) => {
  switch (n) {
    case "secondary":
      return ce`
        ${pr("white")};
        border-color: ${({ theme: r }) => _e(r.colors.grey)};
        color: ${({ theme: r }) => _e(r.colors[qt(n)])};
      `;
    default:
      return ce`
        ${pr(n)}
        color: ${({ theme: r }) => _e(r.colors[qt(n)])};
      `;
  }
}, qt = (n) => {
  switch (n) {
    case "secondary":
    case "secondaryText":
      return "grey";
    case "text":
      return "primary";
    default:
      return "white";
  }
}, go = ({
  variant: n = "primary",
  size: r = "medium",
  type: e = "button",
  isLoading: t,
  flexGrow: o,
  children: s,
  logLabel: a,
  ...i
}) => /* @__PURE__ */ Q(
  mo,
  {
    "aria-busy": t,
    isLoading: t,
    size: r,
    type: e,
    variant: n,
    flexGrow: o,
    "data-loglabel": a,
    ...i,
    children: [
      /* @__PURE__ */ v("div", { children: s }),
      /* @__PURE__ */ v(Vn, { size: "75%", color: qt(n) })
    ]
  }
), is = ce`
  cursor: not-allowed;
  pointer-events: none;
`, cs = _(ua)`
  text-decoration: none;
  ${({ disabled: n }) => n && is}
`, Od = ({
  variant: n = "primary",
  size: r = "medium",
  type: e = "button",
  isLoading: t,
  flexGrow: o,
  children: s,
  to: a,
  disabled: i,
  target: c,
  logLabel: l,
  ...d
}) => /* @__PURE__ */ v(cs, { "aria-disabled": i, disabled: i, to: a, target: c, children: /* @__PURE__ */ Q(
  mo,
  {
    "aria-busy": t,
    isLoading: t,
    size: r,
    type: e,
    variant: n,
    flexGrow: o,
    disabled: i,
    "data-loglabel": l,
    ...d,
    children: [
      /* @__PURE__ */ v("div", { children: s }),
      /* @__PURE__ */ v(Vn, { size: "75%", color: qt(n) })
    ]
  }
) }), R = {
  xs2: "4px",
  xs: "8px",
  s: "12px",
  m: "16px",
  l: "20px",
  gutter: "24px",
  xl2: "32px",
  xl3: "40px",
  xl4: "48px",
  xl5: "56px"
}, fr = (n) => typeof n == "string" || typeof n == "number", z = (n) => {
  if (n) {
    if (!fr(n) && n.length > 3)
      throw new Error("Only three breakpoints are available for spacing");
    return fr(n) ? { mobile: n, tablet: n, desktop: n } : n.length === 1 ? { mobile: n[0], tablet: n[0], desktop: n[0] } : n.length === 2 ? { mobile: n[0], tablet: n[0], desktop: n[1] } : { mobile: n[0], tablet: n[1], desktop: n[2] };
  }
}, rn = ce`
  ${({ p: n, pX: r, pY: e }) => yn(n == null ? void 0 : n.desktop, r == null ? void 0 : r.desktop, e == null ? void 0 : e.desktop)}

  display: ${({ display: n }) => n};
  align-items: ${({ alignItems: n }) => n};
  justify-content: ${({ justifyContent: n }) => n};
  flex-direction: ${({ flexDirection: n }) => n};

  background-color: ${({ debug: n }) => n ? "rgba(255,188,180, 0.5) !important" : void 0};

  ${({ theme: n }) => n.breakpoints.tabletAndLower} {
    ${({ p: n, pX: r, pY: e }) => yn(n == null ? void 0 : n.tablet, r == null ? void 0 : r.tablet, e == null ? void 0 : e.tablet)}
  }

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ p: n, pX: r, pY: e }) => yn(n == null ? void 0 : n.mobile, r == null ? void 0 : r.mobile, e == null ? void 0 : e.mobile)}
  }
`, yn = (n, r, e) => `
  ${n ? `padding: ${R[n]};` : ""}
  ${e ? `padding-top: ${R[e]};` : ""}
  ${e ? `padding-bottom: ${R[e]};` : ""}
  ${r ? `padding-left: ${R[r]};` : ""}
  ${r ? `padding-right: ${R[r]};` : ""}
`, ls = _.div`
  ${rn}

  align-items: ${({ alignItems: n }) => n ?? "flex-start"};

  button:first-child {
    margin-bottom: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("column")) && R[(n == null ? void 0 : n.desktop) ?? "gutter"]};

    ${({ theme: n }) => n.breakpoints.tabletAndLower} {
      margin-bottom: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("column")) && R[(n == null ? void 0 : n.tablet) ?? "m"]};
    }

    ${({ theme: n }) => n.breakpoints.mobileAndLower} {
      margin-bottom: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("column")) && R[(n == null ? void 0 : n.mobile) ?? "s"]};
    }
  }

  button:not(:first-child) {
    margin-left: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("row")) && R[(n == null ? void 0 : n.desktop) ?? "gutter"]};

    ${({ theme: n }) => n.breakpoints.tabletAndLower} {
      margin-left: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("row")) && R[(n == null ? void 0 : n.tablet) ?? "m"]};
    }

    ${({ theme: n }) => n.breakpoints.mobileAndLower} {
      margin-left: ${({ spaceBetween: n, flexDirection: r }) => (r == null ? void 0 : r.includes("row")) && R[(n == null ? void 0 : n.mobile) ?? "s"]};
    }
  }
`, us = ({ p: n, pX: r, pY: e, spaceBetween: t, children: o, ...s }) => {
  const a = z(n), i = z(r), c = z(e), l = z(t);
  return /* @__PURE__ */ v(
    ls,
    {
      "data-testid": "button-group",
      spaceBetween: l,
      p: a,
      pY: c,
      pX: i,
      display: s.display ?? "flex",
      flexDirection: s.flexDirection ?? "row",
      ...s,
      children: /* @__PURE__ */ v(wt, { children: o })
    }
  );
}, hr = (n) => {
  switch (n) {
    case "info":
      return "primary";
    case "warning":
    case "success":
      return n;
    case "error":
      return "danger";
  }
}, ds = _.div`
  background-color: ${({ theme: n, type: r }) => ts(
  n.colors[hr(r)]
  // We know type is defined here because we have a default
)};
  min-width: 320px;
  ${({ theme: n }) => n.borderRadius.m};
  padding: 8px 16px;
  border: 1px solid ${({ theme: n, type: r }) => n.colors[hr(r)]};
  border-left-width: 4px;
  ${({ theme: n }) => n.borderRadius.m};
  color: ${({ theme: n }) => _e(n.colors.black)};
  font-weight: 600;
  font-size: 16px;
`, Td = ({ type: n = "info", children: r, ...e }) => /* @__PURE__ */ v(ds, { type: n, ...e, children: r }), ps = _.div`
  display: inline-block;
`, fs = (n, r, e) => {
  if (e === "lighter")
    switch (n) {
      case "warning":
        return {
          background: "#EDC58A",
          color: r.grey800
        };
      case "success":
        return {
          background: "#9EE5D0",
          color: r.grey500
        };
      case "danger":
        return {
          background: "#F3B1BC",
          color: r.grey600
        };
      case "grey":
        return {
          background: r.grey100,
          color: r.grey600
        };
      case "primary":
        return {
          background: "#C2D0FF",
          color: r.grey600
        };
    }
  switch (n) {
    case "warning":
      return {
        background: r.warning,
        color: "#282000"
      };
    case "success":
      return {
        background: r.success,
        color: r.grey600
        //'#161C30',
      };
    case "danger":
      return {
        background: r.danger,
        color: r.white
      };
    case "grey":
      return {
        background: r.grey200,
        color: "#050B1F"
      };
    case "black":
      return {
        background: r.black,
        color: r.white
      };
    case "primary":
    default:
      return {
        background: r.primary,
        color: r.white
      };
  }
}, hs = _.div`
  padding: 0px 8px;
  ${({ lightness: n, color: r, theme: e }) => fs(r, e.colors, n)};
  ${({ theme: n }) => n.fonts.m};
  font-family: ${({ theme: n }) => n.bodyFont};
  ${({ theme: n }) => n.borderRadius.m};
  font-weight: 500;
`, Nd = ({ color: n, children: r, lightness: e, ...t }) => /* @__PURE__ */ v(ps, { children: /* @__PURE__ */ v(hs, { color: n, lightness: e, ...t, children: r }) }), Ae = (n, r) => r === "grey" ? pe(n.colors.grey) : n.colors[r ?? "black"], ms = _.h1`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.xl3};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, gs = _.h2`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.xl2};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, ys = _.h3`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.xl};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};
  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, bs = _.h4`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.l};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};
  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, ws = _.h5`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.m};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};
  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, vs = _.h6`
  ${({ theme: n, size: r }) => r ? n.fonts[r] : n.fonts.s};
  font-family: ${({ theme: n, useBodyFont: r = !1 }) => r ? n.bodyFont : n.headingFont};
  font-weight: ${({ weight: n }) => n ?? 700};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ theme: n, color: r }) => Ae(n, r)};
  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    ${({ mobilesize: n, theme: r }) => n ? r.fonts[n] : ""};
  }
`, Rd = (n) => /* @__PURE__ */ v(ms, { as: n.type ?? "span", ...n }), Id = (n) => /* @__PURE__ */ v(gs, { as: n.type ?? "span", ...n }), Yd = (n) => /* @__PURE__ */ v(ys, { as: n.type ?? "span", ...n }), Ld = (n) => /* @__PURE__ */ v(bs, { as: n.type ?? "span", ...n }), Fd = (n) => /* @__PURE__ */ v(ws, { as: n.type ?? "span", ...n }), $d = (n) => /* @__PURE__ */ v(vs, { as: n.type ?? "span", ...n }), yo = _.p`
  ${({ theme: n, size: r }) => n.fonts[r ?? "m"]};
  font-family: ${({ theme: n }) => n.bodyFont};
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: ${({ bold: n }) => n ? 600 : void 0};
  color: ${({ theme: n, color: r }) => Ae(n, r)};
`, Ad = _.span`
  /* 540 is a good width for allowing roughly 75 characters, which is the maximum length for comfortable reading */
  max-width: 540px;
  ${({ theme: n, size: r }) => n.fonts[r ?? "m"]};
  font-family: ${({ theme: n }) => n.bodyFont};
  color: ${({ theme: n, color: r }) => Ae(n, r)};
  font-weight: ${({ bold: n }) => n ? 600 : void 0};
  font-style: ${({ italic: n }) => n ? "italic" : void 0};
`, ks = _.div`
  ${rn}

  > :not(:last-child) {
    margin-bottom: ${({ spacing: n }) => R[n.desktop]};
  }

  ${({ theme: n }) => n.breakpoints.tabletAndLower} {
    > :not(:last-child) {
      margin-bottom: ${({ spacing: n }) => R[n.tablet]};
    }
  }

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    > :not(:last-child) {
      margin-bottom: ${({ spacing: n }) => R[n.mobile]};
    }
  }
`, bo = ({
  p: n,
  pX: r,
  pY: e,
  spacing: t,
  children: o,
  ...s
}) => {
  const a = z(n), i = z(r), c = z(e), l = z(t);
  return /* @__PURE__ */ v(
    ks,
    {
      spacing: l,
      p: a,
      pY: c,
      pX: i,
      ...s,
      children: o
    }
  );
}, Ds = _.div`
  ${rn}
`, fe = ({ p: n, pX: r, pY: e, children: t, ...o }) => {
  const s = z(n), a = z(r), i = z(e);
  return /* @__PURE__ */ v(Ds, { p: s, pY: i, pX: a, ...o, children: t });
}, xs = _(fe)`
  @media (min-width: 768px) {
    margin: 0 0 0 320px;
    overflow-x: auto;
  }

  @media (max-width: 767px) {
    margin: 77px 0 0 0;
  }

  max-width: 960px;
`, Cs = _(fe)`
  border-bottom: 1px solid ${({ theme: n }) => Dt(n.colors.grey)};
`, Wd = ({
  children: n,
  header: r,
  ...e
}) => /* @__PURE__ */ v(xs, { ...e, pX: "gutter", children: /* @__PURE__ */ Q(bo, { spacing: "m", children: [
  /* @__PURE__ */ v(Cs, { pY: "m", children: r }),
  n
] }) }), Hd = ({
  gap: n,
  columns: r,
  rows: e,
  autoFlow: t,
  p: o,
  children: s,
  ...a
}) => {
  const i = z(n), c = z(r), l = z(e), d = z(o);
  return /* @__PURE__ */ v(
    Ss,
    {
      gap: i,
      columns: c,
      rows: l,
      autoFlow: t,
      padding: d,
      ...a,
      children: s
    }
  );
}, Ss = _(fe)`
  display: grid;

  gap: ${({ gap: n }) => R[(n == null ? void 0 : n.desktop) ?? "xs"]};
  grid-template-columns: ${({ columns: n }) => (n == null ? void 0 : n.desktop) ?? "none"};
  grid-template-rows: ${({ rows: n }) => (n == null ? void 0 : n.desktop) ?? "none"};
  grid-auto-flow: ${({ autoFlow: n }) => n ?? "none"};
  padding: ${({ padding: n }) => n != null && n.desktop ? R[n.desktop] : 0};
  align-items: ${({ alignItems: n }) => n ?? "normal"};

  ${({ theme: n }) => n.breakpoints.tabletAndLower} {
    gap: ${(n) => {
  var r;
  return R[((r = n.gap) == null ? void 0 : r.tablet) ?? "xs"];
}};
    grid-template-columns: ${({ columns: n }) => (n == null ? void 0 : n.tablet) ?? "none"};
    grid-template-rows: ${({ rows: n }) => (n == null ? void 0 : n.tablet) ?? "none"};
    padding: ${({ padding: n }) => n != null && n.desktop ? R[n.tablet] : 0};
  }

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    gap: ${(n) => {
  var r;
  return R[((r = n.gap) == null ? void 0 : r.mobile) ?? "xs"];
}};
    grid-template-columns: ${({ columns: n }) => n == null ? void 0 : n.mobile};
    grid-template-rows: ${({ rows: n }) => (n == null ? void 0 : n.mobile) ?? "none"};
    padding: ${({ padding: n }) => n != null && n.desktop ? R[n.mobile] : 0};
  }
`, Ms = _.div`
  justify-content: start;
  ${rn}

  display: flex;
  flex-wrap: ${({ noWrap: n }) => n ? "nowrap" : "wrap"};

  gap: ${({ gap: n }) => R[(n == null ? void 0 : n.desktop) ?? "xs"]};

  ${({ rowGap: n }) => n ? `row-gap: ${R[n.desktop]};` : ""}
  ${({ colGap: n }) => n ? `column-gap: ${R[n.desktop]};` : ""}


  ${({ theme: n }) => n.breakpoints.tabletAndLower} {
    gap: ${(n) => {
  var r;
  return R[((r = n.gap) == null ? void 0 : r.tablet) ?? "xs"];
}};
    ${({ rowGap: n }) => n ? `row-gap: ${R[n.tablet]};` : ""}
    ${({ colGap: n }) => n ? `column-gap: ${R[n.tablet]};` : ""}
  }

  ${({ theme: n }) => n.breakpoints.mobileAndLower} {
    gap: ${(n) => {
  var r;
  return R[((r = n.gap) == null ? void 0 : r.mobile) ?? "xs"];
}};
    ${({ rowGap: n }) => n ? `row-gap: ${R[n.mobile]};` : ""}
    ${({ colGap: n }) => n ? `column-gap: ${R[n.mobile]};` : ""}
  }
`, jd = ({
  p: n,
  pX: r,
  pY: e,
  gap: t,
  children: o,
  rowGap: s,
  colGap: a,
  ...i
}) => {
  const c = z(n), l = z(r), d = z(e), f = z(t), g = z(s), h = z(a);
  return /* @__PURE__ */ v(
    Ms,
    {
      gap: f,
      p: c,
      pY: d,
      pX: l,
      rowGap: g,
      colGap: h,
      ...i,
      children: o
    }
  );
}, Gn = ce`
  border: 1px solid;
  padding: 7px 12px; // -1 on height on each side because of the border, we want a total height of 40
  color: ${({ theme: n }) => pe(n.colors.grey)};
  border-color: ${({ error: n, theme: r }) => n ? `${_e(r.colors.danger)} !important` : pe(r.colors.grey)};
  transition: border-color 300ms ${({ theme: n }) => n.bezierCurve},
    opacity 300ms ${({ theme: n }) => n.bezierCurve};
  flex-grow: 0;
  display: block;
  width: 100%;
  max-width: 640px;
  line-height: 1.5;

  ${({ theme: n }) => n.fonts.m};
  font-family: ${({ theme: n }) => n.bodyFont};
  ${({ theme: n }) => n.borderRadius.m};

  &:hover {
    border-color: ${({ theme: n }) => Un(n.colors.grey)};
  }

  &::placeholder {
    color: ${({ theme: n }) => ns(n.colors.grey)};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme: n }) => _e(n.colors.primary)};
  }

  &:active {
    border-color: ${({ theme: n }) => _e(n.colors.primary)};
    outline: none;
  }

  &:disabled {
    opacity: 48%;
  }
`, Tt = () => pa(() => Math.floor(Math.random() * 1e3 * (Math.random() * 1e3)), []), Ps = _.label`
  ${({ theme: n }) => n.fonts.m};

  display: flex;
  color: ${({ theme: n }) => n.colors.black};
  font-weight: 400;
`, ft = ({ children: n, ...r }) => /* @__PURE__ */ v(Ps, { ...r, children: n }), _s = _.input`
  ${Gn}
`, Es = _.div`
  position: absolute;
  display: flex;
  left: ${(n) => n.iconPosition === "left" ? "8px" : void 0};
  right: ${(n) => n.iconPosition === "right" ? "8px" : void 0};
  top: 50%;
  transform: translateY(-50%);
`, Os = _.i`
  position: absolute;
  bottom: 5px;
  left: ${(n) => n.iconPosition === "left" ? "8px" : void 0};
  right: ${(n) => n.iconPosition === "right" ? "8px" : void 0};

  font-size: 20px;

  &::before {
    margin: 0;
  }
`, Ts = ce`
  padding-left: 32px;
`, Ns = ce`
  padding-right: 32px;
`, Rs = _(_s)`
  ${({ hasIcon: n, iconPosition: r }) => n ? r === "left" ? Ts : Ns : void 0};
`, Is = _.div`
  max-width: 694px;
  position: relative;
`, Ys = Et(
  ({ label: n, error: r, icon: e, iconPosition: t = "left", noScroll: o, ...s }, a) => {
    const i = Tt(), c = `Input-${i}`, l = `Label-${i}`;
    return /* @__PURE__ */ Q(Is, { children: [
      n && /* @__PURE__ */ v(ft, { id: l, htmlFor: c, children: n }),
      /* @__PURE__ */ v(
        Rs,
        {
          ref: a,
          id: c,
          "aria-labelledby": l,
          hasIcon: !!e,
          iconPosition: t,
          onWheel: (d) => {
            o && d.currentTarget.blur();
          },
          error: r,
          ...s
        }
      ),
      e !== "" && typeof e == "string" && /* @__PURE__ */ v(Os, { className: `uil uil-${e}`, iconPosition: t }),
      e && typeof e == "object" && /* @__PURE__ */ v(Es, { iconPosition: t, children: e })
    ] });
  }
), Ls = _.textarea`
  ${Gn}
  resize: vertical;
`, Bd = Et(
  ({ label: n, error: r, rows: e, cols: t, ...o }, s) => {
    const a = Tt(), i = `Input-${a}`, c = `Label-${a}`;
    return /* @__PURE__ */ Q("div", { children: [
      n && /* @__PURE__ */ v(ft, { id: c, htmlFor: i, children: n }),
      /* @__PURE__ */ v(
        Ls,
        {
          ref: s,
          rows: e,
          cols: t,
          id: i,
          "aria-labelledby": c,
          error: r,
          ...o
        }
      )
    ] });
  }
), wo = () => /* @__PURE__ */ v("svg", { width: "8px", height: "8px", viewBox: "0 0 23 15", children: /* @__PURE__ */ v(
  "path",
  {
    d: "M2.30012182,0 L20.7000135,0 C21.970261,0 23,0.915773844 23,2.04543813 C23,2.48801002 22.8385918,2.9186435 22.5400027,3.27270101 L13.3400569,14.1817044 C12.5779084,15.0854358 11.1362738,15.2685906 10.1200758,14.590792 C9.94572379,14.4745001 9.79084251,14.3367602 9.66007851,14.1817044 L0.460132651,3.27270101 C-0.302015818,2.36896958 -0.0960680153,1.0868862 0.920129944,0.409087626 C1.31824879,0.143544495 1.80247326,0 2.30012182,0 Z",
    id: "Rectangle",
    fillRule: "evenodd",
    fill: "#303D4A"
  }
) }), Fs = _.select`
  ${Gn}

  background-color: ${({ theme: n }) => n.colors.white};
  display: inline-block;
  padding-right: 32px;
  appearance: none;
  min-width: 120px;
`, $s = _.span`
  margin-left: -24px;
  pointer-events: none;
`;
function qd({
  label: n,
  placeholder: r,
  items: e,
  valueObjectIndexAccessor: t,
  onChange: o,
  ...s
}) {
  if (e.length > 0 && typeof e[0] == "object" && !t)
    throw new Error("Object requires an valueObjectIndexAccessor!");
  const a = Tt(), i = `Dropdown-${a}`, c = `Label-${a}`;
  return /* @__PURE__ */ Q("div", { children: [
    /* @__PURE__ */ v(ft, { id: c, htmlFor: i, children: n }),
    /* @__PURE__ */ Q(
      Fs,
      {
        onChange: (l) => {
          o(
            t ? e.find(
              (d) => d[t] === l.currentTarget.value
              // We need any here because we can't cast to a keyof T
            ) ?? e[0] : e.find((d) => d === l.currentTarget.value) ?? e[0]
          );
        },
        defaultValue: "",
        "aria-labelledby": c,
        ...s,
        children: [
          r && /* @__PURE__ */ v("option", { value: "", disabled: !0, hidden: !0, "aria-hidden": !0, children: r }),
          e.map((l, d) => {
            const f = t ? l[t] : l;
            return /* @__PURE__ */ v("option", { children: f }, d);
          })
        ]
      }
    ),
    /* @__PURE__ */ v($s, { children: /* @__PURE__ */ v(wo, {}) })
  ] });
}
const As = _.div`
  display: grid;
  grid-template-columns: min-content 1fr;

  ${(n) => n.$label ? `gap: ${R.xs};` : ""}

  // Adjacent sibling combinator to reduce opacity on label when input is disabled
  input:disabled + label {
    opacity: 0.48;
    cursor: auto;
  }

  label {
    cursor: pointer;
  }
`, Ws = _.input`
  cursor: pointer;
  appearance: none;
  /* For iOS < 15 to remove gradient background */
  background-color: #fff;
  /* Not removed via appearance */
  margin: 0;

  width: 24px;
  height: 24px;
  border: 1px solid ${({ theme: n }) => ze(n.colors.grey)};
  border-radius: 4px;

  display: grid;
  outline: none;

  &::before {
    content: '';
    width: 24px;
    height: 24px;
    display: none;
    background-color: ${({ theme: n }) => n.colors.primary};

    // This is a SVG path from unicons and it will currently not scale.
    // To make it scalable we can load the svg as an external resource.
    // Including the svg in a .tsx file doesn't work because we apply the
    // icon on a CSS pseudo
    clip-path: path(
      'M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z'
    );
    justify-self: center;
  }

  &:checked::before {
    display: block;
  }

  &:disabled {
    opacity: 0.48;
    cursor: auto;
  }

  &:hover,
  &:focus {
    border: 1px solid ${({ theme: n }) => n.colors.primary};
  }
`, Qd = Et(
  ({ name: n, id: r = n, label: e, ...t }, o) => /* @__PURE__ */ Q(As, { $label: !!e, children: [
    /* @__PURE__ */ v(Ws, { type: "checkbox", id: r, name: n, ...t, ref: o }),
    e && /* @__PURE__ */ v(ft, { htmlFor: r, children: e })
  ] })
), Hs = _.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  ${({ $label: n }) => n ? `gap: ${R.xs};` : ""}
  // Adjacent sibling combinator to reduce opacity on label when input is disabled
  input:disabled + label {
    opacity: 0.48;
    cursor: auto;
  }

  label {
    cursor: pointer;
  }
`, js = _.input`
  cursor: pointer;
  appearance: none;
  /* For iOS < 15 to remove gradient background */
  background-color: #fff;
  /* Not removed via appearance */
  margin: 0;

  width: ${({ radioSize: n }) => R[n ?? "gutter"]};
  height: ${({ radioSize: n }) => R[n ?? "gutter"]};
  border: 1px solid ${({ theme: n }) => ze(n.colors.grey)}; //#405163;
  border-radius: 50%;
  display: grid;
  place-items: center;

  &::before {
    content: '';
    width: ${({ radioSize: n }) => `calc(${R[n ?? "gutter"]} / 2)`};
    height: ${({ radioSize: n }) => `calc(${R[n ?? "gutter"]} / 2)`};
    display: none;
    border-radius: 50%;
    background-color: ${({ theme: n }) => n.colors.primary}; //#049bf2;
  }

  &:checked::before {
    display: block;
  }

  &:disabled {
    opacity: 0.48;
    cursor: auto;
  }

  &:hover,
  &:focus {
    border: 2px solid ${({ theme: n }) => n.colors.primary};
  }
`, Bs = Et(({ id: n, label: r, ...e }, t) => /* @__PURE__ */ Q(Hs, { $label: !!r, children: [
  /* @__PURE__ */ v(js, { type: "radio", id: n, ...e, ref: t }),
  r && /* @__PURE__ */ v(ft, { htmlFor: n, children: r })
] }));
var Yn = {}, qs = {
  get exports() {
    return Yn;
  },
  set exports(n) {
    Yn = n;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var r = {}.hasOwnProperty;
    function e() {
      for (var t = [], o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        if (s) {
          var a = typeof s;
          if (a === "string" || a === "number")
            t.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var i = e.apply(null, s);
              i && t.push(i);
            }
          } else if (a === "object") {
            if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]")) {
              t.push(s.toString());
              continue;
            }
            for (var c in s)
              r.call(s, c) && s[c] && t.push(c);
          }
        }
      }
      return t.join(" ");
    }
    n.exports ? (e.default = e, n.exports = e) : window.classNames = e;
  })();
})(qs);
const J = Yn, Qs = _.label`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;

  border: ${({ theme: n }) => `1px solid ${ho(n.colors.grey)}`};
  border-radius: 4px;
  color: ${({ theme: n }) => n.colors.grey};

  &.disabled {
    opacity: 0.48;
    cursor: auto;
  }

  &.checked {
    border: ${({ theme: n }) => `1px solid ${n.colors.primary}`};
  }
`, Ks = _(fe)`
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  column-gap: ${R.xs};
  flex-grow: 1;
`, Kd = Et(
  ({ name: n, children: r, p: e = "m", checked: t = !1, disabled: o = !1, id: s, footer: a, ...i }, c) => /* @__PURE__ */ Q(Qs, { className: J(t && "checked", o && "disabled"), htmlFor: s, children: [
    /* @__PURE__ */ Q(Ks, { p: e, children: [
      /* @__PURE__ */ v(fe, { children: /* @__PURE__ */ v(Bs, { name: n, ref: c, ...i, disabled: o, checked: t, id: s }) }),
      /* @__PURE__ */ v(fe, { children: r })
    ] }),
    a && /* @__PURE__ */ v(wt, { children: a })
  ] })
), zs = (n) => /* @__PURE__ */ v(wa.DropdownIndicator, { ...n, children: /* @__PURE__ */ v(wo, {}) }), Vs = {
  control: (n, r) => ({
    ...n,
    boxShadow: (r.isFocused, "none"),
    borderColor: r.isFocused ? He.colors.primary : pe(He.colors.grey),
    "&:hover": {
      borderColor: r.isFocused ? He.colors.primary : Un(He.colors.grey)
    },
    "&:active": {
      borderColor: He.colors.primary,
      outline: "none"
    },
    "&:focus": {
      borderColor: He.colors.primary,
      outline: "none"
    },
    borderRadius: "4px",
    width: "100%",
    maxWidth: "640px",
    opacity: r.isDisabled ? 0.4 : 1,
    transition: "opacity 300ms"
  }),
  indicatorSeparator: () => ({
    background: "none"
  }),
  dropdownIndicator: () => ({
    paddingRight: "16px"
  }),
  menu: (n) => ({
    ...n,
    width: "100%",
    maxWidth: "640px"
  })
};
function zd({
  label: n,
  placeholder: r,
  items: e,
  defaultItem: t,
  valueObjectIndexAccessor: o,
  onChange: s,
  disabled: a,
  styles: i,
  ...c
}) {
  if (e.length > 0 && typeof e[0] == "object" && !o)
    throw new Error("Object requires an valueObjectIndexAccessor!");
  const l = Tt(), d = `Combobox-${l}`, f = `Label-${l}`, g = e.map((b) => ({
    value: b,
    label: o ? b[o] : b
  })), h = t ? {
    value: t,
    label: o ? t == null ? void 0 : t[o] : t
  } : void 0;
  return /* @__PURE__ */ Q("div", { children: [
    /* @__PURE__ */ v(ft, { id: f, htmlFor: d, children: n }),
    /* @__PURE__ */ v(
      ba,
      {
        options: g,
        onChange: (b) => {
          s(b == null ? void 0 : b.value);
        },
        "aria-labelledby": f,
        defaultValue: h,
        placeholder: r,
        components: { DropdownIndicator: zs },
        styles: i ?? Vs,
        isDisabled: a,
        ...c
      }
    )
  ] });
}
const Us = (n, r) => n ? ce`
      background: ${({ theme: e }) => _e(e.colors.success)};
      opacity: ${r ? "48%" : "100%"};

      &:active {
        background: ${({ theme: e }) => ze(e.colors.success)};
      }

      &:hover {
        background: ${({ theme: e }) => pe(e.colors.success)};
      }
    ` : ce`
    background: ${({ theme: e }) => pe(e.colors.grey)};
    opacity: ${r ? "48%" : "100%"};

    &:active {
      background: ${({ theme: e }) => Un(e.colors.grey)};
    }

    &:hover {
      background: ${({ theme: e }) => ze(e.colors.grey)};
    }
  `, Gs = _.div`
  border-radius: 12px;
  height: 20px;
  width: 40px;
  border: 2px solid transparent;
  ${({ toggled: n, disabled: r }) => Us(n, r)};
  pointer-events: ${({ disabled: n }) => n && "none"};
  position: relative;
  transition: background-color 250ms ${({ theme: n }) => n.bezierCurve},
    border-color 250ms ${({ theme: n }) => n.bezierCurve};

  &:focus {
    border: 2px solid ${({ theme: n }) => n.colors.black};
    height: 20px;
    width: 40px;
    border-color: ${({ theme: n }) => pe(n.colors.grey)} !important;
    outline: none !important;
  }

  input {
    visibility: hidden;
  }
`, Xs = _.div`
  position: absolute;
  z-index: 500;
  margin: 2px;
  height: 16px;
  width: 16px;
  border-radius: 50px;
  background: white;
  transition: transform 250ms ${({ theme: n }) => n.bezierCurve};

  transform: ${({ toggled: n }) => n && "translateX(20px)"};
`, Vd = ({ label: n, disabled: r, toggled: e, onChange: t, ...o }) => {
  const s = Tt(), a = `Toggle-${s}`, i = `Label-${s}`;
  return /* @__PURE__ */ Q(wt, { children: [
    /* @__PURE__ */ v("label", { htmlFor: a, id: i, children: n }),
    /* @__PURE__ */ Q(
      Gs,
      {
        role: "switch",
        tabIndex: 0,
        disabled: r ?? !1,
        onKeyPress: (c) => c.key === "Enter" ? t(!e) : void 0,
        onClick: () => t(!e),
        toggled: e,
        ...o,
        children: [
          /* @__PURE__ */ v(Xs, { toggled: e }),
          /* @__PURE__ */ v(fe, { children: /* @__PURE__ */ v(
            "input",
            {
              readOnly: !0,
              "aria-labelledby": i,
              id: a,
              checked: e,
              type: "checkbox"
            }
          ) })
        ]
      }
    )
  ] });
}, Zs = ce`
  color: ${({ theme: n, active: r }) => r ? n.colors.primary : n.colors.black};

  ${({ theme: n, active: r }) => r && `
    :hover {
      color: ${n.colors.primary} ;
    }
    `}

  white-space: pre;
  ${({ theme: n }) => n.fonts.l};
  font-weight: 600;
  margin-right: 12px;

  ${({ theme: n, active: r }) => r && `
  border-bottom: 3px solid ${n.colors.primary};
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
  `}
  :focus {
    outline: none;
  }
`, Js = _(go)`
  ${Zs}
`, ei = ({
  title: n,
  active: r,
  setActiveTabIndex: e,
  index: t,
  onClick: o
}) => {
  const s = fa(() => {
    e(t), o && o();
  }, [e, t, o]);
  return /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v(
    Js,
    {
      variant: "text",
      active: r,
      onClick: s,
      "data-testid": `tab-${t}`,
      logLabel: `tab-${t}`,
      children: n
    }
  ) });
}, ti = _.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
`, Ud = ({ children: n }) => {
  const [r, e] = oo(0), t = m.Children.map(n, (o) => m.isValidElement(o) ? m.cloneElement(o, { title: o.props.title }) : o);
  return /* @__PURE__ */ Q(bo, { spacing: "gutter", "data-testid": "tabs", children: [
    /* @__PURE__ */ v(ti, { children: t.map((o, s) => /* @__PURE__ */ v(
      ei,
      {
        "data-testid": `tab-${s}`,
        active: r === s,
        title: o.props.title,
        index: s,
        setActiveTabIndex: e,
        onClick: o.props.onClick
      },
      s
    )) }),
    n[r]
  ] });
}, Gd = ({ children: n }) => /* @__PURE__ */ v("div", { children: n }), ni = _.nav`
  margin-bottom: 30;
  display: flex;
`, ri = _(da)`
  white-space: pre;
  ${({ theme: n }) => n.fonts.l};
  font-weight: 600;
  margin-right: 12px;
  color: ${({ theme: n }) => n.colors.black};
  text-decoration: none;

  &:hover {
    color: ${({ theme: n }) => n.colors.primary};
  }

  &:focus {
    outline: none;
  }

  &.active {
    border-bottom: 3px solid ${({ theme: n }) => n.colors.primary};
    border-bottom-right-radius: 1px;
    border-bottom-left-radius: 1px;
    color: ${({ theme: n }) => n.colors.primary};
  }
`, Xd = ({ items: n }) => /* @__PURE__ */ v(ni, { children: n.map((r, e) => /* @__PURE__ */ v("li", { style: { listStyle: "none" }, children: /* @__PURE__ */ v(ri, { to: r.path, end: !0, children: r.label }) }, e)) });
function Ve(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function S(n) {
  const r = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && r === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || r === "[object Number]" || typeof n == "string" || r === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function xt(n) {
  if (!Ve(n) && typeof n != "number")
    return !1;
  const r = S(n);
  return !isNaN(Number(r));
}
const oi = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ai = (n, r, e) => {
  let t;
  const o = oi[n];
  return typeof o == "string" ? t = o : r === 1 ? t = o.one : t = o.other.replace("{{count}}", r.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + t : t + " ago" : t;
};
function bn(n) {
  return (r = {}) => {
    const e = r.width ? String(r.width) : n.defaultWidth;
    return n.formats[e] || n.formats[n.defaultWidth];
  };
}
const si = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ii = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ci = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, li = {
  date: bn({
    formats: si,
    defaultWidth: "full"
  }),
  time: bn({
    formats: ii,
    defaultWidth: "full"
  }),
  dateTime: bn({
    formats: ci,
    defaultWidth: "full"
  })
}, ui = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, di = (n, r, e, t) => ui[n];
function ht(n) {
  return (r, e) => {
    const t = e != null && e.context ? String(e.context) : "standalone";
    let o;
    if (t === "formatting" && n.formattingValues) {
      const a = n.defaultFormattingWidth || n.defaultWidth, i = e != null && e.width ? String(e.width) : a;
      o = n.formattingValues[i] || n.formattingValues[a];
    } else {
      const a = n.defaultWidth, i = e != null && e.width ? String(e.width) : n.defaultWidth;
      o = n.values[i] || n.values[a];
    }
    const s = n.argumentCallback ? n.argumentCallback(r) : r;
    return o[s];
  };
}
const pi = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fi = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, hi = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, mi = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, gi = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, yi = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bi = (n, r) => {
  const e = Number(n), t = e % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, wi = {
  ordinalNumber: bi,
  era: ht({
    values: pi,
    defaultWidth: "wide"
  }),
  quarter: ht({
    values: fi,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: ht({
    values: hi,
    defaultWidth: "wide"
  }),
  day: ht({
    values: mi,
    defaultWidth: "wide"
  }),
  dayPeriod: ht({
    values: gi,
    defaultWidth: "wide",
    formattingValues: yi,
    defaultFormattingWidth: "wide"
  })
};
function mt(n) {
  return (r, e = {}) => {
    const t = e.width, o = t && n.matchPatterns[t] || n.matchPatterns[n.defaultMatchWidth], s = r.match(o);
    if (!s)
      return null;
    const a = s[0], i = t && n.parsePatterns[t] || n.parsePatterns[n.defaultParseWidth], c = Array.isArray(i) ? ki(i, (f) => f.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      vi(i, (f) => f.test(a))
    );
    let l;
    l = n.valueCallback ? n.valueCallback(c) : c, l = e.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      e.valueCallback(l)
    ) : l;
    const d = r.slice(a.length);
    return { value: l, rest: d };
  };
}
function vi(n, r) {
  for (const e in n)
    if (Object.prototype.hasOwnProperty.call(n, e) && r(n[e]))
      return e;
}
function ki(n, r) {
  for (let e = 0; e < n.length; e++)
    if (r(n[e]))
      return e;
}
function Di(n) {
  return (r, e = {}) => {
    const t = r.match(n.matchPattern);
    if (!t)
      return null;
    const o = t[0], s = r.match(n.parsePattern);
    if (!s)
      return null;
    let a = n.valueCallback ? n.valueCallback(s[0]) : s[0];
    a = e.valueCallback ? e.valueCallback(a) : a;
    const i = r.slice(o.length);
    return { value: a, rest: i };
  };
}
const xi = /^(\d+)(th|st|nd|rd)?/i, Ci = /\d+/i, Si = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Mi = {
  any: [/^b/i, /^(a|c)/i]
}, Pi = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _i = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ei = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Oi = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ti = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ni = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ri = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ii = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Yi = {
  ordinalNumber: Di({
    matchPattern: xi,
    parsePattern: Ci,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: mt({
    matchPatterns: Si,
    defaultMatchWidth: "wide",
    parsePatterns: Mi,
    defaultParseWidth: "any"
  }),
  quarter: mt({
    matchPatterns: Pi,
    defaultMatchWidth: "wide",
    parsePatterns: _i,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: mt({
    matchPatterns: Ei,
    defaultMatchWidth: "wide",
    parsePatterns: Oi,
    defaultParseWidth: "any"
  }),
  day: mt({
    matchPatterns: Ti,
    defaultMatchWidth: "wide",
    parsePatterns: Ni,
    defaultParseWidth: "any"
  }),
  dayPeriod: mt({
    matchPatterns: Ri,
    defaultMatchWidth: "any",
    parsePatterns: Ii,
    defaultParseWidth: "any"
  })
}, vo = {
  code: "en-US",
  formatDistance: ai,
  formatLong: li,
  formatRelative: di,
  localize: wi,
  match: Yi,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Li = {};
function Je() {
  return Li;
}
const ko = 6048e5, Fi = 864e5, on = 6e4, an = 36e5, $i = 1e3;
function De(n) {
  const r = S(n);
  return r.setHours(0, 0, 0, 0), r;
}
function Qt(n) {
  const r = S(n), e = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return e.setUTCFullYear(r.getFullYear()), +n - +e;
}
function Ct(n, r) {
  const e = De(n), t = De(r), o = +e - Qt(e), s = +t - Qt(t);
  return Math.round((o - s) / Fi);
}
function F(n, r) {
  return n instanceof Date ? new n.constructor(r) : new Date(r);
}
function Xn(n) {
  const r = S(n), e = F(n, 0);
  return e.setFullYear(r.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
function Ai(n) {
  const r = S(n);
  return Ct(r, Xn(r)) + 1;
}
function Ee(n, r) {
  var i, c, l, d;
  const e = Je(), t = (r == null ? void 0 : r.weekStartsOn) ?? ((c = (i = r == null ? void 0 : r.locale) == null ? void 0 : i.options) == null ? void 0 : c.weekStartsOn) ?? e.weekStartsOn ?? ((d = (l = e.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = S(n), s = o.getDay(), a = (s < t ? 7 : 0) + s - t;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function it(n) {
  return Ee(n, { weekStartsOn: 1 });
}
function Do(n) {
  const r = S(n), e = r.getFullYear(), t = F(n, 0);
  t.setFullYear(e + 1, 0, 4), t.setHours(0, 0, 0, 0);
  const o = it(t), s = F(n, 0);
  s.setFullYear(e, 0, 4), s.setHours(0, 0, 0, 0);
  const a = it(s);
  return r.getTime() >= o.getTime() ? e + 1 : r.getTime() >= a.getTime() ? e : e - 1;
}
function Wi(n) {
  const r = Do(n), e = F(n, 0);
  return e.setFullYear(r, 0, 4), e.setHours(0, 0, 0, 0), it(e);
}
function Zn(n) {
  const r = S(n), e = +it(r) - +Wi(r);
  return Math.round(e / ko) + 1;
}
function Jn(n, r) {
  var d, f, g, h;
  const e = S(n), t = e.getFullYear(), o = Je(), s = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((f = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = F(n, 0);
  a.setFullYear(t + 1, 0, s), a.setHours(0, 0, 0, 0);
  const i = Ee(a, r), c = F(n, 0);
  c.setFullYear(t, 0, s), c.setHours(0, 0, 0, 0);
  const l = Ee(c, r);
  return e.getTime() >= i.getTime() ? t + 1 : e.getTime() >= l.getTime() ? t : t - 1;
}
function Hi(n, r) {
  var i, c, l, d;
  const e = Je(), t = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((c = (i = r == null ? void 0 : r.locale) == null ? void 0 : i.options) == null ? void 0 : c.firstWeekContainsDate) ?? e.firstWeekContainsDate ?? ((d = (l = e.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = Jn(n, r), s = F(n, 0);
  return s.setFullYear(o, 0, t), s.setHours(0, 0, 0, 0), Ee(s, r);
}
function xo(n, r) {
  const e = S(n), t = +Ee(e, r) - +Hi(e, r);
  return Math.round(t / ko) + 1;
}
function L(n, r) {
  const e = n < 0 ? "-" : "", t = Math.abs(n).toString().padStart(r, "0");
  return e + t;
}
const Te = {
  // Year
  y(n, r) {
    const e = n.getFullYear(), t = e > 0 ? e : 1 - e;
    return L(r === "yy" ? t % 100 : t, r.length);
  },
  // Month
  M(n, r) {
    const e = n.getMonth();
    return r === "M" ? String(e + 1) : L(e + 1, 2);
  },
  // Day of the month
  d(n, r) {
    return L(n.getDate(), r.length);
  },
  // AM or PM
  a(n, r) {
    const e = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, r) {
    return L(n.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(n, r) {
    return L(n.getHours(), r.length);
  },
  // Minute
  m(n, r) {
    return L(n.getMinutes(), r.length);
  },
  // Second
  s(n, r) {
    return L(n.getSeconds(), r.length);
  },
  // Fraction of second
  S(n, r) {
    const e = r.length, t = n.getMilliseconds(), o = Math.trunc(
      t * Math.pow(10, e - 3)
    );
    return L(o, r.length);
  }
}, nt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, mr = {
  // Era
  G: function(n, r, e) {
    const t = n.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return e.era(t, { width: "abbreviated" });
      case "GGGGG":
        return e.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return e.era(t, { width: "wide" });
    }
  },
  // Year
  y: function(n, r, e) {
    if (r === "yo") {
      const t = n.getFullYear(), o = t > 0 ? t : 1 - t;
      return e.ordinalNumber(o, { unit: "year" });
    }
    return Te.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, e, t) {
    const o = Jn(n, t), s = o > 0 ? o : 1 - o;
    if (r === "YY") {
      const a = s % 100;
      return L(a, 2);
    }
    return r === "Yo" ? e.ordinalNumber(s, { unit: "year" }) : L(s, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    const e = Do(n);
    return L(e, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    const e = n.getFullYear();
    return L(e, r.length);
  },
  // Quarter
  Q: function(n, r, e) {
    const t = Math.ceil((n.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(t);
      case "QQ":
        return L(t, 2);
      case "Qo":
        return e.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return e.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return e.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return e.quarter(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, e) {
    const t = Math.ceil((n.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(t);
      case "qq":
        return L(t, 2);
      case "qo":
        return e.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return e.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return e.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return e.quarter(t, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, e) {
    const t = n.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return Te.M(n, r);
      case "Mo":
        return e.ordinalNumber(t + 1, { unit: "month" });
      case "MMM":
        return e.month(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return e.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return e.month(t, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, r, e) {
    const t = n.getMonth();
    switch (r) {
      case "L":
        return String(t + 1);
      case "LL":
        return L(t + 1, 2);
      case "Lo":
        return e.ordinalNumber(t + 1, { unit: "month" });
      case "LLL":
        return e.month(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return e.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return e.month(t, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, r, e, t) {
    const o = xo(n, t);
    return r === "wo" ? e.ordinalNumber(o, { unit: "week" }) : L(o, r.length);
  },
  // ISO week of year
  I: function(n, r, e) {
    const t = Zn(n);
    return r === "Io" ? e.ordinalNumber(t, { unit: "week" }) : L(t, r.length);
  },
  // Day of the month
  d: function(n, r, e) {
    return r === "do" ? e.ordinalNumber(n.getDate(), { unit: "date" }) : Te.d(n, r);
  },
  // Day of year
  D: function(n, r, e) {
    const t = Ai(n);
    return r === "Do" ? e.ordinalNumber(t, { unit: "dayOfYear" }) : L(t, r.length);
  },
  // Day of week
  E: function(n, r, e) {
    const t = n.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return e.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return e.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return e.day(t, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return e.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, e, t) {
    const o = n.getDay(), s = (o - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(s);
      case "ee":
        return L(s, 2);
      case "eo":
        return e.ordinalNumber(s, { unit: "day" });
      case "eee":
        return e.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return e.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return e.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return e.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, e, t) {
    const o = n.getDay(), s = (o - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(s);
      case "cc":
        return L(s, r.length);
      case "co":
        return e.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return e.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return e.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return e.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return e.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, e) {
    const t = n.getDay(), o = t === 0 ? 7 : t;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return L(o, r.length);
      case "io":
        return e.ordinalNumber(o, { unit: "day" });
      case "iii":
        return e.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return e.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return e.day(t, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return e.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, e) {
    const o = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, e) {
    const t = n.getHours();
    let o;
    switch (t === 12 ? o = nt.noon : t === 0 ? o = nt.midnight : o = t / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, e) {
    const t = n.getHours();
    let o;
    switch (t >= 17 ? o = nt.evening : t >= 12 ? o = nt.afternoon : t >= 4 ? o = nt.morning : o = nt.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, e) {
    if (r === "ho") {
      let t = n.getHours() % 12;
      return t === 0 && (t = 12), e.ordinalNumber(t, { unit: "hour" });
    }
    return Te.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, e) {
    return r === "Ho" ? e.ordinalNumber(n.getHours(), { unit: "hour" }) : Te.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, e) {
    const t = n.getHours() % 12;
    return r === "Ko" ? e.ordinalNumber(t, { unit: "hour" }) : L(t, r.length);
  },
  // Hour [1-24]
  k: function(n, r, e) {
    let t = n.getHours();
    return t === 0 && (t = 24), r === "ko" ? e.ordinalNumber(t, { unit: "hour" }) : L(t, r.length);
  },
  // Minute
  m: function(n, r, e) {
    return r === "mo" ? e.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Te.m(n, r);
  },
  // Second
  s: function(n, r, e) {
    return r === "so" ? e.ordinalNumber(n.getSeconds(), { unit: "second" }) : Te.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return Te.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, e) {
    const t = n.getTimezoneOffset();
    if (t === 0)
      return "Z";
    switch (r) {
      case "X":
        return yr(t);
      case "XXXX":
      case "XX":
        return Be(t);
      case "XXXXX":
      case "XXX":
      default:
        return Be(t, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "x":
        return yr(t);
      case "xxxx":
      case "xx":
        return Be(t);
      case "xxxxx":
      case "xxx":
      default:
        return Be(t, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + gr(t, ":");
      case "OOOO":
      default:
        return "GMT" + Be(t, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + gr(t, ":");
      case "zzzz":
      default:
        return "GMT" + Be(t, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, e) {
    const t = Math.trunc(n.getTime() / 1e3);
    return L(t, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, e) {
    const t = n.getTime();
    return L(t, r.length);
  }
};
function gr(n, r = "") {
  const e = n > 0 ? "-" : "+", t = Math.abs(n), o = Math.trunc(t / 60), s = t % 60;
  return s === 0 ? e + String(o) : e + String(o) + r + L(s, 2);
}
function yr(n, r) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + L(Math.abs(n) / 60, 2) : Be(n, r);
}
function Be(n, r = "") {
  const e = n > 0 ? "-" : "+", t = Math.abs(n), o = L(Math.trunc(t / 60), 2), s = L(t % 60, 2);
  return e + o + r + s;
}
const br = (n, r) => {
  switch (n) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, Co = (n, r) => {
  switch (n) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, ji = (n, r) => {
  const e = n.match(/(P+)(p+)?/) || [], t = e[1], o = e[2];
  if (!o)
    return br(n, r);
  let s;
  switch (t) {
    case "P":
      s = r.dateTime({ width: "short" });
      break;
    case "PP":
      s = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = r.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", br(t, r)).replace("{{time}}", Co(o, r));
}, Kt = {
  p: Co,
  P: ji
}, Bi = /^D+$/, qi = /^Y+$/, Qi = ["D", "DD", "YY", "YYYY"];
function So(n) {
  return Bi.test(n);
}
function Mo(n) {
  return qi.test(n);
}
function Ln(n, r, e) {
  const t = Ki(n, r, e);
  if (console.warn(t), Qi.includes(n))
    throw new RangeError(t);
}
function Ki(n, r, e) {
  const t = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${r}\`) for formatting ${t} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const zi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Vi = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ui = /^'([^]*?)'?$/, Gi = /''/g, Xi = /[a-zA-Z]/;
function wr(n, r, e) {
  var d, f, g, h, y, b, C, D;
  const t = Je(), o = (e == null ? void 0 : e.locale) ?? t.locale ?? vo, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((h = (g = t.locale) == null ? void 0 : g.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (e == null ? void 0 : e.weekStartsOn) ?? ((b = (y = e == null ? void 0 : e.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? t.weekStartsOn ?? ((D = (C = t.locale) == null ? void 0 : C.options) == null ? void 0 : D.weekStartsOn) ?? 0, i = S(n);
  if (!xt(i))
    throw new RangeError("Invalid time value");
  let c = r.match(Vi).map((w) => {
    const x = w[0];
    if (x === "p" || x === "P") {
      const E = Kt[x];
      return E(w, o.formatLong);
    }
    return w;
  }).join("").match(zi).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const x = w[0];
    if (x === "'")
      return { isToken: !1, value: Zi(w) };
    if (mr[x])
      return { isToken: !0, value: w };
    if (x.match(Xi))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: w };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(i, c));
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: o
  };
  return c.map((w) => {
    if (!w.isToken)
      return w.value;
    const x = w.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && Mo(x) || !(e != null && e.useAdditionalDayOfYearTokens) && So(x)) && Ln(x, r, String(n));
    const E = mr[x[0]];
    return E(i, x, o.localize, l);
  }).join("");
}
function Zi(n) {
  const r = n.match(Ui);
  return r ? r[1].replace(Gi, "'") : n;
}
function Po(n, r) {
  const e = +S(n);
  return F(n, e + r);
}
function Fn(n, r) {
  return Po(n, r * on);
}
function Ji(n, r) {
  return Po(n, r * an);
}
function We(n, r) {
  const e = S(n);
  return isNaN(r) ? F(n, NaN) : (r && e.setDate(e.getDate() + r), e);
}
function zt(n, r) {
  const e = r * 7;
  return We(n, e);
}
function ye(n, r) {
  const e = S(n);
  if (isNaN(r))
    return F(n, NaN);
  if (!r)
    return e;
  const t = e.getDate(), o = F(n, e.getTime());
  o.setMonth(e.getMonth() + r + 1, 0);
  const s = o.getDate();
  return t >= s ? o : (e.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    t
  ), e);
}
function _o(n, r) {
  const e = r * 3;
  return ye(n, e);
}
function ct(n, r) {
  return ye(n, r * 12);
}
function ec(n, r) {
  return We(n, -r);
}
function vr(n, r) {
  return zt(n, -r);
}
function lt(n, r) {
  return ye(n, -r);
}
function tc(n, r) {
  return _o(n, -r);
}
function St(n, r) {
  return ct(n, -r);
}
function kr(n) {
  return S(n).getSeconds();
}
function xe(n) {
  return S(n).getMinutes();
}
function Ce(n) {
  return S(n).getHours();
}
function nc(n) {
  return S(n).getDay();
}
function Dr(n) {
  return S(n).getDate();
}
function oe(n) {
  return S(n).getMonth();
}
function ot(n) {
  const r = S(n);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function N(n) {
  return S(n).getFullYear();
}
function $n(n) {
  return S(n).getTime();
}
function rc(n, r) {
  const e = S(n);
  return e.setSeconds(r), e;
}
function $t(n, r) {
  const e = S(n);
  return e.setMinutes(r), e;
}
function At(n, r) {
  const e = S(n);
  return e.setHours(r), e;
}
function oc(n) {
  const r = S(n), e = r.getFullYear(), t = r.getMonth(), o = F(n, 0);
  return o.setFullYear(e, t + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function ie(n, r) {
  const e = S(n), t = e.getFullYear(), o = e.getDate(), s = F(n, 0);
  s.setFullYear(t, r, 15), s.setHours(0, 0, 0, 0);
  const a = oc(s);
  return e.setMonth(r, Math.min(o, a)), e;
}
function rt(n, r) {
  const e = S(n), t = Math.trunc(e.getMonth() / 3) + 1, o = r - t;
  return ie(e, e.getMonth() + o * 3);
}
function Me(n, r) {
  const e = S(n);
  return isNaN(+e) ? F(n, NaN) : (e.setFullYear(r), e);
}
function xr(n) {
  let r;
  return n.forEach((e) => {
    const t = S(e);
    (!r || r > t || isNaN(+t)) && (r = t);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Cr(n) {
  let r;
  return n.forEach(function(e) {
    const t = S(e);
    (r === void 0 || r < t || isNaN(Number(t))) && (r = t);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Vt(n, r) {
  const e = S(n), t = S(r), o = e.getFullYear() - t.getFullYear(), s = e.getMonth() - t.getMonth();
  return o * 12 + s;
}
function Ut(n, r) {
  const e = S(n), t = S(r);
  return e.getFullYear() - t.getFullYear();
}
function Eo(n) {
  const r = S(n);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function An(n) {
  const r = S(n), e = r.getMonth(), t = e - e % 3;
  return r.setMonth(t, 1), r.setHours(0, 0, 0, 0), r;
}
function Wn(n) {
  const r = S(n);
  return r.setHours(23, 59, 59, 999), r;
}
function ac(n, r) {
  var i, c, l, d;
  const e = Je(), t = (r == null ? void 0 : r.weekStartsOn) ?? ((c = (i = r == null ? void 0 : r.locale) == null ? void 0 : i.options) == null ? void 0 : c.weekStartsOn) ?? e.weekStartsOn ?? ((d = (l = e.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = S(n), s = o.getDay(), a = (s < t ? -7 : 0) + 6 - (s - t);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function sc(n) {
  const r = S(n), e = r.getMonth();
  return r.setFullYear(r.getFullYear(), e + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function ic(n) {
  const r = S(n), e = r.getFullYear();
  return r.setFullYear(e + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function cc(n, r) {
  const e = S(n), t = S(r);
  return +e == +t;
}
function lc(n, r) {
  const e = De(n), t = De(r);
  return +e == +t;
}
function uc(n, r) {
  const e = S(n), t = S(r);
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
function dc(n, r) {
  const e = S(n), t = S(r);
  return e.getFullYear() === t.getFullYear();
}
function pc(n, r) {
  const e = An(n), t = An(r);
  return +e == +t;
}
function Le(n, r) {
  const e = S(n), t = S(r);
  return e.getTime() > t.getTime();
}
function Ue(n, r) {
  const e = S(n), t = S(r);
  return +e < +t;
}
function Mt(n, r) {
  const e = +S(n), [t, o] = [
    +S(r.start),
    +S(r.end)
  ].sort((s, a) => s - a);
  return e >= t && e <= o;
}
function fc() {
  return Object.assign({}, Je());
}
function hc(n, r) {
  const e = r instanceof Date ? F(r, 0) : new r(0);
  return e.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), e.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), e;
}
const mc = 10;
class Oo {
  constructor() {
    k(this, "subPriority", 0);
  }
  validate(r, e) {
    return !0;
  }
}
class gc extends Oo {
  constructor(r, e, t, o, s) {
    super(), this.value = r, this.validateValue = e, this.setValue = t, this.priority = o, s && (this.subPriority = s);
  }
  validate(r, e) {
    return this.validateValue(r, this.value, e);
  }
  set(r, e, t) {
    return this.setValue(r, e, this.value, t);
  }
}
class yc extends Oo {
  constructor() {
    super(...arguments);
    k(this, "priority", mc);
    k(this, "subPriority", -1);
  }
  set(e, t) {
    return t.timestampIsSet ? e : F(e, hc(e, Date));
  }
}
class Y {
  run(r, e, t, o) {
    const s = this.parse(r, e, t, o);
    return s ? {
      setter: new gc(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(r, e, t) {
    return !0;
  }
}
class bc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 140);
    k(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
      case "GGGGG":
        return o.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(e, { width: "wide" }) || o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
    }
  }
  set(e, t, o) {
    return t.era = o, e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const V = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, we = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function U(n, r) {
  return n && {
    value: r(n.value),
    rest: n.rest
  };
}
function q(n, r) {
  const e = r.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: r.slice(e[0].length)
  } : null;
}
function ve(n, r) {
  const e = r.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const t = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, s = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: t * (o * an + s * on + a * $i),
    rest: r.slice(e[0].length)
  };
}
function To(n) {
  return q(V.anyDigitsSigned, n);
}
function K(n, r) {
  switch (n) {
    case 1:
      return q(V.singleDigit, r);
    case 2:
      return q(V.twoDigits, r);
    case 3:
      return q(V.threeDigits, r);
    case 4:
      return q(V.fourDigits, r);
    default:
      return q(new RegExp("^\\d{1," + n + "}"), r);
  }
}
function Gt(n, r) {
  switch (n) {
    case 1:
      return q(V.singleDigitSigned, r);
    case 2:
      return q(V.twoDigitsSigned, r);
    case 3:
      return q(V.threeDigitsSigned, r);
    case 4:
      return q(V.fourDigitsSigned, r);
    default:
      return q(new RegExp("^-?\\d{1," + n + "}"), r);
  }
}
function er(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function No(n, r) {
  const e = r > 0, t = e ? r : 1 - r;
  let o;
  if (t <= 50)
    o = n || 100;
  else {
    const s = t + 50, a = Math.trunc(s / 100) * 100, i = n >= s % 100;
    o = n + a - (i ? 100 : 0);
  }
  return e ? o : 1 - o;
}
function Ro(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class wc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, o) {
    const s = (a) => ({
      year: a,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return U(K(4, e), s);
      case "yo":
        return U(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          s
        );
      default:
        return U(K(t.length, e), s);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, o) {
    const s = e.getFullYear();
    if (o.isTwoDigitYear) {
      const i = No(
        o.year,
        s
      );
      return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const a = !("era" in t) || t.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(a, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class vc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    const s = (a) => ({
      year: a,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return U(K(4, e), s);
      case "Yo":
        return U(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          s
        );
      default:
        return U(K(t.length, e), s);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, o, s) {
    const a = Jn(e, s);
    if (o.isTwoDigitYear) {
      const c = No(
        o.year,
        a
      );
      return e.setFullYear(
        c,
        0,
        s.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Ee(e, s);
    }
    const i = !("era" in t) || t.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(i, 0, s.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Ee(e, s);
  }
}
class kc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t) {
    return Gt(t === "R" ? 4 : t.length, e);
  }
  set(e, t, o) {
    const s = F(e, 0);
    return s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0), it(s);
  }
}
class Dc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t) {
    return Gt(t === "u" ? 4 : t.length, e);
  }
  set(e, t, o) {
    return e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class xc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 120);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "Q":
      case "QQ":
        return K(t.length, e);
      case "Qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Cc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 120);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "q":
      case "qq":
        return K(t.length, e);
      case "qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Sc extends Y {
  constructor() {
    super(...arguments);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    k(this, "priority", 110);
  }
  parse(e, t, o) {
    const s = (a) => a - 1;
    switch (t) {
      case "M":
        return U(
          q(V.month, e),
          s
        );
      case "MM":
        return U(K(2, e), s);
      case "Mo":
        return U(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          s
        );
      case "MMM":
        return o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(e, { width: "wide", context: "formatting" }) || o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Mc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 110);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    const s = (a) => a - 1;
    switch (t) {
      case "L":
        return U(
          q(V.month, e),
          s
        );
      case "LL":
        return U(K(2, e), s);
      case "Lo":
        return U(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          s
        );
      case "LLL":
        return o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(e, { width: "wide", context: "standalone" }) || o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Pc(n, r, e) {
  const t = S(n), o = xo(t, e) - r;
  return t.setDate(t.getDate() - o * 7), t;
}
class _c extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 100);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "w":
        return q(V.week, e);
      case "wo":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, o, s) {
    return Ee(Pc(e, o, s), s);
  }
}
function Ec(n, r) {
  const e = S(n), t = Zn(e) - r;
  return e.setDate(e.getDate() - t * 7), e;
}
class Oc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 100);
    k(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "I":
        return q(V.week, e);
      case "Io":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, o) {
    return it(Ec(e, o));
  }
}
const Tc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Nc = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Rc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "subPriority", 1);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "d":
        return q(V.date, e);
      case "do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    const o = e.getFullYear(), s = Ro(o), a = e.getMonth();
    return s ? t >= 1 && t <= Nc[a] : t >= 1 && t <= Tc[a];
  }
  set(e, t, o) {
    return e.setDate(o), e.setHours(0, 0, 0, 0), e;
  }
}
class Ic extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "subpriority", 1);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    switch (t) {
      case "D":
      case "DD":
        return q(V.dayOfYear, e);
      case "Do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    const o = e.getFullYear();
    return Ro(o) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(e, t, o) {
    return e.setMonth(0, o), e.setHours(0, 0, 0, 0), e;
  }
}
function tr(n, r, e) {
  var f, g, h, y;
  const t = Je(), o = (e == null ? void 0 : e.weekStartsOn) ?? ((g = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : g.weekStartsOn) ?? t.weekStartsOn ?? ((y = (h = t.locale) == null ? void 0 : h.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = S(n), a = s.getDay(), c = (r % 7 + 7) % 7, l = 7 - o, d = r < 0 || r > 6 ? r - (a + l) % 7 : (c + l) % 7 - (a + l) % 7;
  return We(s, d);
}
class Yc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, o, s) {
    return e = tr(e, o, s), e.setHours(0, 0, 0, 0), e;
  }
}
class Lc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o, s) {
    const a = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + s.weekStartsOn + 6) % 7 + c;
    };
    switch (t) {
      case "e":
      case "ee":
        return U(K(t.length, e), a);
      case "eo":
        return U(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, o, s) {
    return e = tr(e, o, s), e.setHours(0, 0, 0, 0), e;
  }
}
class Fc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, t, o, s) {
    const a = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + s.weekStartsOn + 6) % 7 + c;
    };
    switch (t) {
      case "c":
      case "cc":
        return U(K(t.length, e), a);
      case "co":
        return U(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(e, { width: "wide", context: "standalone" }) || o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, o, s) {
    return e = tr(e, o, s), e.setHours(0, 0, 0, 0), e;
  }
}
function $c(n) {
  let e = S(n).getDay();
  return e === 0 && (e = 7), e;
}
function Ac(n, r) {
  const e = S(n), t = $c(e), o = r - t;
  return We(e, o);
}
class Wc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, o) {
    const s = (a) => a === 0 ? 7 : a;
    switch (t) {
      case "i":
      case "ii":
        return K(t.length, e);
      case "io":
        return o.ordinalNumber(e, { unit: "day" });
      case "iii":
        return U(
          o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiii":
        return U(
          o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiiii":
        return U(
          o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiii":
      default:
        return U(
          o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 7;
  }
  set(e, t, o) {
    return e = Ac(e, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Hc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, o) {
    return e.setHours(er(o), 0, 0, 0), e;
  }
}
class jc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, o) {
    return e.setHours(er(o), 0, 0, 0), e;
  }
}
class Bc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, o) {
    return e.setHours(er(o), 0, 0, 0), e;
  }
}
class qc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "h":
        return q(V.hour12h, e);
      case "ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 12;
  }
  set(e, t, o) {
    const s = e.getHours() >= 12;
    return s && o < 12 ? e.setHours(o + 12, 0, 0, 0) : !s && o === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
}
class Qc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "H":
        return q(V.hour23h, e);
      case "Ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 23;
  }
  set(e, t, o) {
    return e.setHours(o, 0, 0, 0), e;
  }
}
class Kc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "K":
        return q(V.hour11h, e);
      case "Ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, o) {
    return e.getHours() >= 12 && o < 12 ? e.setHours(o + 12, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
}
class zc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "k":
        return q(V.hour24h, e);
      case "ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 24;
  }
  set(e, t, o) {
    const s = o <= 24 ? o % 24 : o;
    return e.setHours(s, 0, 0, 0), e;
  }
}
class Vc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 60);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "m":
        return q(V.minute, e);
      case "mo":
        return o.ordinalNumber(e, { unit: "minute" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, o) {
    return e.setMinutes(o, 0, 0), e;
  }
}
class Uc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 50);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, o) {
    switch (t) {
      case "s":
        return q(V.second, e);
      case "so":
        return o.ordinalNumber(e, { unit: "second" });
      default:
        return K(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, o) {
    return e.setSeconds(o, 0), e;
  }
}
class Gc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 30);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t) {
    const o = (s) => Math.trunc(s * Math.pow(10, -t.length + 3));
    return U(K(t.length, e), o);
  }
  set(e, t, o) {
    return e.setMilliseconds(o), e;
  }
}
class Xc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 10);
    k(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, t) {
    switch (t) {
      case "X":
        return ve(
          we.basicOptionalMinutes,
          e
        );
      case "XX":
        return ve(we.basic, e);
      case "XXXX":
        return ve(
          we.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return ve(
          we.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return ve(we.extended, e);
    }
  }
  set(e, t, o) {
    return t.timestampIsSet ? e : F(
      e,
      e.getTime() - Qt(e) - o
    );
  }
}
class Zc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 10);
    k(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, t) {
    switch (t) {
      case "x":
        return ve(
          we.basicOptionalMinutes,
          e
        );
      case "xx":
        return ve(we.basic, e);
      case "xxxx":
        return ve(
          we.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return ve(
          we.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return ve(we.extended, e);
    }
  }
  set(e, t, o) {
    return t.timestampIsSet ? e : F(
      e,
      e.getTime() - Qt(e) - o
    );
  }
}
class Jc extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 40);
    k(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return To(e);
  }
  set(e, t, o) {
    return [F(e, o * 1e3), { timestampIsSet: !0 }];
  }
}
class el extends Y {
  constructor() {
    super(...arguments);
    k(this, "priority", 20);
    k(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return To(e);
  }
  set(e, t, o) {
    return [F(e, o), { timestampIsSet: !0 }];
  }
}
const tl = {
  G: new bc(),
  y: new wc(),
  Y: new vc(),
  R: new kc(),
  u: new Dc(),
  Q: new xc(),
  q: new Cc(),
  M: new Sc(),
  L: new Mc(),
  w: new _c(),
  I: new Oc(),
  d: new Rc(),
  D: new Ic(),
  E: new Yc(),
  e: new Lc(),
  c: new Fc(),
  i: new Wc(),
  a: new Hc(),
  b: new jc(),
  B: new Bc(),
  h: new qc(),
  H: new Qc(),
  K: new Kc(),
  k: new zc(),
  m: new Vc(),
  s: new Uc(),
  S: new Gc(),
  X: new Xc(),
  x: new Zc(),
  t: new Jc(),
  T: new el()
}, nl = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, rl = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ol = /^'([^]*?)'?$/, al = /''/g, sl = /\S/, il = /[a-zA-Z]/;
function wn(n, r, e, t) {
  var b, C, D, w, x, E, O, I;
  const o = fc(), s = (t == null ? void 0 : t.locale) ?? o.locale ?? vo, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((C = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : C.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((w = (D = o.locale) == null ? void 0 : D.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((E = (x = t == null ? void 0 : t.locale) == null ? void 0 : x.options) == null ? void 0 : E.weekStartsOn) ?? o.weekStartsOn ?? ((I = (O = o.locale) == null ? void 0 : O.options) == null ? void 0 : I.weekStartsOn) ?? 0;
  if (r === "")
    return n === "" ? S(e) : F(e, NaN);
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: s
  }, l = [new yc()], d = r.match(rl).map((M) => {
    const P = M[0];
    if (P in Kt) {
      const $ = Kt[P];
      return $(M, s.formatLong);
    }
    return M;
  }).join("").match(nl), f = [];
  for (let M of d) {
    !(t != null && t.useAdditionalWeekYearTokens) && Mo(M) && Ln(M, r, n), !(t != null && t.useAdditionalDayOfYearTokens) && So(M) && Ln(M, r, n);
    const P = M[0], $ = tl[P];
    if ($) {
      const { incompatibleTokens: G } = $;
      if (Array.isArray(G)) {
        const B = f.find(
          (se) => G.includes(se.token) || se.token === P
        );
        if (B)
          throw new RangeError(
            `The format string mustn't contain \`${B.fullToken}\` and \`${M}\` at the same time`
          );
      } else if ($.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${M}\` and any other token at the same time`
        );
      f.push({ token: P, fullToken: M });
      const ae = $.run(
        n,
        M,
        s.match,
        c
      );
      if (!ae)
        return F(e, NaN);
      l.push(ae.setter), n = ae.rest;
    } else {
      if (P.match(il))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (M === "''" ? M = "'" : P === "'" && (M = cl(M)), n.indexOf(M) === 0)
        n = n.slice(M.length);
      else
        return F(e, NaN);
    }
  }
  if (n.length > 0 && sl.test(n))
    return F(e, NaN);
  const g = l.map((M) => M.priority).sort((M, P) => P - M).filter((M, P, $) => $.indexOf(M) === P).map(
    (M) => l.filter((P) => P.priority === M).sort((P, $) => $.subPriority - P.subPriority)
  ).map((M) => M[0]);
  let h = S(e);
  if (isNaN(h.getTime()))
    return F(e, NaN);
  const y = {};
  for (const M of g) {
    if (!M.validate(h, c))
      return F(e, NaN);
    const P = M.set(h, y, c);
    Array.isArray(P) ? (h = P[0], Object.assign(y, P[1])) : h = P;
  }
  return F(e, h);
}
function cl(n) {
  return n.match(ol)[1].replace(al, "'");
}
function ll(n, r) {
  const e = (r == null ? void 0 : r.additionalDigits) ?? 2, t = fl(n);
  let o;
  if (t.date) {
    const c = hl(t.date, e);
    o = ml(c.restDateString, c.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const s = o.getTime();
  let a = 0, i;
  if (t.time && (a = gl(t.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (t.timezone) {
    if (i = yl(t.timezone), isNaN(i))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const c = new Date(s + a), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return new Date(s + a + i);
}
const It = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, ul = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, dl = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, pl = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function fl(n) {
  const r = {}, e = n.split(It.dateTimeDelimiter);
  let t;
  if (e.length > 2)
    return r;
  if (/:/.test(e[0]) ? t = e[0] : (r.date = e[0], t = e[1], It.timeZoneDelimiter.test(r.date) && (r.date = n.split(It.timeZoneDelimiter)[0], t = n.substr(
    r.date.length,
    n.length
  ))), t) {
    const o = It.timezone.exec(t);
    o ? (r.time = t.replace(o[1], ""), r.timezone = o[1]) : r.time = t;
  }
  return r;
}
function hl(n, r) {
  const e = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), t = n.match(e);
  if (!t)
    return { year: NaN, restDateString: "" };
  const o = t[1] ? parseInt(t[1]) : null, s = t[2] ? parseInt(t[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: n.slice((t[1] || t[2]).length)
  };
}
function ml(n, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  const e = n.match(ul);
  if (!e)
    return /* @__PURE__ */ new Date(NaN);
  const t = !!e[4], o = gt(e[1]), s = gt(e[2]) - 1, a = gt(e[3]), i = gt(e[4]), c = gt(e[5]) - 1;
  if (t)
    return Dl(r, i, c) ? bl(r, i, c) : /* @__PURE__ */ new Date(NaN);
  {
    const l = /* @__PURE__ */ new Date(0);
    return !vl(r, s, a) || !kl(r, o) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(r, s, Math.max(o, a)), l);
  }
}
function gt(n) {
  return n ? parseInt(n) : 1;
}
function gl(n) {
  const r = n.match(dl);
  if (!r)
    return NaN;
  const e = vn(r[1]), t = vn(r[2]), o = vn(r[3]);
  return xl(e, t, o) ? e * an + t * on + o * 1e3 : NaN;
}
function vn(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function yl(n) {
  if (n === "Z")
    return 0;
  const r = n.match(pl);
  if (!r)
    return 0;
  const e = r[1] === "+" ? -1 : 1, t = parseInt(r[2]), o = r[3] && parseInt(r[3]) || 0;
  return Cl(t, o) ? e * (t * an + o * on) : NaN;
}
function bl(n, r, e) {
  const t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(n, 0, 4);
  const o = t.getUTCDay() || 7, s = (r - 1) * 7 + e + 1 - o;
  return t.setUTCDate(t.getUTCDate() + s), t;
}
const wl = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Io(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function vl(n, r, e) {
  return r >= 0 && r <= 11 && e >= 1 && e <= (wl[r] || (Io(n) ? 29 : 28));
}
function kl(n, r) {
  return r >= 1 && r <= (Io(n) ? 366 : 365);
}
function Dl(n, r, e) {
  return r >= 1 && r <= 53 && e >= 0 && e <= 6;
}
function xl(n, r, e) {
  return n === 24 ? r === 0 && e === 0 : e >= 0 && e < 60 && r >= 0 && r < 60 && n >= 0 && n < 25;
}
function Cl(n, r) {
  return r >= 0 && r <= 59;
}
function Sl(n, r) {
  n.prototype = Object.create(r.prototype), n.prototype.constructor = n, Hn(n, r);
}
function Hn(n, r) {
  return Hn = Object.setPrototypeOf || function(t, o) {
    return t.__proto__ = o, t;
  }, Hn(n, r);
}
function Ml(n, r) {
  if (n == null)
    return {};
  var e = {}, t = Object.keys(n), o, s;
  for (s = 0; s < t.length; s++)
    o = t[s], !(r.indexOf(o) >= 0) && (e[o] = n[o]);
  return e;
}
function Sr(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Pl(n, r, e) {
  return n === r ? !0 : n.correspondingElement ? n.correspondingElement.classList.contains(e) : n.classList.contains(e);
}
function _l(n, r, e) {
  if (n === r)
    return !0;
  for (; n.parentNode || n.host; ) {
    if (n.parentNode && Pl(n, r, e))
      return !0;
    n = n.parentNode || n.host;
  }
  return n;
}
function El(n) {
  return document.documentElement.clientWidth <= n.clientX || document.documentElement.clientHeight <= n.clientY;
}
var Ol = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var r = !1, e = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), t = function() {
    };
    return window.addEventListener("testPassiveEventSupport", t, e), window.removeEventListener("testPassiveEventSupport", t, e), r;
  }
};
function Tl(n) {
  return n === void 0 && (n = 0), function() {
    return ++n;
  };
}
var Nl = Tl(), jn, Yt = {}, kn = {}, Rl = ["touchstart", "touchmove"], Il = "ignore-react-onclickoutside";
function Mr(n, r) {
  var e = {}, t = Rl.indexOf(r) !== -1;
  return t && jn && (e.passive = !n.props.preventDefault), e;
}
function sn(n, r) {
  var e, t, o = n.displayName || n.name || "Component";
  return t = e = /* @__PURE__ */ function(s) {
    Sl(a, s);
    function a(c) {
      var l;
      return l = s.call(this, c) || this, l.__outsideClickHandler = function(d) {
        if (typeof l.__clickOutsideHandlerProp == "function") {
          l.__clickOutsideHandlerProp(d);
          return;
        }
        var f = l.getInstance();
        if (typeof f.props.handleClickOutside == "function") {
          f.props.handleClickOutside(d);
          return;
        }
        if (typeof f.handleClickOutside == "function") {
          f.handleClickOutside(d);
          return;
        }
        throw new Error("WrappedComponent: " + o + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, l.__getComponentNode = function() {
        var d = l.getInstance();
        return r && typeof r.setClickOutsideRef == "function" ? r.setClickOutsideRef()(d) : typeof d.setClickOutsideRef == "function" ? d.setClickOutsideRef() : Da(d);
      }, l.enableOnClickOutside = function() {
        if (!(typeof document > "u" || kn[l._uid])) {
          typeof jn > "u" && (jn = Ol()), kn[l._uid] = !0;
          var d = l.props.eventTypes;
          d.forEach || (d = [d]), Yt[l._uid] = function(f) {
            if (l.componentNode !== null && (l.props.preventDefault && f.preventDefault(), l.props.stopPropagation && f.stopPropagation(), !(l.props.excludeScrollbar && El(f)))) {
              var g = f.composed && f.composedPath && f.composedPath().shift() || f.target;
              _l(g, l.componentNode, l.props.outsideClickIgnoreClass) === document && l.__outsideClickHandler(f);
            }
          }, d.forEach(function(f) {
            document.addEventListener(f, Yt[l._uid], Mr(Sr(l), f));
          });
        }
      }, l.disableOnClickOutside = function() {
        delete kn[l._uid];
        var d = Yt[l._uid];
        if (d && typeof document < "u") {
          var f = l.props.eventTypes;
          f.forEach || (f = [f]), f.forEach(function(g) {
            return document.removeEventListener(g, d, Mr(Sr(l), g));
          }), delete Yt[l._uid];
        }
      }, l.getRef = function(d) {
        return l.instanceRef = d;
      }, l._uid = Nl(), l;
    }
    var i = a.prototype;
    return i.getInstance = function() {
      if (n.prototype && !n.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, i.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var l = this.getInstance();
        if (r && typeof r.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = r.handleClickOutside(l), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + o + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, i.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, i.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, i.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var d = Ml(l, ["excludeScrollbar"]);
      return n.prototype && n.prototype.isReactComponent ? d.ref = this.getRef : d.wrappedRef = this.getRef, d.disableOnClickOutside = this.disableOnClickOutside, d.enableOnClickOutside = this.enableOnClickOutside, ha(n, d);
    }, a;
  }(ma), e.displayName = "OnClickOutside(" + o + ")", e.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: r && r.excludeScrollbar || !1,
    outsideClickIgnoreClass: Il,
    preventDefault: !1,
    stopPropagation: !1
  }, e.getClass = function() {
    return n.getClass ? n.getClass() : n;
  }, t;
}
function Fe(n) {
  return Yo(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function de(n) {
  var r;
  return (n == null || (r = n.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Oe(n) {
  var r;
  return (r = (Yo(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : r.documentElement;
}
function Yo(n) {
  return n instanceof Node || n instanceof de(n).Node;
}
function le(n) {
  return n instanceof Element || n instanceof de(n).Element;
}
function Se(n) {
  return n instanceof HTMLElement || n instanceof de(n).HTMLElement;
}
function Pr(n) {
  return typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof de(n).ShadowRoot;
}
function Nt(n) {
  const {
    overflow: r,
    overflowX: e,
    overflowY: t,
    display: o
  } = he(n);
  return /auto|scroll|overlay|hidden|clip/.test(r + t + e) && !["inline", "contents"].includes(o);
}
function Yl(n) {
  return ["table", "td", "th"].includes(Fe(n));
}
function nr(n) {
  const r = rr(), e = he(n);
  return e.transform !== "none" || e.perspective !== "none" || (e.containerType ? e.containerType !== "normal" : !1) || !r && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !r && (e.filter ? e.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((t) => (e.willChange || "").includes(t)) || ["paint", "layout", "strict", "content"].some((t) => (e.contain || "").includes(t));
}
function Ll(n) {
  let r = ut(n);
  for (; Se(r) && !cn(r); ) {
    if (nr(r))
      return r;
    r = ut(r);
  }
  return null;
}
function rr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function cn(n) {
  return ["html", "body", "#document"].includes(Fe(n));
}
function he(n) {
  return de(n).getComputedStyle(n);
}
function ln(n) {
  return le(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.pageXOffset,
    scrollTop: n.pageYOffset
  };
}
function ut(n) {
  if (Fe(n) === "html")
    return n;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    Pr(n) && n.host || // Fallback.
    Oe(n)
  );
  return Pr(r) ? r.host : r;
}
function Lo(n) {
  const r = ut(n);
  return cn(r) ? n.ownerDocument ? n.ownerDocument.body : n.body : Se(r) && Nt(r) ? r : Lo(r);
}
function Pt(n, r, e) {
  var t;
  r === void 0 && (r = []), e === void 0 && (e = !0);
  const o = Lo(n), s = o === ((t = n.ownerDocument) == null ? void 0 : t.body), a = de(o);
  return s ? r.concat(a, a.visualViewport || [], Nt(o) ? o : [], a.frameElement && e ? Pt(a.frameElement) : []) : r.concat(o, Pt(o, [], e));
}
const dt = Math.min, Qe = Math.max, Xt = Math.round, Lt = Math.floor, $e = (n) => ({
  x: n,
  y: n
}), Fl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, $l = {
  start: "end",
  end: "start"
};
function Al(n, r, e) {
  return Qe(n, dt(r, e));
}
function un(n, r) {
  return typeof n == "function" ? n(r) : n;
}
function pt(n) {
  return n.split("-")[0];
}
function Rt(n) {
  return n.split("-")[1];
}
function Wl(n) {
  return n === "x" ? "y" : "x";
}
function or(n) {
  return n === "y" ? "height" : "width";
}
function ar(n) {
  return ["top", "bottom"].includes(pt(n)) ? "y" : "x";
}
function sr(n) {
  return Wl(ar(n));
}
function Hl(n, r, e) {
  e === void 0 && (e = !1);
  const t = Rt(n), o = sr(n), s = or(o);
  let a = o === "x" ? t === (e ? "end" : "start") ? "right" : "left" : t === "start" ? "bottom" : "top";
  return r.reference[s] > r.floating[s] && (a = Zt(a)), [a, Zt(a)];
}
function jl(n) {
  const r = Zt(n);
  return [Bn(n), r, Bn(r)];
}
function Bn(n) {
  return n.replace(/start|end/g, (r) => $l[r]);
}
function Bl(n, r, e) {
  const t = ["left", "right"], o = ["right", "left"], s = ["top", "bottom"], a = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return e ? r ? o : t : r ? t : o;
    case "left":
    case "right":
      return r ? s : a;
    default:
      return [];
  }
}
function ql(n, r, e, t) {
  const o = Rt(n);
  let s = Bl(pt(n), e === "start", t);
  return o && (s = s.map((a) => a + "-" + o), r && (s = s.concat(s.map(Bn)))), s;
}
function Zt(n) {
  return n.replace(/left|right|bottom|top/g, (r) => Fl[r]);
}
function Ql(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function Fo(n) {
  return typeof n != "number" ? Ql(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function Jt(n) {
  return {
    ...n,
    top: n.y,
    left: n.x,
    right: n.x + n.width,
    bottom: n.y + n.height
  };
}
function _r(n, r, e) {
  let {
    reference: t,
    floating: o
  } = n;
  const s = ar(r), a = sr(r), i = or(a), c = pt(r), l = s === "y", d = t.x + t.width / 2 - o.width / 2, f = t.y + t.height / 2 - o.height / 2, g = t[i] / 2 - o[i] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: d,
        y: t.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: t.y + t.height
      };
      break;
    case "right":
      h = {
        x: t.x + t.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: t.x - o.width,
        y: f
      };
      break;
    default:
      h = {
        x: t.x,
        y: t.y
      };
  }
  switch (Rt(r)) {
    case "start":
      h[a] -= g * (e && l ? -1 : 1);
      break;
    case "end":
      h[a] += g * (e && l ? -1 : 1);
      break;
  }
  return h;
}
const Kl = async (n, r, e) => {
  const {
    placement: t = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: a
  } = e, i = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(r));
  let l = await a.getElementRects({
    reference: n,
    floating: r,
    strategy: o
  }), {
    x: d,
    y: f
  } = _r(l, t, c), g = t, h = {}, y = 0;
  for (let b = 0; b < i.length; b++) {
    const {
      name: C,
      fn: D
    } = i[b], {
      x: w,
      y: x,
      data: E,
      reset: O
    } = await D({
      x: d,
      y: f,
      initialPlacement: t,
      placement: g,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: a,
      elements: {
        reference: n,
        floating: r
      }
    });
    d = w ?? d, f = x ?? f, h = {
      ...h,
      [C]: {
        ...h[C],
        ...E
      }
    }, O && y <= 50 && (y++, typeof O == "object" && (O.placement && (g = O.placement), O.rects && (l = O.rects === !0 ? await a.getElementRects({
      reference: n,
      floating: r,
      strategy: o
    }) : O.rects), {
      x: d,
      y: f
    } = _r(l, g, c)), b = -1);
  }
  return {
    x: d,
    y: f,
    placement: g,
    strategy: o,
    middlewareData: h
  };
};
async function zl(n, r) {
  var e;
  r === void 0 && (r = {});
  const {
    x: t,
    y: o,
    platform: s,
    rects: a,
    elements: i,
    strategy: c
  } = n, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: h = 0
  } = un(r, n), y = Fo(h), C = i[g ? f === "floating" ? "reference" : "floating" : f], D = Jt(await s.getClippingRect({
    element: (e = await (s.isElement == null ? void 0 : s.isElement(C))) == null || e ? C : C.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), w = f === "floating" ? {
    ...a.floating,
    x: t,
    y: o
  } : a.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), E = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = Jt(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: x,
    strategy: c
  }) : w);
  return {
    top: (D.top - O.top + y.top) / E.y,
    bottom: (O.bottom - D.bottom + y.bottom) / E.y,
    left: (D.left - O.left + y.left) / E.x,
    right: (O.right - D.right + y.right) / E.x
  };
}
const Vl = (n) => ({
  name: "arrow",
  options: n,
  async fn(r) {
    const {
      x: e,
      y: t,
      placement: o,
      rects: s,
      platform: a,
      elements: i,
      middlewareData: c
    } = r, {
      element: l,
      padding: d = 0
    } = un(n, r) || {};
    if (l == null)
      return {};
    const f = Fo(d), g = {
      x: e,
      y: t
    }, h = sr(o), y = or(h), b = await a.getDimensions(l), C = h === "y", D = C ? "top" : "left", w = C ? "bottom" : "right", x = C ? "clientHeight" : "clientWidth", E = s.reference[y] + s.reference[h] - g[h] - s.floating[y], O = g[h] - s.reference[h], I = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let M = I ? I[x] : 0;
    (!M || !await (a.isElement == null ? void 0 : a.isElement(I))) && (M = i.floating[x] || s.floating[y]);
    const P = E / 2 - O / 2, $ = M / 2 - b[y] / 2 - 1, G = dt(f[D], $), ae = dt(f[w], $), B = G, se = M - b[y] - ae, X = M / 2 - b[y] / 2 + P, Z = Al(B, X, se), ue = !c.arrow && Rt(o) != null && X !== Z && s.reference[y] / 2 - (X < B ? G : ae) - b[y] / 2 < 0, H = ue ? X < B ? X - B : X - se : 0;
    return {
      [h]: g[h] + H,
      data: {
        [h]: Z,
        centerOffset: X - Z - H,
        ...ue && {
          alignmentOffset: H
        }
      },
      reset: ue
    };
  }
}), Ul = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(r) {
      var e, t;
      const {
        placement: o,
        middlewareData: s,
        rects: a,
        initialPlacement: i,
        platform: c,
        elements: l
      } = r, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: b = !0,
        ...C
      } = un(n, r);
      if ((e = s.arrow) != null && e.alignmentOffset)
        return {};
      const D = pt(o), w = pt(i) === i, x = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), E = g || (w || !b ? [Zt(i)] : jl(i));
      !g && y !== "none" && E.push(...ql(i, b, y, x));
      const O = [i, ...E], I = await zl(r, C), M = [];
      let P = ((t = s.flip) == null ? void 0 : t.overflows) || [];
      if (d && M.push(I[D]), f) {
        const B = Hl(o, a, x);
        M.push(I[B[0]], I[B[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: M
      }], !M.every((B) => B <= 0)) {
        var $, G;
        const B = ((($ = s.flip) == null ? void 0 : $.index) || 0) + 1, se = O[B];
        if (se)
          return {
            data: {
              index: B,
              overflows: P
            },
            reset: {
              placement: se
            }
          };
        let X = (G = P.filter((Z) => Z.overflows[0] <= 0).sort((Z, ue) => Z.overflows[1] - ue.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!X)
          switch (h) {
            case "bestFit": {
              var ae;
              const Z = (ae = P.map((ue) => [ue.placement, ue.overflows.filter((H) => H > 0).reduce((H, et) => H + et, 0)]).sort((ue, H) => ue[1] - H[1])[0]) == null ? void 0 : ae[0];
              Z && (X = Z);
              break;
            }
            case "initialPlacement":
              X = i;
              break;
          }
        if (o !== X)
          return {
            reset: {
              placement: X
            }
          };
      }
      return {};
    }
  };
};
async function Gl(n, r) {
  const {
    placement: e,
    platform: t,
    elements: o
  } = n, s = await (t.isRTL == null ? void 0 : t.isRTL(o.floating)), a = pt(e), i = Rt(e), c = ar(e) === "y", l = ["left", "top"].includes(a) ? -1 : 1, d = s && c ? -1 : 1, f = un(r, n);
  let {
    mainAxis: g,
    crossAxis: h,
    alignmentAxis: y
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return i && typeof y == "number" && (h = i === "end" ? y * -1 : y), c ? {
    x: h * d,
    y: g * l
  } : {
    x: g * l,
    y: h * d
  };
}
const Xl = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(r) {
      var e, t;
      const {
        x: o,
        y: s,
        placement: a,
        middlewareData: i
      } = r, c = await Gl(r, n);
      return a === ((e = i.offset) == null ? void 0 : e.placement) && (t = i.arrow) != null && t.alignmentOffset ? {} : {
        x: o + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
};
function $o(n) {
  const r = he(n);
  let e = parseFloat(r.width) || 0, t = parseFloat(r.height) || 0;
  const o = Se(n), s = o ? n.offsetWidth : e, a = o ? n.offsetHeight : t, i = Xt(e) !== s || Xt(t) !== a;
  return i && (e = s, t = a), {
    width: e,
    height: t,
    $: i
  };
}
function ir(n) {
  return le(n) ? n : n.contextElement;
}
function st(n) {
  const r = ir(n);
  if (!Se(r))
    return $e(1);
  const e = r.getBoundingClientRect(), {
    width: t,
    height: o,
    $: s
  } = $o(r);
  let a = (s ? Xt(e.width) : e.width) / t, i = (s ? Xt(e.height) : e.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const Zl = /* @__PURE__ */ $e(0);
function Ao(n) {
  const r = de(n);
  return !rr() || !r.visualViewport ? Zl : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function Jl(n, r, e) {
  return r === void 0 && (r = !1), !e || r && e !== de(n) ? !1 : r;
}
function Ge(n, r, e, t) {
  r === void 0 && (r = !1), e === void 0 && (e = !1);
  const o = n.getBoundingClientRect(), s = ir(n);
  let a = $e(1);
  r && (t ? le(t) && (a = st(t)) : a = st(n));
  const i = Jl(s, e, t) ? Ao(s) : $e(0);
  let c = (o.left + i.x) / a.x, l = (o.top + i.y) / a.y, d = o.width / a.x, f = o.height / a.y;
  if (s) {
    const g = de(s), h = t && le(t) ? de(t) : t;
    let y = g, b = y.frameElement;
    for (; b && t && h !== y; ) {
      const C = st(b), D = b.getBoundingClientRect(), w = he(b), x = D.left + (b.clientLeft + parseFloat(w.paddingLeft)) * C.x, E = D.top + (b.clientTop + parseFloat(w.paddingTop)) * C.y;
      c *= C.x, l *= C.y, d *= C.x, f *= C.y, c += x, l += E, y = de(b), b = y.frameElement;
    }
  }
  return Jt({
    width: d,
    height: f,
    x: c,
    y: l
  });
}
const eu = [":popover-open", ":modal"];
function Wo(n) {
  return eu.some((r) => {
    try {
      return n.matches(r);
    } catch {
      return !1;
    }
  });
}
function tu(n) {
  let {
    elements: r,
    rect: e,
    offsetParent: t,
    strategy: o
  } = n;
  const s = o === "fixed", a = Oe(t), i = r ? Wo(r.floating) : !1;
  if (t === a || i && s)
    return e;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = $e(1);
  const d = $e(0), f = Se(t);
  if ((f || !f && !s) && ((Fe(t) !== "body" || Nt(a)) && (c = ln(t)), Se(t))) {
    const g = Ge(t);
    l = st(t), d.x = g.x + t.clientLeft, d.y = g.y + t.clientTop;
  }
  return {
    width: e.width * l.x,
    height: e.height * l.y,
    x: e.x * l.x - c.scrollLeft * l.x + d.x,
    y: e.y * l.y - c.scrollTop * l.y + d.y
  };
}
function nu(n) {
  return Array.from(n.getClientRects());
}
function Ho(n) {
  return Ge(Oe(n)).left + ln(n).scrollLeft;
}
function ru(n) {
  const r = Oe(n), e = ln(n), t = n.ownerDocument.body, o = Qe(r.scrollWidth, r.clientWidth, t.scrollWidth, t.clientWidth), s = Qe(r.scrollHeight, r.clientHeight, t.scrollHeight, t.clientHeight);
  let a = -e.scrollLeft + Ho(n);
  const i = -e.scrollTop;
  return he(t).direction === "rtl" && (a += Qe(r.clientWidth, t.clientWidth) - o), {
    width: o,
    height: s,
    x: a,
    y: i
  };
}
function ou(n, r) {
  const e = de(n), t = Oe(n), o = e.visualViewport;
  let s = t.clientWidth, a = t.clientHeight, i = 0, c = 0;
  if (o) {
    s = o.width, a = o.height;
    const l = rr();
    (!l || l && r === "fixed") && (i = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: i,
    y: c
  };
}
function au(n, r) {
  const e = Ge(n, !0, r === "fixed"), t = e.top + n.clientTop, o = e.left + n.clientLeft, s = Se(n) ? st(n) : $e(1), a = n.clientWidth * s.x, i = n.clientHeight * s.y, c = o * s.x, l = t * s.y;
  return {
    width: a,
    height: i,
    x: c,
    y: l
  };
}
function Er(n, r, e) {
  let t;
  if (r === "viewport")
    t = ou(n, e);
  else if (r === "document")
    t = ru(Oe(n));
  else if (le(r))
    t = au(r, e);
  else {
    const o = Ao(n);
    t = {
      ...r,
      x: r.x - o.x,
      y: r.y - o.y
    };
  }
  return Jt(t);
}
function jo(n, r) {
  const e = ut(n);
  return e === r || !le(e) || cn(e) ? !1 : he(e).position === "fixed" || jo(e, r);
}
function su(n, r) {
  const e = r.get(n);
  if (e)
    return e;
  let t = Pt(n, [], !1).filter((i) => le(i) && Fe(i) !== "body"), o = null;
  const s = he(n).position === "fixed";
  let a = s ? ut(n) : n;
  for (; le(a) && !cn(a); ) {
    const i = he(a), c = nr(a);
    !c && i.position === "fixed" && (o = null), (s ? !c && !o : !c && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Nt(a) && !c && jo(n, a)) ? t = t.filter((d) => d !== a) : o = i, a = ut(a);
  }
  return r.set(n, t), t;
}
function iu(n) {
  let {
    element: r,
    boundary: e,
    rootBoundary: t,
    strategy: o
  } = n;
  const a = [...e === "clippingAncestors" ? su(r, this._c) : [].concat(e), t], i = a[0], c = a.reduce((l, d) => {
    const f = Er(r, d, o);
    return l.top = Qe(f.top, l.top), l.right = dt(f.right, l.right), l.bottom = dt(f.bottom, l.bottom), l.left = Qe(f.left, l.left), l;
  }, Er(r, i, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function cu(n) {
  const {
    width: r,
    height: e
  } = $o(n);
  return {
    width: r,
    height: e
  };
}
function lu(n, r, e) {
  const t = Se(r), o = Oe(r), s = e === "fixed", a = Ge(n, !0, s, r);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = $e(0);
  if (t || !t && !s)
    if ((Fe(r) !== "body" || Nt(o)) && (i = ln(r)), t) {
      const f = Ge(r, !0, s, r);
      c.x = f.x + r.clientLeft, c.y = f.y + r.clientTop;
    } else
      o && (c.x = Ho(o));
  const l = a.left + i.scrollLeft - c.x, d = a.top + i.scrollTop - c.y;
  return {
    x: l,
    y: d,
    width: a.width,
    height: a.height
  };
}
function Or(n, r) {
  return !Se(n) || he(n).position === "fixed" ? null : r ? r(n) : n.offsetParent;
}
function Bo(n, r) {
  const e = de(n);
  if (!Se(n) || Wo(n))
    return e;
  let t = Or(n, r);
  for (; t && Yl(t) && he(t).position === "static"; )
    t = Or(t, r);
  return t && (Fe(t) === "html" || Fe(t) === "body" && he(t).position === "static" && !nr(t)) ? e : t || Ll(n) || e;
}
const uu = async function(n) {
  const r = this.getOffsetParent || Bo, e = this.getDimensions;
  return {
    reference: lu(n.reference, await r(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await e(n.floating)
    }
  };
};
function du(n) {
  return he(n).direction === "rtl";
}
const qo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: tu,
  getDocumentElement: Oe,
  getClippingRect: iu,
  getOffsetParent: Bo,
  getElementRects: uu,
  getClientRects: nu,
  getDimensions: cu,
  getScale: st,
  isElement: le,
  isRTL: du
};
function pu(n, r) {
  let e = null, t;
  const o = Oe(n);
  function s() {
    var i;
    clearTimeout(t), (i = e) == null || i.disconnect(), e = null;
  }
  function a(i, c) {
    i === void 0 && (i = !1), c === void 0 && (c = 1), s();
    const {
      left: l,
      top: d,
      width: f,
      height: g
    } = n.getBoundingClientRect();
    if (i || r(), !f || !g)
      return;
    const h = Lt(d), y = Lt(o.clientWidth - (l + f)), b = Lt(o.clientHeight - (d + g)), C = Lt(l), w = {
      rootMargin: -h + "px " + -y + "px " + -b + "px " + -C + "px",
      threshold: Qe(0, dt(1, c)) || 1
    };
    let x = !0;
    function E(O) {
      const I = O[0].intersectionRatio;
      if (I !== c) {
        if (!x)
          return a();
        I ? a(!1, I) : t = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      e = new IntersectionObserver(E, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(E, w);
    }
    e.observe(n);
  }
  return a(!0), s;
}
function fu(n, r, e, t) {
  t === void 0 && (t = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = t, l = ir(n), d = o || s ? [...l ? Pt(l) : [], ...Pt(r)] : [];
  d.forEach((D) => {
    o && D.addEventListener("scroll", e, {
      passive: !0
    }), s && D.addEventListener("resize", e);
  });
  const f = l && i ? pu(l, e) : null;
  let g = -1, h = null;
  a && (h = new ResizeObserver((D) => {
    let [w] = D;
    w && w.target === l && h && (h.unobserve(r), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(r);
    })), e();
  }), l && !c && h.observe(l), h.observe(r));
  let y, b = c ? Ge(n) : null;
  c && C();
  function C() {
    const D = Ge(n);
    b && (D.x !== b.x || D.y !== b.y || D.width !== b.width || D.height !== b.height) && e(), b = D, y = requestAnimationFrame(C);
  }
  return e(), () => {
    var D;
    d.forEach((w) => {
      o && w.removeEventListener("scroll", e), s && w.removeEventListener("resize", e);
    }), f == null || f(), (D = h) == null || D.disconnect(), h = null, c && cancelAnimationFrame(y);
  };
}
const hu = Ul, Tr = Vl, mu = (n, r, e) => {
  const t = /* @__PURE__ */ new Map(), o = {
    platform: qo,
    ...e
  }, s = {
    ...o.platform,
    _c: t
  };
  return Kl(n, r, {
    ...o,
    platform: s
  });
}, gu = (n) => {
  function r(e) {
    return {}.hasOwnProperty.call(e, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(e) {
      const {
        element: t,
        padding: o
      } = typeof n == "function" ? n(e) : n;
      return t && r(t) ? t.current != null ? Tr({
        element: t.current,
        padding: o
      }).fn(e) : {} : t ? Tr({
        element: t,
        padding: o
      }).fn(e) : {};
    }
  };
};
var Wt = typeof document < "u" ? ao : so;
function en(n, r) {
  if (n === r)
    return !0;
  if (typeof n != typeof r)
    return !1;
  if (typeof n == "function" && n.toString() === r.toString())
    return !0;
  let e, t, o;
  if (n && r && typeof n == "object") {
    if (Array.isArray(n)) {
      if (e = n.length, e !== r.length)
        return !1;
      for (t = e; t-- !== 0; )
        if (!en(n[t], r[t]))
          return !1;
      return !0;
    }
    if (o = Object.keys(n), e = o.length, e !== Object.keys(r).length)
      return !1;
    for (t = e; t-- !== 0; )
      if (!{}.hasOwnProperty.call(r, o[t]))
        return !1;
    for (t = e; t-- !== 0; ) {
      const s = o[t];
      if (!(s === "_owner" && n.$$typeof) && !en(n[s], r[s]))
        return !1;
    }
    return !0;
  }
  return n !== n && r !== r;
}
function Qo(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Nr(n, r) {
  const e = Qo(n);
  return Math.round(r * e) / e;
}
function Rr(n) {
  const r = T.useRef(n);
  return Wt(() => {
    r.current = n;
  }), r;
}
function yu(n) {
  n === void 0 && (n = {});
  const {
    placement: r = "bottom",
    strategy: e = "absolute",
    middleware: t = [],
    platform: o,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: i = !0,
    whileElementsMounted: c,
    open: l
  } = n, [d, f] = T.useState({
    x: 0,
    y: 0,
    strategy: e,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [g, h] = T.useState(t);
  en(g, t) || h(t);
  const [y, b] = T.useState(null), [C, D] = T.useState(null), w = T.useCallback((H) => {
    H !== I.current && (I.current = H, b(H));
  }, []), x = T.useCallback((H) => {
    H !== M.current && (M.current = H, D(H));
  }, []), E = s || y, O = a || C, I = T.useRef(null), M = T.useRef(null), P = T.useRef(d), $ = c != null, G = Rr(c), ae = Rr(o), B = T.useCallback(() => {
    if (!I.current || !M.current)
      return;
    const H = {
      placement: r,
      strategy: e,
      middleware: g
    };
    ae.current && (H.platform = ae.current), mu(I.current, M.current, H).then((et) => {
      const tt = {
        ...et,
        isPositioned: !0
      };
      se.current && !en(P.current, tt) && (P.current = tt, va.flushSync(() => {
        f(tt);
      }));
    });
  }, [g, r, e, ae]);
  Wt(() => {
    l === !1 && P.current.isPositioned && (P.current.isPositioned = !1, f((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [l]);
  const se = T.useRef(!1);
  Wt(() => (se.current = !0, () => {
    se.current = !1;
  }), []), Wt(() => {
    if (E && (I.current = E), O && (M.current = O), E && O) {
      if (G.current)
        return G.current(E, O, B);
      B();
    }
  }, [E, O, B, G, $]);
  const X = T.useMemo(() => ({
    reference: I,
    floating: M,
    setReference: w,
    setFloating: x
  }), [w, x]), Z = T.useMemo(() => ({
    reference: E,
    floating: O
  }), [E, O]), ue = T.useMemo(() => {
    const H = {
      position: e,
      left: 0,
      top: 0
    };
    if (!Z.floating)
      return H;
    const et = Nr(Z.floating, d.x), tt = Nr(Z.floating, d.y);
    return i ? {
      ...H,
      transform: "translate(" + et + "px, " + tt + "px)",
      ...Qo(Z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: e,
      left: et,
      top: tt
    };
  }, [e, i, Z.floating, d.x, d.y]);
  return T.useMemo(() => ({
    ...d,
    update: B,
    refs: X,
    elements: Z,
    floatingStyles: ue
  }), [d, B, X, Z, ue]);
}
const bu = T[/* @__PURE__ */ "useInsertionEffect".toString()], wu = bu || ((n) => n());
function vu(n) {
  const r = T.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return wu(() => {
    r.current = n;
  }), T.useCallback(function() {
    for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
      t[o] = arguments[o];
    return r.current == null ? void 0 : r.current(...t);
  }, []);
}
var Ko = typeof document < "u" ? ao : so;
function qn() {
  return qn = Object.assign ? Object.assign.bind() : function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    }
    return n;
  }, qn.apply(this, arguments);
}
let Dn = !1, ku = 0;
const Ir = () => "floating-ui-" + ku++;
function Du() {
  const [n, r] = T.useState(() => Dn ? Ir() : void 0);
  return Ko(() => {
    n == null && r(Ir());
  }, []), T.useEffect(() => {
    Dn || (Dn = !0);
  }, []), n;
}
const xu = T[/* @__PURE__ */ "useId".toString()], zo = xu || Du, Cu = /* @__PURE__ */ T.forwardRef(function(r, e) {
  let {
    context: {
      placement: t,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: s
      }
    },
    width: a = 14,
    height: i = 7,
    tipRadius: c = 0,
    strokeWidth: l = 0,
    staticOffset: d,
    stroke: f,
    d: g,
    style: {
      transform: h,
      ...y
    } = {},
    ...b
  } = r;
  process.env.NODE_ENV !== "production" && (e || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const C = zo();
  if (!o)
    return null;
  l *= 2;
  const D = l / 2, w = a / 2 * (c / -8 + 1), x = i / 2 * c / 4, [E, O] = t.split("-"), I = qo.isRTL(o), M = !!g, P = E === "top" || E === "bottom", $ = d && O === "end" ? "bottom" : "top";
  let G = d && O === "end" ? "right" : "left";
  d && I && (G = O === "end" ? "left" : "right");
  const ae = (s == null ? void 0 : s.x) != null ? d || s.x : "", B = (s == null ? void 0 : s.y) != null ? d || s.y : "", se = g || // biome-ignore lint/style/useTemplate: readability
  "M0,0" + (" H" + a) + (" L" + (a - w) + "," + (i - x)) + (" Q" + a / 2 + "," + i + " " + w + "," + (i - x)) + " Z", X = {
    top: M ? "rotate(180deg)" : "",
    left: M ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: M ? "" : "rotate(180deg)",
    right: M ? "rotate(-90deg)" : "rotate(90deg)"
  }[E];
  return /* @__PURE__ */ T.createElement("svg", qn({}, b, {
    "aria-hidden": !0,
    ref: e,
    width: M ? a : a + l,
    height: a,
    viewBox: "0 0 " + a + " " + (i > a ? i : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [G]: ae,
      [$]: B,
      [E]: P || M ? "100%" : "calc(100% - " + l / 2 + "px)",
      transform: "" + X + (h ?? ""),
      ...y
    }
  }), l > 0 && /* @__PURE__ */ T.createElement("path", {
    clipPath: "url(#" + C + ")",
    fill: "none",
    stroke: f,
    strokeWidth: l + (g ? 0 : 1),
    d: se
  }), /* @__PURE__ */ T.createElement("path", {
    stroke: l && !g ? b.fill : "none",
    d: se
  }), /* @__PURE__ */ T.createElement("clipPath", {
    id: C
  }, /* @__PURE__ */ T.createElement("rect", {
    x: -D,
    y: D * (M ? -1 : 1),
    width: a + l,
    height: a
  })));
});
function Su() {
  const n = /* @__PURE__ */ new Map();
  return {
    emit(r, e) {
      var t;
      (t = n.get(r)) == null || t.forEach((o) => o(e));
    },
    on(r, e) {
      n.set(r, [...n.get(r) || [], e]);
    },
    off(r, e) {
      var t;
      n.set(r, ((t = n.get(r)) == null ? void 0 : t.filter((o) => o !== e)) || []);
    }
  };
}
const Mu = /* @__PURE__ */ T.createContext(null), Pu = /* @__PURE__ */ T.createContext(null), _u = () => {
  var n;
  return ((n = T.useContext(Mu)) == null ? void 0 : n.id) || null;
}, Eu = () => T.useContext(Pu);
let Qn;
process.env.NODE_ENV !== "production" && (Qn = /* @__PURE__ */ new Set());
function Ou(n) {
  var r;
  n === void 0 && (n = {});
  const {
    open: e = !1,
    onOpenChange: t,
    nodeId: o
  } = n;
  if (process.env.NODE_ENV !== "production") {
    var s;
    const P = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((s = n.elements) != null && s.reference && !le(n.elements.reference)) {
      var a;
      if (!((a = Qn) != null && a.has(P))) {
        var i;
        (i = Qn) == null || i.add(P), console.error(P);
      }
    }
  }
  const [c, l] = T.useState(null), d = ((r = n.elements) == null ? void 0 : r.reference) || c, f = yu(n), g = Eu(), h = _u() != null, y = vu((P, $, G) => {
    P && (C.current.openEvent = $), D.emit("openchange", {
      open: P,
      event: $,
      reason: G,
      nested: h
    }), t == null || t(P, $, G);
  }), b = T.useRef(null), C = T.useRef({}), D = T.useState(() => Su())[0], w = zo(), x = T.useCallback((P) => {
    const $ = le(P) ? {
      getBoundingClientRect: () => P.getBoundingClientRect(),
      contextElement: P
    } : P;
    f.refs.setReference($);
  }, [f.refs]), E = T.useCallback((P) => {
    (le(P) || P === null) && (b.current = P, l(P)), (le(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    P !== null && !le(P)) && f.refs.setReference(P);
  }, [f.refs]), O = T.useMemo(() => ({
    ...f.refs,
    setReference: E,
    setPositionReference: x,
    domReference: b
  }), [f.refs, E, x]), I = T.useMemo(() => ({
    ...f.elements,
    domReference: d
  }), [f.elements, d]), M = T.useMemo(() => ({
    ...f,
    refs: O,
    elements: I,
    dataRef: C,
    nodeId: o,
    floatingId: w,
    events: D,
    open: e,
    onOpenChange: y
  }), [f, o, w, D, e, y, O, I]);
  return Ko(() => {
    const P = g == null ? void 0 : g.nodesRef.current.find(($) => $.id === o);
    P && (P.context = M);
  }), T.useMemo(() => ({
    ...f,
    context: M,
    refs: O,
    elements: I
  }), [f, O, I, M]);
}
function Tu(n, r) {
  let e = S(n);
  return isNaN(+e) ? F(n, NaN) : (r.year != null && e.setFullYear(r.year), r.month != null && (e = ie(e, r.month)), r.date != null && e.setDate(r.date), r.hours != null && e.setHours(r.hours), r.minutes != null && e.setMinutes(r.minutes), r.seconds != null && e.setSeconds(r.seconds), r.milliseconds != null && e.setMilliseconds(r.milliseconds), e);
}
function ee(n, r, e) {
  return r = tn(r), function(t, o) {
    if (o && (typeof o == "object" || typeof o == "function"))
      return o;
    if (o !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return p(t);
  }(n, Vo() ? Reflect.construct(r, e || [], tn(n).constructor) : r.apply(n, e));
}
function Vo() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Vo = function() {
    return !!n;
  })();
}
function Yr(n, r) {
  var e = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);
    r && (t = t.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), e.push.apply(e, t);
  }
  return e;
}
function Pe(n) {
  for (var r = 1; r < arguments.length; r++) {
    var e = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Yr(Object(e), !0).forEach(function(t) {
      u(n, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : Yr(Object(e)).forEach(function(t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }
  return n;
}
function Uo(n) {
  var r = function(e, t) {
    if (typeof e != "object" || !e)
      return e;
    var o = e[Symbol.toPrimitive];
    if (o !== void 0) {
      var s = o.call(e, t || "default");
      if (typeof s != "object")
        return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }(n, "string");
  return typeof r == "symbol" ? r : String(r);
}
function Kn(n) {
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Kn(n);
}
function te(n, r) {
  if (!(n instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Lr(n, r) {
  for (var e = 0; e < r.length; e++) {
    var t = r[e];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(n, Uo(t.key), t);
  }
}
function ne(n, r, e) {
  return r && Lr(n.prototype, r), e && Lr(n, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function u(n, r, e) {
  return (r = Uo(r)) in n ? Object.defineProperty(n, r, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = e, n;
}
function _t() {
  return _t = Object.assign ? Object.assign.bind() : function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    }
    return n;
  }, _t.apply(this, arguments);
}
function re(n, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(r && r.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), r && zn(n, r);
}
function tn(n) {
  return tn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tn(n);
}
function zn(n, r) {
  return zn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
    return e.__proto__ = t, e;
  }, zn(n, r);
}
function p(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Xe(n) {
  return function(r) {
    if (Array.isArray(r))
      return xn(r);
  }(n) || function(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
      return Array.from(r);
  }(n) || function(r, e) {
    if (r) {
      if (typeof r == "string")
        return xn(r, e);
      var t = Object.prototype.toString.call(r).slice(8, -1);
      if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
        return Array.from(r);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
        return xn(r, e);
    }
  }(n) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function xn(n, r) {
  (r == null || r > n.length) && (r = n.length);
  for (var e = 0, t = new Array(r); e < r; e++)
    t[e] = n[e];
  return t;
}
var bt = 12, Nu = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function W(n) {
  var r = n ? typeof n == "string" || n instanceof String ? ll(n) : S(n) : /* @__PURE__ */ new Date();
  return Ne(r) ? r : null;
}
function Ne(n, r) {
  return r = r || /* @__PURE__ */ new Date("1/1/1000"), xt(n) && !Ue(n, r);
}
function j(n, r, e) {
  if (e === "en")
    return wr(n, r, { useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
  var t = Ye(e);
  return e && !t && console.warn('A locale object was not found for the provided string ["'.concat(e, '"].')), !t && Ke() && Ye(Ke()) && (t = Ye(Ke())), wr(n, r, { locale: t || null, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
}
function be(n, r) {
  var e = r.dateFormat, t = r.locale;
  return n && j(n, Array.isArray(e) ? e[0] : e, t) || "";
}
function Fr(n, r) {
  var e = r.hour, t = e === void 0 ? 0 : e, o = r.minute, s = o === void 0 ? 0 : o, a = r.second;
  return At($t(rc(n, a === void 0 ? 0 : a), s), t);
}
function ge(n, r, e) {
  var t = Ye(r || Ke());
  return Ee(n, { locale: t, weekStartsOn: e });
}
function Ie(n) {
  return Eo(n);
}
function yt(n) {
  return Xn(n);
}
function $r(n) {
  return An(n);
}
function Ar() {
  return De(W());
}
function Re(n, r) {
  return n && r ? dc(n, r) : !n && !r;
}
function me(n, r) {
  return n && r ? uc(n, r) : !n && !r;
}
function nn(n, r) {
  return n && r ? pc(n, r) : !n && !r;
}
function A(n, r) {
  return n && r ? lc(n, r) : !n && !r;
}
function qe(n, r) {
  return n && r ? cc(n, r) : !n && !r;
}
function Ht(n, r, e) {
  var t, o = De(r), s = Wn(e);
  try {
    t = Mt(n, { start: o, end: s });
  } catch {
    t = !1;
  }
  return t;
}
function Ke() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Ye(n) {
  if (typeof n == "string") {
    var r = typeof window < "u" ? window : globalThis;
    return r.__localeData__ ? r.__localeData__[n] : null;
  }
  return n;
}
function cr(n, r) {
  return j(ie(W(), n), "LLLL", r);
}
function Go(n, r) {
  return j(ie(W(), n), "LLL", r);
}
function dn(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.maxDate, o = r.excludeDates, s = r.excludeDateIntervals, a = r.includeDates, i = r.includeDateIntervals, c = r.filterDate;
  return pn(n, { minDate: e, maxDate: t }) || o && o.some(function(l) {
    return A(n, l.date ? l.date : l);
  }) || s && s.some(function(l) {
    var d = l.start, f = l.end;
    return Mt(n, { start: d, end: f });
  }) || a && !a.some(function(l) {
    return A(n, l);
  }) || i && !i.some(function(l) {
    var d = l.start, f = l.end;
    return Mt(n, { start: d, end: f });
  }) || c && !c(W(n)) || !1;
}
function lr(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.excludeDates, t = r.excludeDateIntervals;
  return t && t.length > 0 ? t.some(function(o) {
    var s = o.start, a = o.end;
    return Mt(n, { start: s, end: a });
  }) : e && e.some(function(o) {
    return A(n, o.date ? o.date : o);
  }) || !1;
}
function Xo(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.maxDate, o = r.excludeDates, s = r.includeDates, a = r.filterDate;
  return pn(n, { minDate: Eo(e), maxDate: sc(t) }) || o && o.some(function(i) {
    return me(n, i);
  }) || s && !s.some(function(i) {
    return me(n, i);
  }) || a && !a(W(n)) || !1;
}
function Cn(n, r, e, t) {
  var o = N(n), s = oe(n), a = N(r), i = oe(r), c = N(t);
  return o === a && o === c ? s <= e && e <= i : o < a ? c === o && s <= e || c === a && i >= e || c < a && c > o : void 0;
}
function Ru(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.maxDate, o = r.excludeDates, s = r.includeDates, a = r.filterDate;
  return pn(n, { minDate: e, maxDate: t }) || o && o.some(function(i) {
    return nn(n, i);
  }) || s && !s.some(function(i) {
    return nn(n, i);
  }) || a && !a(W(n)) || !1;
}
function Sn(n, r, e) {
  if (!xt(r) || !xt(e))
    return !1;
  var t = N(r), o = N(e);
  return t <= n && o >= n;
}
function Zo(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.maxDate, o = r.excludeDates, s = r.includeDates, a = r.filterDate, i = new Date(n, 0, 1);
  return pn(i, { minDate: Xn(e), maxDate: ic(t) }) || o && o.some(function(c) {
    return Re(i, c);
  }) || s && !s.some(function(c) {
    return Re(i, c);
  }) || a && !a(W(i)) || !1;
}
function Mn(n, r, e, t) {
  var o = N(n), s = ot(n), a = N(r), i = ot(r), c = N(t);
  return o === a && o === c ? s <= e && e <= i : o < a ? c === o && s <= e || c === a && i >= e || c < a && c > o : void 0;
}
function pn(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.maxDate;
  return e && Ct(n, e) < 0 || t && Ct(n, t) > 0;
}
function Wr(n, r) {
  return r.some(function(e) {
    return Ce(e) === Ce(n) && xe(e) === xe(n);
  });
}
function Hr(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.excludeTimes, t = r.includeTimes, o = r.filterTime;
  return e && Wr(n, e) || t && !Wr(n, t) || o && !o(n) || !1;
}
function jr(n, r) {
  var e = r.minTime, t = r.maxTime;
  if (!e || !t)
    throw new Error("Both minTime and maxTime props required");
  var o, s = W(), a = At($t(s, xe(n)), Ce(n)), i = At($t(s, xe(e)), Ce(e)), c = At($t(s, xe(t)), Ce(t));
  try {
    o = !Mt(a, { start: i, end: c });
  } catch {
    o = !1;
  }
  return o;
}
function Br(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.includeDates, o = lt(n, 1);
  return e && Vt(e, o) > 0 || t && t.every(function(s) {
    return Vt(s, o) > 0;
  }) || !1;
}
function qr(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.maxDate, t = r.includeDates, o = ye(n, 1);
  return e && Vt(o, e) > 0 || t && t.every(function(s) {
    return Vt(o, s) > 0;
  }) || !1;
}
function Qr(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.minDate, t = r.includeDates, o = St(n, 1);
  return e && Ut(e, o) > 0 || t && t.every(function(s) {
    return Ut(s, o) > 0;
  }) || !1;
}
function Kr(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = r.maxDate, t = r.includeDates, o = ct(n, 1);
  return e && Ut(o, e) > 0 || t && t.every(function(s) {
    return Ut(o, s) > 0;
  }) || !1;
}
function Jo(n) {
  var r = n.minDate, e = n.includeDates;
  if (e && r) {
    var t = e.filter(function(o) {
      return Ct(o, r) >= 0;
    });
    return xr(t);
  }
  return e ? xr(e) : r;
}
function ea(n) {
  var r = n.maxDate, e = n.includeDates;
  if (e && r) {
    var t = e.filter(function(o) {
      return Ct(o, r) <= 0;
    });
    return Cr(t);
  }
  return e ? Cr(e) : r;
}
function zr() {
  for (var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", e = /* @__PURE__ */ new Map(), t = 0, o = n.length; t < o; t++) {
    var s = n[t];
    if (Ve(s)) {
      var a = j(s, "MM.dd.yyyy"), i = e.get(a) || [];
      i.includes(r) || (i.push(r), e.set(a, i));
    } else if (Kn(s) === "object") {
      var c = Object.keys(s), l = c[0], d = s[c[0]];
      if (typeof l == "string" && d.constructor === Array)
        for (var f = 0, g = d.length; f < g; f++) {
          var h = j(d[f], "MM.dd.yyyy"), y = e.get(h) || [];
          y.includes(l) || (y.push(l), e.set(h, y));
        }
    }
  }
  return e;
}
function Iu() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", e = /* @__PURE__ */ new Map();
  return n.forEach(function(t) {
    var o = t.date, s = t.holidayName;
    if (Ve(o)) {
      var a = j(o, "MM.dd.yyyy"), i = e.get(a) || {};
      if (!("className" in i) || i.className !== r || (c = i.holidayNames, l = [s], c.length !== l.length || !c.every(function(f, g) {
        return f === l[g];
      }))) {
        var c, l;
        i.className = r;
        var d = i.holidayNames;
        i.holidayNames = d ? [].concat(Xe(d), [s]) : [s], e.set(a, i);
      }
    }
  }), e;
}
function Yu(n, r, e, t, o) {
  for (var s = o.length, a = [], i = 0; i < s; i++) {
    var c = Fn(Ji(n, Ce(o[i])), xe(o[i])), l = Fn(n, (e + 1) * t);
    Le(c, r) && Ue(c, l) && a.push(o[i]);
  }
  return a;
}
function Vr(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
}
function at(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : bt, e = Math.ceil(N(n) / r) * r;
  return { startPeriod: e - (r - 1), endPeriod: e };
}
function Ur(n) {
  var r = n.getSeconds(), e = n.getMilliseconds();
  return S(n.getTime() - 1e3 * r - e);
}
function Gr(n) {
  if (!Ve(n))
    throw new Error("Invalid date");
  var r = new Date(n);
  return r.setHours(0, 0, 0, 0), r;
}
function Xr(n, r) {
  if (!Ve(n) || !Ve(r))
    throw new Error("Invalid date received");
  var e = Gr(n), t = Gr(r);
  return Ue(e, t);
}
function Lu(n, r, e, t) {
  for (var o = [], s = 0; s < 2 * r + 1; s++) {
    var a = n + r - s, i = !0;
    e && (i = N(e) <= a), t && i && (i = N(t) >= a), i && o.push(a);
  }
  return o;
}
var Fu = sn(function(n) {
  function r(e) {
    var t;
    te(this, r), u(p(t = ee(this, r, [e])), "renderOptions", function() {
      var i = t.props.year, c = t.state.yearsList.map(function(f) {
        return m.createElement("div", { className: i === f ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: f, onClick: t.onChange.bind(p(t), f), "aria-selected": i === f ? "true" : void 0 }, i === f ? m.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", f);
      }), l = t.props.minDate ? N(t.props.minDate) : null, d = t.props.maxDate ? N(t.props.maxDate) : null;
      return d && t.state.yearsList.find(function(f) {
        return f === d;
      }) || c.unshift(m.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: t.incrementYears }, m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), l && t.state.yearsList.find(function(f) {
        return f === l;
      }) || c.push(m.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: t.decrementYears }, m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), c;
    }), u(p(t), "onChange", function(i) {
      t.props.onChange(i);
    }), u(p(t), "handleClickOutside", function() {
      t.props.onCancel();
    }), u(p(t), "shiftYears", function(i) {
      var c = t.state.yearsList.map(function(l) {
        return l + i;
      });
      t.setState({ yearsList: c });
    }), u(p(t), "incrementYears", function() {
      return t.shiftYears(1);
    }), u(p(t), "decrementYears", function() {
      return t.shiftYears(-1);
    });
    var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, a = o || (s ? 10 : 5);
    return t.state = { yearsList: Lu(t.props.year, a, t.props.minDate, t.props.maxDate) }, t.dropdownRef = ga(), t;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    var e = this.dropdownRef.current;
    if (e) {
      var t = e.children ? Array.from(e.children) : null, o = t ? t.find(function(s) {
        return s.ariaSelected;
      }) : null;
      e.scrollTop = o ? o.offsetTop + (o.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var e = J({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return m.createElement("div", { className: e, ref: this.dropdownRef }, this.renderOptions());
  } }]), r;
}()), $u = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), u(p(e), "renderSelectOptions", function() {
      for (var a = e.props.minDate ? N(e.props.minDate) : 1900, i = e.props.maxDate ? N(e.props.maxDate) : 2100, c = [], l = a; l <= i; l++)
        c.push(m.createElement("option", { key: l, value: l }, l));
      return c;
    }), u(p(e), "onSelectChange", function(a) {
      e.onChange(a.target.value);
    }), u(p(e), "renderSelectMode", function() {
      return m.createElement("select", { value: e.props.year, className: "react-datepicker__year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
    }), u(p(e), "renderReadView", function(a) {
      return m.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(i) {
        return e.toggleDropdown(i);
      } }, m.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), m.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, e.props.year));
    }), u(p(e), "renderDropdown", function() {
      return m.createElement(Fu, { key: "dropdown", year: e.props.year, onChange: e.onChange, onCancel: e.toggleDropdown, minDate: e.props.minDate, maxDate: e.props.maxDate, scrollableYearDropdown: e.props.scrollableYearDropdown, yearDropdownItemNumber: e.props.yearDropdownItemNumber });
    }), u(p(e), "renderScrollMode", function() {
      var a = e.state.dropdownVisible, i = [e.renderReadView(!a)];
      return a && i.unshift(e.renderDropdown()), i;
    }), u(p(e), "onChange", function(a) {
      e.toggleDropdown(), a !== e.props.year && e.props.onChange(a);
    }), u(p(e), "toggleDropdown", function(a) {
      e.setState({ dropdownVisible: !e.state.dropdownVisible }, function() {
        e.props.adjustDateOnChange && e.handleYearChange(e.props.date, a);
      });
    }), u(p(e), "handleYearChange", function(a, i) {
      e.onSelect(a, i), e.setOpen();
    }), u(p(e), "onSelect", function(a, i) {
      e.props.onSelect && e.props.onSelect(a, i);
    }), u(p(e), "setOpen", function() {
      e.props.setOpen && e.props.setOpen(!0);
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e;
    switch (this.props.dropdownMode) {
      case "scroll":
        e = this.renderScrollMode();
        break;
      case "select":
        e = this.renderSelectMode();
    }
    return m.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, e);
  } }]), r;
}(), Au = sn(function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "isSelectedMonth", function(a) {
      return e.props.month === a;
    }), u(p(e), "renderOptions", function() {
      return e.props.monthNames.map(function(a, i) {
        return m.createElement("div", { className: e.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: a, onClick: e.onChange.bind(p(e), i), "aria-selected": e.isSelectedMonth(i) ? "true" : void 0 }, e.isSelectedMonth(i) ? m.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", a);
      });
    }), u(p(e), "onChange", function(a) {
      return e.props.onChange(a);
    }), u(p(e), "handleClickOutside", function() {
      return e.props.onCancel();
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    return m.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), r;
}()), Wu = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), u(p(e), "renderSelectOptions", function(a) {
      return a.map(function(i, c) {
        return m.createElement("option", { key: c, value: c }, i);
      });
    }), u(p(e), "renderSelectMode", function(a) {
      return m.createElement("select", { value: e.props.month, className: "react-datepicker__month-select", onChange: function(i) {
        return e.onChange(i.target.value);
      } }, e.renderSelectOptions(a));
    }), u(p(e), "renderReadView", function(a, i) {
      return m.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: e.toggleDropdown }, m.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), m.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, i[e.props.month]));
    }), u(p(e), "renderDropdown", function(a) {
      return m.createElement(Au, { key: "dropdown", month: e.props.month, monthNames: a, onChange: e.onChange, onCancel: e.toggleDropdown });
    }), u(p(e), "renderScrollMode", function(a) {
      var i = e.state.dropdownVisible, c = [e.renderReadView(!i, a)];
      return i && c.unshift(e.renderDropdown(a)), c;
    }), u(p(e), "onChange", function(a) {
      e.toggleDropdown(), a !== e.props.month && e.props.onChange(a);
    }), u(p(e), "toggleDropdown", function() {
      return e.setState({ dropdownVisible: !e.state.dropdownVisible });
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e, t = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(s) {
      return Go(s, t.props.locale);
    } : function(s) {
      return cr(s, t.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        e = this.renderScrollMode(o);
        break;
      case "select":
        e = this.renderSelectMode(o);
    }
    return m.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, e);
  } }]), r;
}();
function Hu(n, r) {
  for (var e = [], t = Ie(n), o = Ie(r); !Le(t, o); )
    e.push(W(t)), t = ye(t, 1);
  return e;
}
var ju = sn(function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "renderOptions", function() {
      return t.state.monthYearsList.map(function(o) {
        var s = $n(o), a = Re(t.props.date, o) && me(t.props.date, o);
        return m.createElement("div", { className: a ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: s, onClick: t.onChange.bind(p(t), s), "aria-selected": a ? "true" : void 0 }, a ? m.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", j(o, t.props.dateFormat, t.props.locale));
      });
    }), u(p(t), "onChange", function(o) {
      return t.props.onChange(o);
    }), u(p(t), "handleClickOutside", function() {
      t.props.onCancel();
    }), t.state = { monthYearsList: Hu(t.props.minDate, t.props.maxDate) }, t;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e = J({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return m.createElement("div", { className: e }, this.renderOptions());
  } }]), r;
}()), Bu = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "state", { dropdownVisible: !1 }), u(p(e), "renderSelectOptions", function() {
      for (var a = Ie(e.props.minDate), i = Ie(e.props.maxDate), c = []; !Le(a, i); ) {
        var l = $n(a);
        c.push(m.createElement("option", { key: l, value: l }, j(a, e.props.dateFormat, e.props.locale))), a = ye(a, 1);
      }
      return c;
    }), u(p(e), "onSelectChange", function(a) {
      e.onChange(a.target.value);
    }), u(p(e), "renderSelectMode", function() {
      return m.createElement("select", { value: $n(Ie(e.props.date)), className: "react-datepicker__month-year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
    }), u(p(e), "renderReadView", function(a) {
      var i = j(e.props.date, e.props.dateFormat, e.props.locale);
      return m.createElement("div", { key: "read", style: { visibility: a ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(c) {
        return e.toggleDropdown(c);
      } }, m.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), m.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, i));
    }), u(p(e), "renderDropdown", function() {
      return m.createElement(ju, { key: "dropdown", date: e.props.date, dateFormat: e.props.dateFormat, onChange: e.onChange, onCancel: e.toggleDropdown, minDate: e.props.minDate, maxDate: e.props.maxDate, scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown, locale: e.props.locale });
    }), u(p(e), "renderScrollMode", function() {
      var a = e.state.dropdownVisible, i = [e.renderReadView(!a)];
      return a && i.unshift(e.renderDropdown()), i;
    }), u(p(e), "onChange", function(a) {
      e.toggleDropdown();
      var i = W(parseInt(a));
      Re(e.props.date, i) && me(e.props.date, i) || e.props.onChange(i);
    }), u(p(e), "toggleDropdown", function() {
      return e.setState({ dropdownVisible: !e.state.dropdownVisible });
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e;
    switch (this.props.dropdownMode) {
      case "scroll":
        e = this.renderScrollMode();
        break;
      case "select":
        e = this.renderSelectMode();
    }
    return m.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, e);
  } }]), r;
}(), qu = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "dayEl", m.createRef()), u(p(e), "handleClick", function(a) {
      !e.isDisabled() && e.props.onClick && e.props.onClick(a);
    }), u(p(e), "handleMouseEnter", function(a) {
      !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(a);
    }), u(p(e), "handleOnKeyDown", function(a) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), e.props.handleOnKeyDown(a);
    }), u(p(e), "isSameDay", function(a) {
      return A(e.props.day, a);
    }), u(p(e), "isKeyboardSelected", function() {
      return !e.props.disabledKeyboardNavigation && !(e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected)) && (e.isSameDay(e.props.preSelection) || e.isSameWeek(e.props.preSelection));
    }), u(p(e), "isDisabled", function() {
      return dn(e.props.day, e.props);
    }), u(p(e), "isExcluded", function() {
      return lr(e.props.day, e.props);
    }), u(p(e), "isStartOfWeek", function() {
      return A(e.props.day, ge(e.props.day, e.props.locale, e.props.calendarStartDay));
    }), u(p(e), "isSameWeek", function(a) {
      return e.props.showWeekPicker && A(a, ge(e.props.day, e.props.locale, e.props.calendarStartDay));
    }), u(p(e), "getHighLightedClass", function() {
      var a = e.props, i = a.day, c = a.highlightDates;
      if (!c)
        return !1;
      var l = j(i, "MM.dd.yyyy");
      return c.get(l);
    }), u(p(e), "getHolidaysClass", function() {
      var a = e.props, i = a.day, c = a.holidays;
      if (!c)
        return !1;
      var l = j(i, "MM.dd.yyyy");
      return c.has(l) ? [c.get(l).className] : void 0;
    }), u(p(e), "isInRange", function() {
      var a = e.props, i = a.day, c = a.startDate, l = a.endDate;
      return !(!c || !l) && Ht(i, c, l);
    }), u(p(e), "isInSelectingRange", function() {
      var a, i = e.props, c = i.day, l = i.selectsStart, d = i.selectsEnd, f = i.selectsRange, g = i.selectsDisabledDaysInRange, h = i.startDate, y = i.endDate, b = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
      return !(!(l || d || f) || !b || !g && e.isDisabled()) && (l && y && (Ue(b, y) || qe(b, y)) ? Ht(c, b, y) : (d && h && (Le(b, h) || qe(b, h)) || !(!f || !h || y || !Le(b, h) && !qe(b, h))) && Ht(c, h, b));
    }), u(p(e), "isSelectingRangeStart", function() {
      var a;
      if (!e.isInSelectingRange())
        return !1;
      var i = e.props, c = i.day, l = i.startDate, d = i.selectsStart, f = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
      return A(c, d ? f : l);
    }), u(p(e), "isSelectingRangeEnd", function() {
      var a;
      if (!e.isInSelectingRange())
        return !1;
      var i = e.props, c = i.day, l = i.endDate, d = i.selectsEnd, f = i.selectsRange, g = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
      return A(c, d || f ? g : l);
    }), u(p(e), "isRangeStart", function() {
      var a = e.props, i = a.day, c = a.startDate, l = a.endDate;
      return !(!c || !l) && A(c, i);
    }), u(p(e), "isRangeEnd", function() {
      var a = e.props, i = a.day, c = a.startDate, l = a.endDate;
      return !(!c || !l) && A(l, i);
    }), u(p(e), "isWeekend", function() {
      var a = nc(e.props.day);
      return a === 0 || a === 6;
    }), u(p(e), "isAfterMonth", function() {
      return e.props.month !== void 0 && (e.props.month + 1) % 12 === oe(e.props.day);
    }), u(p(e), "isBeforeMonth", function() {
      return e.props.month !== void 0 && (oe(e.props.day) + 1) % 12 === e.props.month;
    }), u(p(e), "isCurrentDay", function() {
      return e.isSameDay(W());
    }), u(p(e), "isSelected", function() {
      return e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected);
    }), u(p(e), "getClassNames", function(a) {
      var i, c = e.props.dayClassName ? e.props.dayClassName(a) : void 0;
      return J("react-datepicker__day", c, "react-datepicker__day--" + j(e.props.day, "ddd", i), { "react-datepicker__day--disabled": e.isDisabled(), "react-datepicker__day--excluded": e.isExcluded(), "react-datepicker__day--selected": e.isSelected(), "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(), "react-datepicker__day--range-start": e.isRangeStart(), "react-datepicker__day--range-end": e.isRangeEnd(), "react-datepicker__day--in-range": e.isInRange(), "react-datepicker__day--in-selecting-range": e.isInSelectingRange(), "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(), "react-datepicker__day--today": e.isCurrentDay(), "react-datepicker__day--weekend": e.isWeekend(), "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth() }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
    }), u(p(e), "getAriaLabel", function() {
      var a = e.props, i = a.day, c = a.ariaLabelPrefixWhenEnabled, l = c === void 0 ? "Choose" : c, d = a.ariaLabelPrefixWhenDisabled, f = d === void 0 ? "Not available" : d, g = e.isDisabled() || e.isExcluded() ? f : l;
      return "".concat(g, " ").concat(j(i, "PPPP", e.props.locale));
    }), u(p(e), "getTitle", function() {
      var a = e.props, i = a.day, c = a.holidays, l = c === void 0 ? /* @__PURE__ */ new Map() : c, d = a.excludeDates, f = j(i, "MM.dd.yyyy"), g = [];
      return l.has(f) && g.push.apply(g, Xe(l.get(f).holidayNames)), e.isExcluded() && g.push(d == null ? void 0 : d.filter(function(h) {
        return A(h.date ? h.date : h, i);
      }).map(function(h) {
        return h.message;
      })), g.join(", ");
    }), u(p(e), "getTabIndex", function(a, i) {
      var c = a || e.props.selected, l = i || e.props.preSelection;
      return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(c) && A(l, c)) ? 0 : -1;
    }), u(p(e), "handleFocusDay", function() {
      var a, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      e.getTabIndex() === 0 && !i.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (c = !0), e.props.inline && !e.props.shouldFocusDayInline && (c = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (c = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (c = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (c = !1)), c && ((a = e.dayEl.current) === null || a === void 0 || a.focus({ preventScroll: !0 }));
    }), u(p(e), "renderDayContents", function() {
      return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Dr(e.props.day), e.props.day) : Dr(e.props.day);
    }), u(p(e), "render", function() {
      return m.createElement("div", { ref: e.dayEl, className: e.getClassNames(e.props.day), onKeyDown: e.handleOnKeyDown, onClick: e.handleClick, onMouseEnter: e.handleMouseEnter, tabIndex: e.getTabIndex(), "aria-label": e.getAriaLabel(), role: "option", title: e.getTitle(), "aria-disabled": e.isDisabled(), "aria-current": e.isCurrentDay() ? "date" : void 0, "aria-selected": e.isSelected() || e.isInRange() }, e.renderDayContents(), e.getTitle() !== "" && m.createElement("span", { className: "overlay" }, e.getTitle()));
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(e) {
    this.handleFocusDay(e);
  } }]), r;
}(), Qu = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "weekNumberEl", m.createRef()), u(p(e), "handleClick", function(a) {
      e.props.onClick && e.props.onClick(a);
    }), u(p(e), "handleOnKeyDown", function(a) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), e.props.handleOnKeyDown(a);
    }), u(p(e), "isKeyboardSelected", function() {
      return !e.props.disabledKeyboardNavigation && !A(e.props.date, e.props.selected) && A(e.props.date, e.props.preSelection);
    }), u(p(e), "getTabIndex", function() {
      return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || A(e.props.date, e.props.selected) && A(e.props.preSelection, e.props.selected)) ? 0 : -1;
    }), u(p(e), "handleFocusWeekNumber", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = !1;
      e.getTabIndex() === 0 && !a.isInputFocused && A(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (i = !0), e.props.inline && !e.props.shouldFocusDayInline && (i = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (i = !0)), i && e.weekNumberEl.current && e.weekNumberEl.current.focus({ preventScroll: !0 });
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(e) {
    this.handleFocusWeekNumber(e);
  } }, { key: "render", value: function() {
    var e = this.props, t = e.weekNumber, o = e.ariaLabelPrefix, s = o === void 0 ? "week " : o, a = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!e.onClick, "react-datepicker__week-number--selected": A(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return m.createElement("div", { ref: this.weekNumberEl, className: J(a), "aria-label": "".concat(s, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, t);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), r;
}(), Ku = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "handleDayClick", function(a, i) {
      e.props.onDayClick && e.props.onDayClick(a, i);
    }), u(p(e), "handleDayMouseEnter", function(a) {
      e.props.onDayMouseEnter && e.props.onDayMouseEnter(a);
    }), u(p(e), "handleWeekClick", function(a, i, c) {
      if (typeof e.props.onWeekSelect == "function" && e.props.onWeekSelect(a, i, c), e.props.showWeekPicker) {
        var l = ge(a, e.props.locale, e.props.calendarStartDay);
        e.handleDayClick(l, c);
      }
      e.props.shouldCloseOnSelect && e.props.setOpen(!1);
    }), u(p(e), "formatWeekNumber", function(a) {
      return e.props.formatWeekNumber ? e.props.formatWeekNumber(a) : function(i, c) {
        return c && Ye(c) || Ke() && Ye(Ke()), Zn(i);
      }(a);
    }), u(p(e), "renderDays", function() {
      var a = ge(e.props.day, e.props.locale, e.props.calendarStartDay), i = [], c = e.formatWeekNumber(a);
      if (e.props.showWeekNumber) {
        var l = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(p(e), a, c) : void 0;
        i.push(m.createElement(Qu, { key: "W", weekNumber: c, date: a, onClick: l, selected: e.props.selected, preSelection: e.props.preSelection, ariaLabelPrefix: e.props.ariaLabelPrefix, showWeekPicker: e.props.showWeekPicker, showWeekNumber: e.props.showWeekNumber, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, handleOnKeyDown: e.props.handleOnKeyDown, isInputFocused: e.props.isInputFocused, containerRef: e.props.containerRef }));
      }
      return i.concat([0, 1, 2, 3, 4, 5, 6].map(function(d) {
        var f = We(a, d);
        return m.createElement(qu, { ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix, key: f.valueOf(), day: f, month: e.props.month, onClick: e.handleDayClick.bind(p(e), f), onMouseEnter: e.handleDayMouseEnter.bind(p(e), f), minDate: e.props.minDate, maxDate: e.props.maxDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, highlightDates: e.props.highlightDates, holidays: e.props.holidays, selectingDate: e.props.selectingDate, filterDate: e.props.filterDate, preSelection: e.props.preSelection, selected: e.props.selected, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, showWeekPicker: e.props.showWeekPicker, showWeekNumber: e.props.showWeekNumber, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, startDate: e.props.startDate, endDate: e.props.endDate, dayClassName: e.props.dayClassName, renderDayContents: e.props.renderDayContents, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, handleOnKeyDown: e.props.handleOnKeyDown, isInputFocused: e.props.isInputFocused, containerRef: e.props.containerRef, inline: e.props.inline, shouldFocusDayInline: e.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart, locale: e.props.locale });
      }));
    }), u(p(e), "startOfWeek", function() {
      return ge(e.props.day, e.props.locale, e.props.calendarStartDay);
    }), u(p(e), "isKeyboardSelected", function() {
      return !e.props.disabledKeyboardNavigation && !A(e.startOfWeek(), e.props.selected) && A(e.startOfWeek(), e.props.preSelection);
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e = { "react-datepicker__week": !0, "react-datepicker__week--selected": A(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return m.createElement("div", { className: J(e) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), r;
}(), ta = "two_columns", na = "three_columns", ra = "four_columns", Pn = u(u(u({}, ta, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), na, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), ra, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function Zr(n, r) {
  return n ? ra : r ? ta : na;
}
var zu = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "MONTH_REFS", Xe(Array(12)).map(function() {
      return m.createRef();
    })), u(p(e), "QUARTER_REFS", Xe(Array(4)).map(function() {
      return m.createRef();
    })), u(p(e), "isDisabled", function(a) {
      return dn(a, e.props);
    }), u(p(e), "isExcluded", function(a) {
      return lr(a, e.props);
    }), u(p(e), "handleDayClick", function(a, i) {
      e.props.onDayClick && e.props.onDayClick(a, i, e.props.orderInDisplay);
    }), u(p(e), "handleDayMouseEnter", function(a) {
      e.props.onDayMouseEnter && e.props.onDayMouseEnter(a);
    }), u(p(e), "handleMouseLeave", function() {
      e.props.onMouseLeave && e.props.onMouseLeave();
    }), u(p(e), "isRangeStartMonth", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate;
      return !(!l || !d) && me(ie(c, a), l);
    }), u(p(e), "isRangeStartQuarter", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate;
      return !(!l || !d) && nn(rt(c, a), l);
    }), u(p(e), "isRangeEndMonth", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate;
      return !(!l || !d) && me(ie(c, a), d);
    }), u(p(e), "isRangeEndQuarter", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate;
      return !(!l || !d) && nn(rt(c, a), d);
    }), u(p(e), "isInSelectingRangeMonth", function(a) {
      var i, c = e.props, l = c.day, d = c.selectsStart, f = c.selectsEnd, g = c.selectsRange, h = c.startDate, y = c.endDate, b = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
      return !(!(d || f || g) || !b) && (d && y ? Cn(b, y, a, l) : (f && h || !(!g || !h || y)) && Cn(h, b, a, l));
    }), u(p(e), "isSelectingMonthRangeStart", function(a) {
      var i;
      if (!e.isInSelectingRangeMonth(a))
        return !1;
      var c = e.props, l = c.day, d = c.startDate, f = c.selectsStart, g = ie(l, a), h = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
      return me(g, f ? h : d);
    }), u(p(e), "isSelectingMonthRangeEnd", function(a) {
      var i;
      if (!e.isInSelectingRangeMonth(a))
        return !1;
      var c = e.props, l = c.day, d = c.endDate, f = c.selectsEnd, g = c.selectsRange, h = ie(l, a), y = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
      return me(h, f || g ? y : d);
    }), u(p(e), "isInSelectingRangeQuarter", function(a) {
      var i, c = e.props, l = c.day, d = c.selectsStart, f = c.selectsEnd, g = c.selectsRange, h = c.startDate, y = c.endDate, b = (i = e.props.selectingDate) !== null && i !== void 0 ? i : e.props.preSelection;
      return !(!(d || f || g) || !b) && (d && y ? Mn(b, y, a, l) : (f && h || !(!g || !h || y)) && Mn(h, b, a, l));
    }), u(p(e), "isWeekInMonth", function(a) {
      var i = e.props.day, c = We(a, 6);
      return me(a, i) || me(c, i);
    }), u(p(e), "isCurrentMonth", function(a, i) {
      return N(a) === N(W()) && i === oe(W());
    }), u(p(e), "isCurrentQuarter", function(a, i) {
      return N(a) === N(W()) && i === ot(W());
    }), u(p(e), "isSelectedMonth", function(a, i, c) {
      return oe(c) === i && N(a) === N(c);
    }), u(p(e), "isSelectedQuarter", function(a, i, c) {
      return ot(a) === i && N(a) === N(c);
    }), u(p(e), "renderWeeks", function() {
      for (var a = [], i = e.props.fixedHeight, c = 0, l = !1, d = ge(Ie(e.props.day), e.props.locale, e.props.calendarStartDay); a.push(m.createElement(Ku, { ariaLabelPrefix: e.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix, key: c, day: d, month: oe(e.props.day), onDayClick: e.handleDayClick, onDayMouseEnter: e.handleDayMouseEnter, onWeekSelect: e.props.onWeekSelect, formatWeekNumber: e.props.formatWeekNumber, locale: e.props.locale, minDate: e.props.minDate, maxDate: e.props.maxDate, excludeDates: e.props.excludeDates, excludeDateIntervals: e.props.excludeDateIntervals, includeDates: e.props.includeDates, includeDateIntervals: e.props.includeDateIntervals, inline: e.props.inline, shouldFocusDayInline: e.props.shouldFocusDayInline, highlightDates: e.props.highlightDates, holidays: e.props.holidays, selectingDate: e.props.selectingDate, filterDate: e.props.filterDate, preSelection: e.props.preSelection, selected: e.props.selected, selectsStart: e.props.selectsStart, selectsEnd: e.props.selectsEnd, selectsRange: e.props.selectsRange, selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange, showWeekNumber: e.props.showWeekNumbers, showWeekPicker: e.props.showWeekPicker, startDate: e.props.startDate, endDate: e.props.endDate, dayClassName: e.props.dayClassName, setOpen: e.props.setOpen, shouldCloseOnSelect: e.props.shouldCloseOnSelect, disabledKeyboardNavigation: e.props.disabledKeyboardNavigation, renderDayContents: e.props.renderDayContents, handleOnKeyDown: e.props.handleOnKeyDown, isInputFocused: e.props.isInputFocused, containerRef: e.props.containerRef, calendarStartDay: e.props.calendarStartDay, monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart })), !l; ) {
        c++, d = zt(d, 1);
        var f = i && c >= 6, g = !i && !e.isWeekInMonth(d);
        if (f || g) {
          if (!e.props.peekNextMonth)
            break;
          l = !0;
        }
      }
      return a;
    }), u(p(e), "onMonthClick", function(a, i) {
      e.handleDayClick(Ie(ie(e.props.day, i)), a);
    }), u(p(e), "onMonthMouseEnter", function(a) {
      e.handleDayMouseEnter(Ie(ie(e.props.day, a)));
    }), u(p(e), "handleMonthNavigation", function(a, i) {
      e.isDisabled(i) || e.isExcluded(i) || (e.props.setPreSelection(i), e.MONTH_REFS[a].current && e.MONTH_REFS[a].current.focus());
    }), u(p(e), "onMonthKeyDown", function(a, i) {
      var c = e.props, l = c.selected, d = c.preSelection, f = c.disabledKeyboardNavigation, g = c.showTwoColumnMonthYearPicker, h = c.showFourColumnMonthYearPicker, y = c.setPreSelection, b = a.key;
      if (b !== "Tab" && a.preventDefault(), !f) {
        var C = Zr(h, g), D = Pn[C].verticalNavigationOffset, w = Pn[C].grid;
        switch (b) {
          case "Enter":
            e.onMonthClick(a, i), y(l);
            break;
          case "ArrowRight":
            e.handleMonthNavigation(i === 11 ? 0 : i + 1, ye(d, 1));
            break;
          case "ArrowLeft":
            e.handleMonthNavigation(i === 0 ? 11 : i - 1, lt(d, 1));
            break;
          case "ArrowUp":
            e.handleMonthNavigation(w[0].includes(i) ? i + 12 - D : i - D, lt(d, D));
            break;
          case "ArrowDown":
            e.handleMonthNavigation(w[w.length - 1].includes(i) ? i - 12 + D : i + D, ye(d, D));
        }
      }
    }), u(p(e), "onQuarterClick", function(a, i) {
      e.handleDayClick($r(rt(e.props.day, i)), a);
    }), u(p(e), "onQuarterMouseEnter", function(a) {
      e.handleDayMouseEnter($r(rt(e.props.day, a)));
    }), u(p(e), "handleQuarterNavigation", function(a, i) {
      e.isDisabled(i) || e.isExcluded(i) || (e.props.setPreSelection(i), e.QUARTER_REFS[a - 1].current && e.QUARTER_REFS[a - 1].current.focus());
    }), u(p(e), "onQuarterKeyDown", function(a, i) {
      var c = a.key;
      if (!e.props.disabledKeyboardNavigation)
        switch (c) {
          case "Enter":
            e.onQuarterClick(a, i), e.props.setPreSelection(e.props.selected);
            break;
          case "ArrowRight":
            e.handleQuarterNavigation(i === 4 ? 1 : i + 1, _o(e.props.preSelection, 1));
            break;
          case "ArrowLeft":
            e.handleQuarterNavigation(i === 1 ? 4 : i - 1, tc(e.props.preSelection, 1));
        }
    }), u(p(e), "getMonthClassNames", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate, f = i.selected, g = i.minDate, h = i.maxDate, y = i.preSelection, b = i.monthClassName, C = i.excludeDates, D = i.includeDates, w = b ? b(ie(c, a)) : void 0, x = ie(c, a);
      return J("react-datepicker__month-text", "react-datepicker__month-".concat(a), w, { "react-datepicker__month-text--disabled": (g || h || C || D) && Xo(x, e.props), "react-datepicker__month-text--selected": e.isSelectedMonth(c, a, f), "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && oe(y) === a, "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(a), "react-datepicker__month-text--in-range": Cn(l, d, a, c), "react-datepicker__month-text--range-start": e.isRangeStartMonth(a), "react-datepicker__month-text--range-end": e.isRangeEndMonth(a), "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(a), "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(a), "react-datepicker__month-text--today": e.isCurrentMonth(c, a) });
    }), u(p(e), "getTabIndex", function(a) {
      var i = oe(e.props.preSelection);
      return e.props.disabledKeyboardNavigation || a !== i ? "-1" : "0";
    }), u(p(e), "getQuarterTabIndex", function(a) {
      var i = ot(e.props.preSelection);
      return e.props.disabledKeyboardNavigation || a !== i ? "-1" : "0";
    }), u(p(e), "getAriaLabel", function(a) {
      var i = e.props, c = i.chooseDayAriaLabelPrefix, l = c === void 0 ? "Choose" : c, d = i.disabledDayAriaLabelPrefix, f = d === void 0 ? "Not available" : d, g = i.day, h = ie(g, a), y = e.isDisabled(h) || e.isExcluded(h) ? f : l;
      return "".concat(y, " ").concat(j(h, "MMMM yyyy"));
    }), u(p(e), "getQuarterClassNames", function(a) {
      var i = e.props, c = i.day, l = i.startDate, d = i.endDate, f = i.selected, g = i.minDate, h = i.maxDate, y = i.preSelection, b = i.disabledKeyboardNavigation;
      return J("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(a), { "react-datepicker__quarter-text--disabled": (g || h) && Ru(rt(c, a), e.props), "react-datepicker__quarter-text--selected": e.isSelectedQuarter(c, a, f), "react-datepicker__quarter-text--keyboard-selected": !b && ot(y) === a, "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(a), "react-datepicker__quarter-text--in-range": Mn(l, d, a, c), "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(a), "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(a) });
    }), u(p(e), "getMonthContent", function(a) {
      var i = e.props, c = i.showFullMonthYearPicker, l = i.renderMonthContent, d = i.locale, f = i.day, g = Go(a, d), h = cr(a, d);
      return l ? l(a, g, h, f) : c ? h : g;
    }), u(p(e), "getQuarterContent", function(a) {
      var i = e.props, c = i.renderQuarterContent, l = function(d, f) {
        return j(rt(W(), d), "QQQ", f);
      }(a, i.locale);
      return c ? c(a, l) : l;
    }), u(p(e), "renderMonths", function() {
      var a = e.props, i = a.showTwoColumnMonthYearPicker, c = a.showFourColumnMonthYearPicker, l = a.day, d = a.selected;
      return Pn[Zr(c, i)].grid.map(function(f, g) {
        return m.createElement("div", { className: "react-datepicker__month-wrapper", key: g }, f.map(function(h, y) {
          return m.createElement("div", { ref: e.MONTH_REFS[h], key: y, onClick: function(b) {
            e.onMonthClick(b, h);
          }, onKeyDown: function(b) {
            e.onMonthKeyDown(b, h);
          }, onMouseEnter: function() {
            return e.onMonthMouseEnter(h);
          }, tabIndex: e.getTabIndex(h), className: e.getMonthClassNames(h), role: "option", "aria-label": e.getAriaLabel(h), "aria-current": e.isCurrentMonth(l, h) ? "date" : void 0, "aria-selected": e.isSelectedMonth(l, h, d) }, e.getMonthContent(h));
        }));
      });
    }), u(p(e), "renderQuarters", function() {
      var a = e.props, i = a.day, c = a.selected;
      return m.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(l, d) {
        return m.createElement("div", { key: d, ref: e.QUARTER_REFS[d], role: "option", onClick: function(f) {
          e.onQuarterClick(f, l);
        }, onKeyDown: function(f) {
          e.onQuarterKeyDown(f, l);
        }, onMouseEnter: function() {
          return e.onQuarterMouseEnter(l);
        }, className: e.getQuarterClassNames(l), "aria-selected": e.isSelectedQuarter(i, l, c), tabIndex: e.getQuarterTabIndex(l), "aria-current": e.isCurrentQuarter(i, l) ? "date" : void 0 }, e.getQuarterContent(l));
      }));
    }), u(p(e), "getClassNames", function() {
      var a = e.props, i = a.selectingDate, c = a.selectsStart, l = a.selectsEnd, d = a.showMonthYearPicker, f = a.showQuarterYearPicker, g = a.showWeekPicker;
      return J("react-datepicker__month", { "react-datepicker__month--selecting-range": i && (c || l) }, { "react-datepicker__monthPicker": d }, { "react-datepicker__quarterPicker": f }, { "react-datepicker__weekPicker": g });
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e = this.props, t = e.showMonthYearPicker, o = e.showQuarterYearPicker, s = e.day, a = e.ariaLabelPrefix, i = a === void 0 ? "month " : a;
    return m.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(i, " ").concat(j(s, "yyyy-MM")), role: "listbox" }, t ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
  } }]), r;
}(), oa = function(n) {
  function r() {
    var e;
    te(this, r);
    for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++)
      o[s] = arguments[s];
    return u(p(e = ee(this, r, [].concat(o))), "state", { height: null }), u(p(e), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        e.list && (e.list.scrollTop = e.centerLi && r.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
      });
    }), u(p(e), "handleClick", function(a) {
      (e.props.minTime || e.props.maxTime) && jr(a, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && Hr(a, e.props) || e.props.onChange(a);
    }), u(p(e), "isSelectedTime", function(a) {
      return e.props.selected && (i = e.props.selected, c = a, Ur(i).getTime() === Ur(c).getTime());
      var i, c;
    }), u(p(e), "isDisabledTime", function(a) {
      return (e.props.minTime || e.props.maxTime) && jr(a, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && Hr(a, e.props);
    }), u(p(e), "liClasses", function(a) {
      var i = ["react-datepicker__time-list-item", e.props.timeClassName ? e.props.timeClassName(a) : void 0];
      return e.isSelectedTime(a) && i.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(a) && i.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Ce(a) + xe(a)) % e.props.intervals != 0 && i.push("react-datepicker__time-list-item--injected"), i.join(" ");
    }), u(p(e), "handleOnKeyDown", function(a, i) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), a.key !== "ArrowUp" && a.key !== "ArrowLeft" || !a.target.previousSibling || (a.preventDefault(), a.target.previousSibling.focus()), a.key !== "ArrowDown" && a.key !== "ArrowRight" || !a.target.nextSibling || (a.preventDefault(), a.target.nextSibling.focus()), a.key === "Enter" && e.handleClick(i), e.props.handleOnKeyDown(a);
    }), u(p(e), "renderTimes", function() {
      for (var a = [], i = e.props.format ? e.props.format : "p", c = e.props.intervals, l = e.props.selected || e.props.openToDate || W(), d = De(l), f = e.props.injectTimes && e.props.injectTimes.sort(function(w, x) {
        return w - x;
      }), g = 60 * function(w) {
        var x = new Date(w.getFullYear(), w.getMonth(), w.getDate()), E = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 24);
        return Math.round((+E - +x) / 36e5);
      }(l), h = g / c, y = 0; y < h; y++) {
        var b = Fn(d, y * c);
        if (a.push(b), f) {
          var C = Yu(d, b, y, c, f);
          a = a.concat(C);
        }
      }
      var D = a.reduce(function(w, x) {
        return x.getTime() <= l.getTime() ? x : w;
      }, a[0]);
      return a.map(function(w, x) {
        return m.createElement("li", { key: x, onClick: e.handleClick.bind(p(e), w), className: e.liClasses(w), ref: function(E) {
          w === D && (e.centerLi = E);
        }, onKeyDown: function(E) {
          e.handleOnKeyDown(E, w);
        }, tabIndex: w === D ? 0 : -1, role: "option", "aria-selected": e.isSelectedTime(w) ? "true" : void 0, "aria-disabled": e.isDisabledTime(w) ? "true" : void 0 }, j(w, i, e.props.locale));
      });
    }), e;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var e = this, t = this.state.height;
    return m.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, m.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
      e.header = o;
    } }, m.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), m.createElement("div", { className: "react-datepicker__time" }, m.createElement("div", { className: "react-datepicker__time-box" }, m.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
      e.list = o;
    }, style: t ? { height: t } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), r;
}();
u(oa, "calcCenterPosition", function(n, r) {
  return r.offsetTop - (n / 2 - r.clientHeight / 2);
});
var Vu = function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "YEAR_REFS", Xe(Array(t.props.yearItemNumber)).map(function() {
      return m.createRef();
    })), u(p(t), "isDisabled", function(o) {
      return dn(o, t.props);
    }), u(p(t), "isExcluded", function(o) {
      return lr(o, t.props);
    }), u(p(t), "selectingDate", function() {
      var o;
      return (o = t.props.selectingDate) !== null && o !== void 0 ? o : t.props.preSelection;
    }), u(p(t), "updateFocusOnPaginate", function(o) {
      var s = function() {
        this.YEAR_REFS[o].current.focus();
      }.bind(p(t));
      window.requestAnimationFrame(s);
    }), u(p(t), "handleYearClick", function(o, s) {
      t.props.onDayClick && t.props.onDayClick(o, s);
    }), u(p(t), "handleYearNavigation", function(o, s) {
      var a = t.props, i = a.date, c = a.yearItemNumber, l = at(i, c).startPeriod;
      t.isDisabled(s) || t.isExcluded(s) || (t.props.setPreSelection(s), o - l == -1 ? t.updateFocusOnPaginate(c - 1) : o - l === c ? t.updateFocusOnPaginate(0) : t.YEAR_REFS[o - l].current.focus());
    }), u(p(t), "isSameDay", function(o, s) {
      return A(o, s);
    }), u(p(t), "isCurrentYear", function(o) {
      return o === N(W());
    }), u(p(t), "isRangeStart", function(o) {
      return t.props.startDate && t.props.endDate && Re(Me(W(), o), t.props.startDate);
    }), u(p(t), "isRangeEnd", function(o) {
      return t.props.startDate && t.props.endDate && Re(Me(W(), o), t.props.endDate);
    }), u(p(t), "isInRange", function(o) {
      return Sn(o, t.props.startDate, t.props.endDate);
    }), u(p(t), "isInSelectingRange", function(o) {
      var s = t.props, a = s.selectsStart, i = s.selectsEnd, c = s.selectsRange, l = s.startDate, d = s.endDate;
      return !(!(a || i || c) || !t.selectingDate()) && (a && d ? Sn(o, t.selectingDate(), d) : (i && l || !(!c || !l || d)) && Sn(o, l, t.selectingDate()));
    }), u(p(t), "isSelectingRangeStart", function(o) {
      if (!t.isInSelectingRange(o))
        return !1;
      var s = t.props, a = s.startDate, i = s.selectsStart, c = Me(W(), o);
      return Re(c, i ? t.selectingDate() : a);
    }), u(p(t), "isSelectingRangeEnd", function(o) {
      if (!t.isInSelectingRange(o))
        return !1;
      var s = t.props, a = s.endDate, i = s.selectsEnd, c = s.selectsRange, l = Me(W(), o);
      return Re(l, i || c ? t.selectingDate() : a);
    }), u(p(t), "isKeyboardSelected", function(o) {
      var s = yt(Me(t.props.date, o));
      return !t.props.disabledKeyboardNavigation && !t.props.inline && !A(s, yt(t.props.selected)) && A(s, yt(t.props.preSelection));
    }), u(p(t), "onYearClick", function(o, s) {
      var a = t.props.date;
      t.handleYearClick(yt(Me(a, s)), o);
    }), u(p(t), "onYearKeyDown", function(o, s) {
      var a = o.key;
      if (!t.props.disabledKeyboardNavigation)
        switch (a) {
          case "Enter":
            t.onYearClick(o, s), t.props.setPreSelection(t.props.selected);
            break;
          case "ArrowRight":
            t.handleYearNavigation(s + 1, ct(t.props.preSelection, 1));
            break;
          case "ArrowLeft":
            t.handleYearNavigation(s - 1, St(t.props.preSelection, 1));
        }
    }), u(p(t), "getYearClassNames", function(o) {
      var s = t.props, a = s.minDate, i = s.maxDate, c = s.selected, l = s.excludeDates, d = s.includeDates, f = s.filterDate;
      return J("react-datepicker__year-text", { "react-datepicker__year-text--selected": o === N(c), "react-datepicker__year-text--disabled": (a || i || l || d || f) && Zo(o, t.props), "react-datepicker__year-text--keyboard-selected": t.isKeyboardSelected(o), "react-datepicker__year-text--range-start": t.isRangeStart(o), "react-datepicker__year-text--range-end": t.isRangeEnd(o), "react-datepicker__year-text--in-range": t.isInRange(o), "react-datepicker__year-text--in-selecting-range": t.isInSelectingRange(o), "react-datepicker__year-text--selecting-range-start": t.isSelectingRangeStart(o), "react-datepicker__year-text--selecting-range-end": t.isSelectingRangeEnd(o), "react-datepicker__year-text--today": t.isCurrentYear(o) });
    }), u(p(t), "getYearTabIndex", function(o) {
      return t.props.disabledKeyboardNavigation ? "-1" : o === N(t.props.preSelection) ? "0" : "-1";
    }), u(p(t), "getYearContainerClassNames", function() {
      var o = t.props, s = o.selectingDate, a = o.selectsStart, i = o.selectsEnd, c = o.selectsRange;
      return J("react-datepicker__year", { "react-datepicker__year--selecting-range": s && (a || i || c) });
    }), u(p(t), "getYearContent", function(o) {
      return t.props.renderYearContent ? t.props.renderYearContent(o) : o;
    }), t;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    for (var e = this, t = [], o = this.props, s = o.date, a = o.yearItemNumber, i = o.onYearMouseEnter, c = o.onYearMouseLeave, l = at(s, a), d = l.startPeriod, f = l.endPeriod, g = function(y) {
      t.push(m.createElement("div", { ref: e.YEAR_REFS[y - d], onClick: function(b) {
        e.onYearClick(b, y);
      }, onKeyDown: function(b) {
        e.onYearKeyDown(b, y);
      }, tabIndex: e.getYearTabIndex(y), className: e.getYearClassNames(y), onMouseEnter: function(b) {
        return i(b, y);
      }, onMouseLeave: function(b) {
        return c(b, y);
      }, key: y, "aria-current": e.isCurrentYear(y) ? "date" : void 0 }, e.getYearContent(y)));
    }, h = d; h <= f; h++)
      g(h);
    return m.createElement("div", { className: this.getYearContainerClassNames() }, m.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, t));
  } }]), r;
}(), Uu = function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "onTimeChange", function(o) {
      t.setState({ time: o });
      var s = t.props.date, a = s instanceof Date && !isNaN(s) ? s : /* @__PURE__ */ new Date();
      a.setHours(o.split(":")[0]), a.setMinutes(o.split(":")[1]), t.props.onChange(a);
    }), u(p(t), "renderTimeInput", function() {
      var o = t.state.time, s = t.props, a = s.date, i = s.timeString, c = s.customTimeInput;
      return c ? m.cloneElement(c, { date: a, value: o, onChange: t.onTimeChange }) : m.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: o, onChange: function(l) {
        t.onTimeChange(l.target.value || i);
      } });
    }), t.state = { time: t.props.timeString }, t;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    return m.createElement("div", { className: "react-datepicker__input-time-container" }, m.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), m.createElement("div", { className: "react-datepicker-time__input-container" }, m.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(e, t) {
    return e.timeString !== t.time ? { time: e.timeString } : null;
  } }]), r;
}();
function Gu(n) {
  var r = n.className, e = n.children;
  return m.createElement("div", { className: r }, e);
}
var Xu = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Zu = function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "handleClickOutside", function(o) {
      t.props.onClickOutside(o);
    }), u(p(t), "setClickOutsideRef", function() {
      return t.containerRef.current;
    }), u(p(t), "handleDropdownFocus", function(o) {
      (function() {
        var s = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return Xu.some(function(a) {
          return s.indexOf(a) >= 0;
        });
      })(o.target) && t.props.onDropdownFocus();
    }), u(p(t), "getDateInView", function() {
      var o = t.props, s = o.preSelection, a = o.selected, i = o.openToDate, c = Jo(t.props), l = ea(t.props), d = W(), f = i || a || s;
      return f || (c && Ue(d, c) ? c : l && Le(d, l) ? l : d);
    }), u(p(t), "increaseMonth", function() {
      t.setState(function(o) {
        var s = o.date;
        return { date: ye(s, 1) };
      }, function() {
        return t.handleMonthChange(t.state.date);
      });
    }), u(p(t), "decreaseMonth", function() {
      t.setState(function(o) {
        var s = o.date;
        return { date: lt(s, 1) };
      }, function() {
        return t.handleMonthChange(t.state.date);
      });
    }), u(p(t), "handleDayClick", function(o, s, a) {
      t.props.onSelect(o, s, a), t.props.setPreSelection && t.props.setPreSelection(o);
    }), u(p(t), "handleDayMouseEnter", function(o) {
      t.setState({ selectingDate: o }), t.props.onDayMouseEnter && t.props.onDayMouseEnter(o);
    }), u(p(t), "handleMonthMouseLeave", function() {
      t.setState({ selectingDate: null }), t.props.onMonthMouseLeave && t.props.onMonthMouseLeave();
    }), u(p(t), "handleYearMouseEnter", function(o, s) {
      t.setState({ selectingDate: Me(W(), s) }), t.props.onYearMouseEnter && t.props.onYearMouseEnter(o, s);
    }), u(p(t), "handleYearMouseLeave", function(o, s) {
      t.props.onYearMouseLeave && t.props.onYearMouseLeave(o, s);
    }), u(p(t), "handleYearChange", function(o) {
      t.props.onYearChange && (t.props.onYearChange(o), t.setState({ isRenderAriaLiveMessage: !0 })), t.props.adjustDateOnChange && (t.props.onSelect && t.props.onSelect(o), t.props.setOpen && t.props.setOpen(!0)), t.props.setPreSelection && t.props.setPreSelection(o);
    }), u(p(t), "handleMonthChange", function(o) {
      t.handleCustomMonthChange(o), t.props.adjustDateOnChange && (t.props.onSelect && t.props.onSelect(o), t.props.setOpen && t.props.setOpen(!0)), t.props.setPreSelection && t.props.setPreSelection(o);
    }), u(p(t), "handleCustomMonthChange", function(o) {
      t.props.onMonthChange && (t.props.onMonthChange(o), t.setState({ isRenderAriaLiveMessage: !0 }));
    }), u(p(t), "handleMonthYearChange", function(o) {
      t.handleYearChange(o), t.handleMonthChange(o);
    }), u(p(t), "changeYear", function(o) {
      t.setState(function(s) {
        var a = s.date;
        return { date: Me(a, o) };
      }, function() {
        return t.handleYearChange(t.state.date);
      });
    }), u(p(t), "changeMonth", function(o) {
      t.setState(function(s) {
        var a = s.date;
        return { date: ie(a, o) };
      }, function() {
        return t.handleMonthChange(t.state.date);
      });
    }), u(p(t), "changeMonthYear", function(o) {
      t.setState(function(s) {
        var a = s.date;
        return { date: Me(ie(a, oe(o)), N(o)) };
      }, function() {
        return t.handleMonthYearChange(t.state.date);
      });
    }), u(p(t), "header", function() {
      var o = ge(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.state.date, t.props.locale, t.props.calendarStartDay), s = [];
      return t.props.showWeekNumbers && s.push(m.createElement("div", { key: "W", className: "react-datepicker__day-name" }, t.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(a) {
        var i = We(o, a), c = t.formatWeekday(i, t.props.locale), l = t.props.weekDayClassName ? t.props.weekDayClassName(i) : void 0;
        return m.createElement("div", { key: a, className: J("react-datepicker__day-name", l) }, c);
      }));
    }), u(p(t), "formatWeekday", function(o, s) {
      return t.props.formatWeekDay ? function(a, i, c) {
        return i(j(a, "EEEE", c));
      }(o, t.props.formatWeekDay, s) : t.props.useWeekdaysShort ? function(a, i) {
        return j(a, "EEE", i);
      }(o, s) : function(a, i) {
        return j(a, "EEEEEE", i);
      }(o, s);
    }), u(p(t), "decreaseYear", function() {
      t.setState(function(o) {
        var s = o.date;
        return { date: St(s, t.props.showYearPicker ? t.props.yearItemNumber : 1) };
      }, function() {
        return t.handleYearChange(t.state.date);
      });
    }), u(p(t), "clearSelectingDate", function() {
      t.setState({ selectingDate: null });
    }), u(p(t), "renderPreviousButton", function() {
      if (!t.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case t.props.showMonthYearPicker:
            o = Qr(t.state.date, t.props);
            break;
          case t.props.showYearPicker:
            o = function(C) {
              var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = D.minDate, x = D.yearItemNumber, E = x === void 0 ? bt : x, O = at(yt(St(C, E)), E).endPeriod, I = w && N(w);
              return I && I > O || !1;
            }(t.state.date, t.props);
            break;
          default:
            o = Br(t.state.date, t.props);
        }
        if ((t.props.forceShowMonthNavigation || t.props.showDisabledMonthNavigation || !o) && !t.props.showTimeSelectOnly) {
          var s = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], a = t.decreaseMonth;
          (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker) && (a = t.decreaseYear), o && t.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--previous--disabled"), a = null);
          var i = t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker, c = t.props, l = c.previousMonthButtonLabel, d = c.previousYearButtonLabel, f = t.props, g = f.previousMonthAriaLabel, h = g === void 0 ? typeof l == "string" ? l : "Previous Month" : g, y = f.previousYearAriaLabel, b = y === void 0 ? typeof d == "string" ? d : "Previous Year" : y;
          return m.createElement("button", { type: "button", className: s.join(" "), onClick: a, onKeyDown: t.props.handleOnKeyDown, "aria-label": i ? b : h }, m.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, i ? t.props.previousYearButtonLabel : t.props.previousMonthButtonLabel));
        }
      }
    }), u(p(t), "increaseYear", function() {
      t.setState(function(o) {
        var s = o.date;
        return { date: ct(s, t.props.showYearPicker ? t.props.yearItemNumber : 1) };
      }, function() {
        return t.handleYearChange(t.state.date);
      });
    }), u(p(t), "renderNextButton", function() {
      if (!t.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case t.props.showMonthYearPicker:
            o = Kr(t.state.date, t.props);
            break;
          case t.props.showYearPicker:
            o = function(C) {
              var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = D.maxDate, x = D.yearItemNumber, E = x === void 0 ? bt : x, O = at(ct(C, E), E).startPeriod, I = w && N(w);
              return I && I < O || !1;
            }(t.state.date, t.props);
            break;
          default:
            o = qr(t.state.date, t.props);
        }
        if ((t.props.forceShowMonthNavigation || t.props.showDisabledMonthNavigation || !o) && !t.props.showTimeSelectOnly) {
          var s = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          t.props.showTimeSelect && s.push("react-datepicker__navigation--next--with-time"), t.props.todayButton && s.push("react-datepicker__navigation--next--with-today-button");
          var a = t.increaseMonth;
          (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker) && (a = t.increaseYear), o && t.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--next--disabled"), a = null);
          var i = t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker, c = t.props, l = c.nextMonthButtonLabel, d = c.nextYearButtonLabel, f = t.props, g = f.nextMonthAriaLabel, h = g === void 0 ? typeof l == "string" ? l : "Next Month" : g, y = f.nextYearAriaLabel, b = y === void 0 ? typeof d == "string" ? d : "Next Year" : y;
          return m.createElement("button", { type: "button", className: s.join(" "), onClick: a, onKeyDown: t.props.handleOnKeyDown, "aria-label": i ? b : h }, m.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, i ? t.props.nextYearButtonLabel : t.props.nextMonthButtonLabel));
        }
      }
    }), u(p(t), "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.state.date, s = ["react-datepicker__current-month"];
      return t.props.showYearDropdown && s.push("react-datepicker__current-month--hasYearDropdown"), t.props.showMonthDropdown && s.push("react-datepicker__current-month--hasMonthDropdown"), t.props.showMonthYearDropdown && s.push("react-datepicker__current-month--hasMonthYearDropdown"), m.createElement("div", { className: s.join(" ") }, j(o, t.props.dateFormat, t.props.locale));
    }), u(p(t), "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (t.props.showYearDropdown && !o)
        return m.createElement($u, { adjustDateOnChange: t.props.adjustDateOnChange, date: t.state.date, onSelect: t.props.onSelect, setOpen: t.props.setOpen, dropdownMode: t.props.dropdownMode, onChange: t.changeYear, minDate: t.props.minDate, maxDate: t.props.maxDate, year: N(t.state.date), scrollableYearDropdown: t.props.scrollableYearDropdown, yearDropdownItemNumber: t.props.yearDropdownItemNumber });
    }), u(p(t), "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (t.props.showMonthDropdown && !o)
        return m.createElement(Wu, { dropdownMode: t.props.dropdownMode, locale: t.props.locale, onChange: t.changeMonth, month: oe(t.state.date), useShortMonthInDropdown: t.props.useShortMonthInDropdown });
    }), u(p(t), "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (t.props.showMonthYearDropdown && !o)
        return m.createElement(Bu, { dropdownMode: t.props.dropdownMode, locale: t.props.locale, dateFormat: t.props.dateFormat, onChange: t.changeMonthYear, minDate: t.props.minDate, maxDate: t.props.maxDate, date: t.state.date, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown });
    }), u(p(t), "handleTodayButtonClick", function(o) {
      t.props.onSelect(Ar(), o), t.props.setPreSelection && t.props.setPreSelection(Ar());
    }), u(p(t), "renderTodayButton", function() {
      if (t.props.todayButton && !t.props.showTimeSelectOnly)
        return m.createElement("div", { className: "react-datepicker__today-button", onClick: function(o) {
          return t.handleTodayButtonClick(o);
        } }, t.props.todayButton);
    }), u(p(t), "renderDefaultHeader", function(o) {
      var s = o.monthDate, a = o.i;
      return m.createElement("div", { className: "react-datepicker__header ".concat(t.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, t.renderCurrentMonth(s), m.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(t.props.dropdownMode), onFocus: t.handleDropdownFocus }, t.renderMonthDropdown(a !== 0), t.renderMonthYearDropdown(a !== 0), t.renderYearDropdown(a !== 0)), m.createElement("div", { className: "react-datepicker__day-names" }, t.header(s)));
    }), u(p(t), "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = o.monthDate, a = o.i;
      if (t.props.showTimeSelect && !t.state.monthContainer || t.props.showTimeSelectOnly)
        return null;
      var i = Br(t.state.date, t.props), c = qr(t.state.date, t.props), l = Qr(t.state.date, t.props), d = Kr(t.state.date, t.props), f = !t.props.showMonthYearPicker && !t.props.showQuarterYearPicker && !t.props.showYearPicker;
      return m.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: t.props.onDropdownFocus }, t.props.renderCustomHeader(Pe(Pe({}, t.state), {}, { customHeaderCount: a, monthDate: s, changeMonth: t.changeMonth, changeYear: t.changeYear, decreaseMonth: t.decreaseMonth, increaseMonth: t.increaseMonth, decreaseYear: t.decreaseYear, increaseYear: t.increaseYear, prevMonthButtonDisabled: i, nextMonthButtonDisabled: c, prevYearButtonDisabled: l, nextYearButtonDisabled: d })), f && m.createElement("div", { className: "react-datepicker__day-names" }, t.header(s)));
    }), u(p(t), "renderYearHeader", function() {
      var o = t.state.date, s = t.props, a = s.showYearPicker, i = at(o, s.yearItemNumber), c = i.startPeriod, l = i.endPeriod;
      return m.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, a ? "".concat(c, " - ").concat(l) : N(o));
    }), u(p(t), "renderHeader", function(o) {
      switch (!0) {
        case t.props.renderCustomHeader !== void 0:
          return t.renderCustomHeader(o);
        case (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker):
          return t.renderYearHeader(o);
        default:
          return t.renderDefaultHeader(o);
      }
    }), u(p(t), "renderMonths", function() {
      var o;
      if (!t.props.showTimeSelectOnly && !t.props.showYearPicker) {
        for (var s = [], a = t.props.showPreviousMonths ? t.props.monthsShown - 1 : 0, i = lt(t.state.date, a), c = (o = t.props.monthSelectedIn) !== null && o !== void 0 ? o : a, l = 0; l < t.props.monthsShown; ++l) {
          var d = ye(i, l - c + a), f = "month-".concat(l), g = l < t.props.monthsShown - 1, h = l > 0;
          s.push(m.createElement("div", { key: f, ref: function(y) {
            t.monthContainer = y;
          }, className: "react-datepicker__month-container" }, t.renderHeader({ monthDate: d, i: l }), m.createElement(zu, { chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: t.props.weekAriaLabelPrefix, ariaLabelPrefix: t.props.monthAriaLabelPrefix, onChange: t.changeMonthYear, day: d, dayClassName: t.props.dayClassName, calendarStartDay: t.props.calendarStartDay, monthClassName: t.props.monthClassName, onDayClick: t.handleDayClick, handleOnKeyDown: t.props.handleOnDayKeyDown, onDayMouseEnter: t.handleDayMouseEnter, onMouseLeave: t.handleMonthMouseLeave, onWeekSelect: t.props.onWeekSelect, orderInDisplay: l, formatWeekNumber: t.props.formatWeekNumber, locale: t.props.locale, minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, highlightDates: t.props.highlightDates, holidays: t.props.holidays, selectingDate: t.state.selectingDate, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, fixedHeight: t.props.fixedHeight, filterDate: t.props.filterDate, preSelection: t.props.preSelection, setPreSelection: t.props.setPreSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, showWeekNumbers: t.props.showWeekNumbers, startDate: t.props.startDate, endDate: t.props.endDate, peekNextMonth: t.props.peekNextMonth, setOpen: t.props.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, renderDayContents: t.props.renderDayContents, renderMonthContent: t.props.renderMonthContent, renderQuarterContent: t.props.renderQuarterContent, renderYearContent: t.props.renderYearContent, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, showMonthYearPicker: t.props.showMonthYearPicker, showFullMonthYearPicker: t.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: t.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: t.props.showFourColumnMonthYearPicker, showYearPicker: t.props.showYearPicker, showQuarterYearPicker: t.props.showQuarterYearPicker, showWeekPicker: t.props.showWeekPicker, isInputFocused: t.props.isInputFocused, containerRef: t.containerRef, monthShowsDuplicateDaysEnd: g, monthShowsDuplicateDaysStart: h })));
        }
        return s;
      }
    }), u(p(t), "renderYears", function() {
      if (!t.props.showTimeSelectOnly)
        return t.props.showYearPicker ? m.createElement("div", { className: "react-datepicker__year--container" }, t.renderHeader(), m.createElement(Vu, _t({ onDayClick: t.handleDayClick, selectingDate: t.state.selectingDate, clearSelectingDate: t.clearSelectingDate, date: t.state.date }, t.props, { onYearMouseEnter: t.handleYearMouseEnter, onYearMouseLeave: t.handleYearMouseLeave }))) : void 0;
    }), u(p(t), "renderTimeSection", function() {
      if (t.props.showTimeSelect && (t.state.monthContainer || t.props.showTimeSelectOnly))
        return m.createElement(oa, { selected: t.props.selected, openToDate: t.props.openToDate, onChange: t.props.onTimeChange, timeClassName: t.props.timeClassName, format: t.props.timeFormat, includeTimes: t.props.includeTimes, intervals: t.props.timeIntervals, minTime: t.props.minTime, maxTime: t.props.maxTime, excludeTimes: t.props.excludeTimes, filterTime: t.props.filterTime, timeCaption: t.props.timeCaption, todayButton: t.props.todayButton, showMonthDropdown: t.props.showMonthDropdown, showMonthYearDropdown: t.props.showMonthYearDropdown, showYearDropdown: t.props.showYearDropdown, withPortal: t.props.withPortal, monthRef: t.state.monthContainer, injectTimes: t.props.injectTimes, locale: t.props.locale, handleOnKeyDown: t.props.handleOnKeyDown, showTimeSelectOnly: t.props.showTimeSelectOnly });
    }), u(p(t), "renderInputTimeSection", function() {
      var o = new Date(t.props.selected), s = Ne(o) && t.props.selected ? "".concat(Vr(o.getHours()), ":").concat(Vr(o.getMinutes())) : "";
      if (t.props.showTimeInput)
        return m.createElement(Uu, { date: o, timeString: s, timeInputLabel: t.props.timeInputLabel, onChange: t.props.onTimeChange, customTimeInput: t.props.customTimeInput });
    }), u(p(t), "renderAriaLiveRegion", function() {
      var o, s = at(t.state.date, t.props.yearItemNumber), a = s.startPeriod, i = s.endPeriod;
      return o = t.props.showYearPicker ? "".concat(a, " - ").concat(i) : t.props.showMonthYearPicker || t.props.showQuarterYearPicker ? N(t.state.date) : "".concat(cr(oe(t.state.date), t.props.locale), " ").concat(N(t.state.date)), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, t.state.isRenderAriaLiveMessage && o);
    }), u(p(t), "renderChildren", function() {
      if (t.props.children)
        return m.createElement("div", { className: "react-datepicker__children-container" }, t.props.children);
    }), t.containerRef = m.createRef(), t.state = { date: t.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, t;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    var e = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({ monthContainer: e.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(e) {
    var t = this;
    if (!this.props.preSelection || A(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn)
      this.props.openToDate && !A(this.props.openToDate, e.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var o = !me(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return o && t.handleCustomMonthChange(t.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var e = this.props.container || Gu;
    return m.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, m.createElement(e, { className: J("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }) }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: bt };
  } }]), r;
}(), Ju = function(n) {
  var r = n.icon, e = n.className, t = e === void 0 ? "" : e, o = n.onClick, s = "react-datepicker__calendar-icon";
  return m.isValidElement(r) ? m.cloneElement(r, { className: "".concat(r.props.className || "", " ").concat(s, " ").concat(t), onClick: function(a) {
    typeof r.props.onClick == "function" && r.props.onClick(a), typeof o == "function" && o(a);
  } }) : typeof r == "string" ? m.createElement("i", { className: "".concat(s, " ").concat(r, " ").concat(t), "aria-hidden": "true", onClick: o }) : m.createElement("svg", { className: "".concat(s, " ").concat(t), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: o }, m.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, aa = function(n) {
  function r(e) {
    var t;
    return te(this, r), (t = ee(this, r, [e])).el = document.createElement("div"), t;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return ka.createPortal(this.props.children, this.el);
  } }]), r;
}(), ed = function(n) {
  return !n.disabled && n.tabIndex !== -1;
}, sa = function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "getTabChildren", function() {
      return Array.prototype.slice.call(t.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(ed);
    }), u(p(t), "handleFocusStart", function() {
      var o = t.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), u(p(t), "handleFocusEnd", function() {
      var o = t.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), t.tabLoopRef = m.createRef(), t;
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? m.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, m.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, m.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), r;
}(), Jr, td = (Jr = function(n) {
  function r() {
    return te(this, r), ee(this, r, arguments);
  }
  return re(r, m.Component), ne(r, [{ key: "render", value: function() {
    var e, t = this.props, o = t.className, s = t.wrapperClassName, a = t.hidePopper, i = t.popperComponent, c = t.targetComponent, l = t.enableTabLoop, d = t.popperOnKeyDown, f = t.portalId, g = t.portalHost, h = t.popperProps, y = t.showArrow;
    if (!a) {
      var b = J("react-datepicker-popper", o);
      e = m.createElement(sa, { enableTabLoop: l }, m.createElement("div", { ref: h.refs.setFloating, style: h.floatingStyles, className: b, "data-placement": h.placement, onKeyDown: d }, i, y && m.createElement(Cu, { ref: h.arrowRef, context: h.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })));
    }
    this.props.popperContainer && (e = m.createElement(this.props.popperContainer, {}, e)), f && !a && (e = m.createElement(aa, { portalId: f, portalHost: g }, e));
    var C = J("react-datepicker-wrapper", s);
    return m.createElement(m.Fragment, null, m.createElement("div", { ref: h.refs.setReference, className: C }, c), e);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0 };
  } }]), r;
}(), function(n) {
  var r = Pe(Pe({}, n), {}, { popperModifiers: n.popperModifiers || [], popperProps: n.popperProps || {}, hidePopper: typeof n.hidePopper != "boolean" || n.hidePopper }), e = m.useRef(), t = Ou(Pe({ open: !r.hidePopper, whileElementsMounted: fu, placement: r.popperPlacement, middleware: [hu({ padding: 15 }), Xl(10), gu({ element: e })].concat(Xe(r.popperModifiers)) }, r.popperProps));
  return m.createElement(Jr, _t({}, r, { popperProps: Pe(Pe({}, t), {}, { arrowRef: e }) }));
}), eo = "react-datepicker-ignore-onclickoutside", nd = sn(Zu), _n = "Date input not valid.", rd = function(n) {
  function r(e) {
    var t;
    return te(this, r), u(p(t = ee(this, r, [e])), "getPreSelection", function() {
      return t.props.openToDate ? t.props.openToDate : t.props.selectsEnd && t.props.startDate ? t.props.startDate : t.props.selectsStart && t.props.endDate ? t.props.endDate : W();
    }), u(p(t), "modifyHolidays", function() {
      var o;
      return (o = t.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(s, a) {
        var i = new Date(a.date);
        return xt(i) ? [].concat(Xe(s), [Pe(Pe({}, a), {}, { date: i })]) : s;
      }, []);
    }), u(p(t), "calcInitialState", function() {
      var o, s = t.getPreSelection(), a = Jo(t.props), i = ea(t.props), c = a && Ue(s, De(a)) ? a : i && Le(s, Wn(i)) ? i : s;
      return { open: t.props.startOpen || !1, preventFocus: !1, preSelection: (o = t.props.selectsRange ? t.props.startDate : t.props.selected) !== null && o !== void 0 ? o : c, highlightDates: zr(t.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), u(p(t), "clearPreventFocusTimeout", function() {
      t.preventFocusTimeout && clearTimeout(t.preventFocusTimeout);
    }), u(p(t), "setFocus", function() {
      t.input && t.input.focus && t.input.focus({ preventScroll: !0 });
    }), u(p(t), "setBlur", function() {
      t.input && t.input.blur && t.input.blur(), t.cancelFocusInput();
    }), u(p(t), "setOpen", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      t.setState({ open: o, preSelection: o && t.state.open ? t.state.preSelection : t.calcInitialState().preSelection, lastPreSelectChange: En }, function() {
        o || t.setState(function(a) {
          return { focused: !!s && a.focused };
        }, function() {
          !s && t.setBlur(), t.setState({ inputValue: null });
        });
      });
    }), u(p(t), "inputOk", function() {
      return Ve(t.state.preSelection);
    }), u(p(t), "isCalendarOpen", function() {
      return t.props.open === void 0 ? t.state.open && !t.props.disabled && !t.props.readOnly : t.props.open;
    }), u(p(t), "handleFocus", function(o) {
      t.state.preventFocus || (t.props.onFocus(o), t.props.preventOpenOnFocus || t.props.readOnly || t.setOpen(!0)), t.setState({ focused: !0 });
    }), u(p(t), "sendFocusBackToInput", function() {
      t.preventFocusTimeout && t.clearPreventFocusTimeout(), t.setState({ preventFocus: !0 }, function() {
        t.preventFocusTimeout = setTimeout(function() {
          t.setFocus(), t.setState({ preventFocus: !1 });
        });
      });
    }), u(p(t), "cancelFocusInput", function() {
      clearTimeout(t.inputFocusTimeout), t.inputFocusTimeout = null;
    }), u(p(t), "deferFocusInput", function() {
      t.cancelFocusInput(), t.inputFocusTimeout = setTimeout(function() {
        return t.setFocus();
      }, 1);
    }), u(p(t), "handleDropdownFocus", function() {
      t.cancelFocusInput();
    }), u(p(t), "handleBlur", function(o) {
      (!t.state.open || t.props.withPortal || t.props.showTimeInput) && t.props.onBlur(o), t.setState({ focused: !1 });
    }), u(p(t), "handleCalendarClickOutside", function(o) {
      t.props.inline || t.setOpen(!1), t.props.onClickOutside(o), t.props.withPortal && o.preventDefault();
    }), u(p(t), "handleChange", function() {
      for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
        s[a] = arguments[a];
      var i = s[0];
      if (!t.props.onChangeRaw || (t.props.onChangeRaw.apply(p(t), s), typeof i.isDefaultPrevented == "function" && !i.isDefaultPrevented())) {
        t.setState({ inputValue: i.target.value, lastPreSelectChange: od });
        var c, l, d, f, g, h, y, b, C = (c = i.target.value, l = t.props.dateFormat, d = t.props.locale, f = t.props.strictParsing, g = t.props.minDate, h = null, y = Ye(d) || Ye(Ke()), b = !0, Array.isArray(l) ? (l.forEach(function(D) {
          var w = wn(c, D, /* @__PURE__ */ new Date(), { locale: y, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 });
          f && (b = Ne(w, g) && c === j(w, D, d)), Ne(w, g) && b && (h = w);
        }), h) : (h = wn(c, l, /* @__PURE__ */ new Date(), { locale: y, useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 }), f ? b = Ne(h) && c === j(h, l, d) : Ne(h) || (l = l.match(Nu).map(function(D) {
          var w = D[0];
          if (w === "p" || w === "P") {
            var x = Kt[w];
            return y ? x(D, y.formatLong) : w;
          }
          return D;
        }).join(""), c.length > 0 && (h = wn(c, l.slice(0, c.length), /* @__PURE__ */ new Date(), { useAdditionalWeekYearTokens: !0, useAdditionalDayOfYearTokens: !0 })), Ne(h) || (h = new Date(c))), Ne(h) && b ? h : null));
        t.props.showTimeSelectOnly && t.props.selected && C && !A(C, t.props.selected) && (C = Tu(t.props.selected, { hours: Ce(C), minutes: xe(C), seconds: kr(C) })), !C && i.target.value || (t.props.showWeekPicker && (C = ge(C, t.props.locale, t.props.calendarStartDay)), t.setSelected(C, i, !0));
      }
    }), u(p(t), "handleSelect", function(o, s, a) {
      if (t.props.shouldCloseOnSelect && !t.props.showTimeSelect && t.sendFocusBackToInput(), t.props.onChangeRaw && t.props.onChangeRaw(s), t.props.showWeekPicker && (o = ge(o, t.props.locale, t.props.calendarStartDay)), t.setSelected(o, s, !1, a), t.props.showDateSelect && t.setState({ isRenderAriaLiveMessage: !0 }), !t.props.shouldCloseOnSelect || t.props.showTimeSelect)
        t.setPreSelection(o);
      else if (!t.props.inline) {
        t.props.selectsRange || t.setOpen(!1);
        var i = t.props, c = i.startDate, l = i.endDate;
        !c || l || Xr(o, c) || t.setOpen(!1);
      }
    }), u(p(t), "setSelected", function(o, s, a, i) {
      var c = o;
      if (t.props.showYearPicker) {
        if (c !== null && Zo(N(c), t.props))
          return;
      } else if (t.props.showMonthYearPicker) {
        if (c !== null && Xo(c, t.props))
          return;
      } else if (c !== null && dn(c, t.props))
        return;
      var l = t.props, d = l.onChange, f = l.selectsRange, g = l.startDate, h = l.endDate;
      if (!qe(t.props.selected, c) || t.props.allowSameDay || f)
        if (c !== null && (!t.props.selected || a && (t.props.showTimeSelect || t.props.showTimeSelectOnly || t.props.showTimeInput) || (c = Fr(c, { hour: Ce(t.props.selected), minute: xe(t.props.selected), second: kr(t.props.selected) })), t.props.inline || t.setState({ preSelection: c }), t.props.focusSelectedMonth || t.setState({ monthSelectedIn: i })), f) {
          var y = g && !h, b = g && h;
          !g && !h ? d([c, null], s) : y && (Xr(c, g) ? d([c, null], s) : d([g, c], s)), b && d([c, null], s);
        } else
          d(c, s);
      a || (t.props.onSelect(c, s), t.setState({ inputValue: null }));
    }), u(p(t), "setPreSelection", function(o) {
      var s = t.props.minDate !== void 0, a = t.props.maxDate !== void 0, i = !0;
      if (o) {
        t.props.showWeekPicker && (o = ge(o, t.props.locale, t.props.calendarStartDay));
        var c = De(o);
        if (s && a)
          i = Ht(o, t.props.minDate, t.props.maxDate);
        else if (s) {
          var l = De(t.props.minDate);
          i = Le(o, l) || qe(c, l);
        } else if (a) {
          var d = Wn(t.props.maxDate);
          i = Ue(o, d) || qe(c, d);
        }
      }
      i && t.setState({ preSelection: o });
    }), u(p(t), "toggleCalendar", function() {
      t.setOpen(!t.state.open);
    }), u(p(t), "handleTimeChange", function(o) {
      var s = t.props.selected ? t.props.selected : t.getPreSelection(), a = t.props.selected ? o : Fr(s, { hour: Ce(o), minute: xe(o) });
      t.setState({ preSelection: a }), t.props.onChange(a), t.props.shouldCloseOnSelect && (t.sendFocusBackToInput(), t.setOpen(!1)), t.props.showTimeInput && t.setOpen(!0), (t.props.showTimeSelectOnly || t.props.showTimeSelect) && t.setState({ isRenderAriaLiveMessage: !0 }), t.setState({ inputValue: null });
    }), u(p(t), "onInputClick", function() {
      t.props.disabled || t.props.readOnly || t.setOpen(!0), t.props.onInputClick();
    }), u(p(t), "onInputKeyDown", function(o) {
      t.props.onKeyDown(o);
      var s = o.key;
      if (t.state.open || t.props.inline || t.props.preventOpenOnFocus) {
        if (t.state.open) {
          if (s === "ArrowDown" || s === "ArrowUp") {
            o.preventDefault();
            var a = t.props.showWeekPicker && t.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', i = t.calendar.componentNode && t.calendar.componentNode.querySelector(a);
            return void (i && i.focus({ preventScroll: !0 }));
          }
          var c = W(t.state.preSelection);
          s === "Enter" ? (o.preventDefault(), t.inputOk() && t.state.lastPreSelectChange === En ? (t.handleSelect(c, o), !t.props.shouldCloseOnSelect && t.setPreSelection(c)) : t.setOpen(!1)) : s === "Escape" ? (o.preventDefault(), t.sendFocusBackToInput(), t.setOpen(!1)) : s === "Tab" && t.setOpen(!1), t.inputOk() || t.props.onInputError({ code: 1, msg: _n });
        }
      } else
        s !== "ArrowDown" && s !== "ArrowUp" && s !== "Enter" || t.onInputClick();
    }), u(p(t), "onPortalKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), t.setState({ preventFocus: !0 }, function() {
        t.setOpen(!1), setTimeout(function() {
          t.setFocus(), t.setState({ preventFocus: !1 });
        });
      }));
    }), u(p(t), "onDayKeyDown", function(o) {
      t.props.onKeyDown(o);
      var s = o.key, a = o.shiftKey, i = W(t.state.preSelection);
      if (s === "Enter")
        o.preventDefault(), t.handleSelect(i, o), !t.props.shouldCloseOnSelect && t.setPreSelection(i);
      else if (s === "Escape")
        o.preventDefault(), t.setOpen(!1), t.inputOk() || t.props.onInputError({ code: 1, msg: _n });
      else if (!t.props.disabledKeyboardNavigation) {
        var c;
        switch (s) {
          case "ArrowLeft":
            c = t.props.showWeekPicker ? vr(i, 1) : ec(i, 1);
            break;
          case "ArrowRight":
            c = t.props.showWeekPicker ? zt(i, 1) : We(i, 1);
            break;
          case "ArrowUp":
            c = vr(i, 1);
            break;
          case "ArrowDown":
            c = zt(i, 1);
            break;
          case "PageUp":
            c = a ? St(i, 1) : lt(i, 1);
            break;
          case "PageDown":
            c = a ? ct(i, 1) : ye(i, 1);
            break;
          case "Home":
            c = ge(i, t.props.locale, t.props.calendarStartDay);
            break;
          case "End":
            c = ac(i);
            break;
          default:
            c = null;
        }
        if (!c)
          return void (t.props.onInputError && t.props.onInputError({ code: 1, msg: _n }));
        if (o.preventDefault(), t.setState({ lastPreSelectChange: En }), t.props.adjustDateOnChange && t.setSelected(c), t.setPreSelection(c), t.props.inline) {
          var l = oe(i), d = oe(c), f = N(i), g = N(c);
          l !== d || f !== g ? t.setState({ shouldFocusDayInline: !0 }) : t.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), u(p(t), "onPopperKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), t.sendFocusBackToInput());
    }), u(p(t), "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), t.sendFocusBackToInput(), t.props.selectsRange ? t.props.onChange([null, null], o) : t.props.onChange(null, o), t.setState({ inputValue: null });
    }), u(p(t), "clear", function() {
      t.onClearClick();
    }), u(p(t), "onScroll", function(o) {
      typeof t.props.closeOnScroll == "boolean" && t.props.closeOnScroll ? o.target !== document && o.target !== document.documentElement && o.target !== document.body || t.setOpen(!1) : typeof t.props.closeOnScroll == "function" && t.props.closeOnScroll(o) && t.setOpen(!1);
    }), u(p(t), "renderCalendar", function() {
      return t.props.inline || t.isCalendarOpen() ? m.createElement(nd, { ref: function(o) {
        t.calendar = o;
      }, locale: t.props.locale, calendarStartDay: t.props.calendarStartDay, chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: t.props.weekAriaLabelPrefix, monthAriaLabelPrefix: t.props.monthAriaLabelPrefix, adjustDateOnChange: t.props.adjustDateOnChange, setOpen: t.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, dateFormat: t.props.dateFormatCalendar, useWeekdaysShort: t.props.useWeekdaysShort, formatWeekDay: t.props.formatWeekDay, dropdownMode: t.props.dropdownMode, selected: t.props.selected, preSelection: t.state.preSelection, onSelect: t.handleSelect, onWeekSelect: t.props.onWeekSelect, openToDate: t.props.openToDate, minDate: t.props.minDate, maxDate: t.props.maxDate, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, startDate: t.props.startDate, endDate: t.props.endDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, filterDate: t.props.filterDate, onClickOutside: t.handleCalendarClickOutside, formatWeekNumber: t.props.formatWeekNumber, highlightDates: t.state.highlightDates, holidays: Iu(t.modifyHolidays()), includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, includeTimes: t.props.includeTimes, injectTimes: t.props.injectTimes, inline: t.props.inline, shouldFocusDayInline: t.state.shouldFocusDayInline, peekNextMonth: t.props.peekNextMonth, showMonthDropdown: t.props.showMonthDropdown, showPreviousMonths: t.props.showPreviousMonths, useShortMonthInDropdown: t.props.useShortMonthInDropdown, showMonthYearDropdown: t.props.showMonthYearDropdown, showWeekNumbers: t.props.showWeekNumbers, showYearDropdown: t.props.showYearDropdown, withPortal: t.props.withPortal, forceShowMonthNavigation: t.props.forceShowMonthNavigation, showDisabledMonthNavigation: t.props.showDisabledMonthNavigation, scrollableYearDropdown: t.props.scrollableYearDropdown, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown, todayButton: t.props.todayButton, weekLabel: t.props.weekLabel, outsideClickIgnoreClass: eo, fixedHeight: t.props.fixedHeight, monthsShown: t.props.monthsShown, monthSelectedIn: t.state.monthSelectedIn, onDropdownFocus: t.handleDropdownFocus, onMonthChange: t.props.onMonthChange, onYearChange: t.props.onYearChange, dayClassName: t.props.dayClassName, weekDayClassName: t.props.weekDayClassName, monthClassName: t.props.monthClassName, timeClassName: t.props.timeClassName, showDateSelect: t.props.showDateSelect, showTimeSelect: t.props.showTimeSelect, showTimeSelectOnly: t.props.showTimeSelectOnly, onTimeChange: t.handleTimeChange, timeFormat: t.props.timeFormat, timeIntervals: t.props.timeIntervals, minTime: t.props.minTime, maxTime: t.props.maxTime, excludeTimes: t.props.excludeTimes, filterTime: t.props.filterTime, timeCaption: t.props.timeCaption, className: t.props.calendarClassName, container: t.props.calendarContainer, yearItemNumber: t.props.yearItemNumber, yearDropdownItemNumber: t.props.yearDropdownItemNumber, previousMonthAriaLabel: t.props.previousMonthAriaLabel, previousMonthButtonLabel: t.props.previousMonthButtonLabel, nextMonthAriaLabel: t.props.nextMonthAriaLabel, nextMonthButtonLabel: t.props.nextMonthButtonLabel, previousYearAriaLabel: t.props.previousYearAriaLabel, previousYearButtonLabel: t.props.previousYearButtonLabel, nextYearAriaLabel: t.props.nextYearAriaLabel, nextYearButtonLabel: t.props.nextYearButtonLabel, timeInputLabel: t.props.timeInputLabel, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, renderCustomHeader: t.props.renderCustomHeader, popperProps: t.props.popperProps, renderDayContents: t.props.renderDayContents, renderMonthContent: t.props.renderMonthContent, renderQuarterContent: t.props.renderQuarterContent, renderYearContent: t.props.renderYearContent, onDayMouseEnter: t.props.onDayMouseEnter, onMonthMouseLeave: t.props.onMonthMouseLeave, onYearMouseEnter: t.props.onYearMouseEnter, onYearMouseLeave: t.props.onYearMouseLeave, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, showTimeInput: t.props.showTimeInput, showMonthYearPicker: t.props.showMonthYearPicker, showFullMonthYearPicker: t.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: t.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: t.props.showFourColumnMonthYearPicker, showYearPicker: t.props.showYearPicker, showQuarterYearPicker: t.props.showQuarterYearPicker, showWeekPicker: t.props.showWeekPicker, excludeScrollbar: t.props.excludeScrollbar, handleOnKeyDown: t.props.onKeyDown, handleOnDayKeyDown: t.onDayKeyDown, isInputFocused: t.state.focused, customTimeInput: t.props.customTimeInput, setPreSelection: t.setPreSelection }, t.props.children) : null;
    }), u(p(t), "renderAriaLiveRegion", function() {
      var o, s = t.props, a = s.dateFormat, i = s.locale, c = t.props.showTimeInput || t.props.showTimeSelect ? "PPPPp" : "PPPP";
      return o = t.props.selectsRange ? "Selected start date: ".concat(be(t.props.startDate, { dateFormat: c, locale: i }), ". ").concat(t.props.endDate ? "End date: " + be(t.props.endDate, { dateFormat: c, locale: i }) : "") : t.props.showTimeSelectOnly ? "Selected time: ".concat(be(t.props.selected, { dateFormat: a, locale: i })) : t.props.showYearPicker ? "Selected year: ".concat(be(t.props.selected, { dateFormat: "yyyy", locale: i })) : t.props.showMonthYearPicker ? "Selected month: ".concat(be(t.props.selected, { dateFormat: "MMMM yyyy", locale: i })) : t.props.showQuarterYearPicker ? "Selected quarter: ".concat(be(t.props.selected, { dateFormat: "yyyy, QQQ", locale: i })) : "Selected date: ".concat(be(t.props.selected, { dateFormat: c, locale: i })), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, o);
    }), u(p(t), "renderDateInput", function() {
      var o, s = J(t.props.className, u({}, eo, t.state.open)), a = t.props.customInput || m.createElement("input", { type: "text" }), i = t.props.customInputRef || "ref", c = typeof t.props.value == "string" ? t.props.value : typeof t.state.inputValue == "string" ? t.state.inputValue : t.props.selectsRange ? function(l, d, f) {
        if (!l)
          return "";
        var g = be(l, f), h = d ? be(d, f) : "";
        return "".concat(g, " - ").concat(h);
      }(t.props.startDate, t.props.endDate, t.props) : be(t.props.selected, t.props);
      return m.cloneElement(a, (u(u(u(u(u(u(u(u(u(u(o = {}, i, function(l) {
        t.input = l;
      }), "value", c), "onBlur", t.handleBlur), "onChange", t.handleChange), "onClick", t.onInputClick), "onFocus", t.handleFocus), "onKeyDown", t.onInputKeyDown), "id", t.props.id), "name", t.props.name), "form", t.props.form), u(u(u(u(u(u(u(u(u(u(o, "autoFocus", t.props.autoFocus), "placeholder", t.props.placeholderText), "disabled", t.props.disabled), "autoComplete", t.props.autoComplete), "className", J(a.props.className, s)), "title", t.props.title), "readOnly", t.props.readOnly), "required", t.props.required), "tabIndex", t.props.tabIndex), "aria-describedby", t.props.ariaDescribedBy), u(u(u(o, "aria-invalid", t.props.ariaInvalid), "aria-labelledby", t.props.ariaLabelledBy), "aria-required", t.props.ariaRequired)));
    }), u(p(t), "renderClearButton", function() {
      var o = t.props, s = o.isClearable, a = o.disabled, i = o.selected, c = o.startDate, l = o.endDate, d = o.clearButtonTitle, f = o.clearButtonClassName, g = f === void 0 ? "" : f, h = o.ariaLabelClose, y = h === void 0 ? "Close" : h;
      return !s || i == null && c == null && l == null ? null : m.createElement("button", { type: "button", className: J("react-datepicker__close-icon", g, { "react-datepicker__close-icon--disabled": a }), disabled: a, "aria-label": y, onClick: t.onClearClick, title: d, tabIndex: -1 });
    }), t.state = t.calcInitialState(), t.preventFocusTimeout = null, t;
  }
  return re(r, m.Component), ne(r, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(e, t) {
    var o, s;
    e.inline && (o = e.selected, s = this.props.selected, o && s ? oe(o) !== oe(s) || N(o) !== N(s) : o !== s) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && e.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: zr(this.props.highlightDates) }), t.focused || qe(e.selected, this.props.selected) || this.setState({ inputValue: null }), t.open !== this.state.open && (t.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), t.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var e = this.props, t = e.showIcon, o = e.icon, s = e.calendarIconClassname, a = e.toggleCalendarOnIconClick, i = this.state.open;
    return m.createElement("div", { className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "") }, t && m.createElement(Ju, _t({ icon: o, className: "".concat(s, " ").concat(i && "react-datepicker-ignore-onclickoutside") }, a ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var e = this.renderCalendar();
    if (this.props.inline)
      return e;
    if (this.props.withPortal) {
      var t = this.state.open ? m.createElement(sa, { enableTabLoop: this.props.enableTabLoop }, m.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, e)) : null;
      return this.state.open && this.props.portalId && (t = m.createElement(aa, { portalId: this.props.portalId, portalHost: this.props.portalHost }, t)), m.createElement("div", null, this.renderInputContainer(), t);
    }
    return m.createElement(td, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: e, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop, showArrow: this.props.showPopperArrow });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: bt, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), r;
}(), od = "input", En = "navigate";
function Zd({
  icon: n,
  ...r
}) {
  return /* @__PURE__ */ v(rd, { customInput: /* @__PURE__ */ v(Ys, { "data-testid": "date-picker", icon: n }), ...r });
}
const ad = _(fe)`
  color: ${({ theme: n }) => pe(n.colors.grey)};
  background-color: ${({ theme: n }) => n.colors.white};
  ${({ theme: n }) => n.borderRadius.m}
  box-shadow: 0 1px 4px 0 ${({ theme: n }) => Dt(n.colors.grey)}, 0 0 0 1px ${({ theme: n }) => Dt(n.colors.grey)};
`, Jd = ({ children: n, ...r }) => /* @__PURE__ */ v(ad, { p: ["s", "gutter"], ...r, children: n }), sd = _(fe)`
  position: absolute;
  right: 0;
  z-index: 9999;
  width: 225px;
  margin-top: 4px;
  ${({ theme: n }) => n.borderRadius.m};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 5px 16px 0px rgba(0, 0, 0, 0.2);
  background: ${({ theme: n }) => n.colors.white};
  padding: 20px;
`, id = _.ul`
  margin: 0;
  margin-top: 4px;
  list-style: none;
  padding: 0;

  > li {
    margin: 0px -20px;
    padding: 0px 20px;
    cursor: pointer;

    transition: ${({ theme: n }) => `background-color 250ms ${n.bezierCurve}`};

    &:hover:not(:disabled) {
      background-color: ${({ theme: n }) => Dt(n.colors.grey)};
    }

    &:focus:not(:disabled) {
      background-color: ${({ theme: n }) => Dt(n.colors.grey)};
    }

    &:active:not(:disabled) {
      background-color: ${({ theme: n }) => ho(n.colors.grey)};
    }

    :not(:last-child) {
      margin-bottom: 12px;
    }
  }
`, cd = _(yo)`
  :not(:first-of-type) {
    padding-top: 24px;
  }
`, ld = _(fe)`
  position: relative;
`, ud = _.li`
  display: flex;
  align-items: center;
  opacity: ${({ disabled: n }) => n ? 0.4 : 1};
  pointer-events: ${({ disabled: n }) => n ? "none" : void 0};
`, dd = _.i`
  font-size: 20px;
  margin-right: 8px;

  &::before {
    margin: 0;
  }
`, ep = ({
  items: n,
  children: r,
  logLabelSuffix: e
}) => {
  const [t, o] = oo(!1), s = () => /* @__PURE__ */ v(sd, { children: Object.keys(n).map((a) => /* @__PURE__ */ Q(ya, { children: [
    /* @__PURE__ */ v(cd, { size: "s", color: "grey", children: a }),
    /* @__PURE__ */ v(id, { children: n[a].filter((i) => !i.shouldHide).map((i) => /* @__PURE__ */ Q(
      ud,
      {
        disabled: i.disabled,
        "aria-disabled": i.disabled,
        onClick: () => {
          o(!1), i.callback();
        },
        role: "button",
        children: [
          i.icon && /* @__PURE__ */ v(dd, { className: `uil uil-${i.icon}` }),
          /* @__PURE__ */ v(yo, { children: i.text })
        ]
      },
      i.text
    )) })
  ] }, a)) });
  return /* @__PURE__ */ v(us, { children: /* @__PURE__ */ Q(ld, { children: [
    /* @__PURE__ */ v(
      go,
      {
        onClick: () => o(!t),
        variant: "secondary",
        logLabel: `open-menu-${e}`,
        children: /* @__PURE__ */ v(fe, { display: "flex", alignItems: "center", children: r })
      }
    ),
    t && /* @__PURE__ */ v(s, {})
  ] }) });
}, pd = "'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 86.001 86.001%22%3E%3Cpath d=%22M64.998 80.095a3.484 3.484 0 0 1 0 4.893 3.401 3.401 0 0 1-4.844 0l-39.151-39.54a3.486 3.486 0 0 1 0-4.895l39.15-39.539a3.4 3.4 0 0 1 4.844 0A3.487 3.487 0 0 1 65 5.907L29.294 43.001l35.704 37.094z%22 fill=%22%23039CF2%22/%3E%3C/svg%3E'", fd = "'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 512 512%22%3E%3Cpath d=%22M367.954 213.588L160.67 5.872c-7.804-7.819-20.467-7.831-28.284-.029-7.819 7.802-7.832 20.465-.03 28.284l207.299 207.731c7.798 7.798 7.798 20.486-.015 28.299L132.356 477.873c-7.802 7.819-7.789 20.482.03 28.284A19.935 19.935 0 0 0 146.513 512c5.125 0 10.25-1.958 14.157-5.873l207.269-207.701c23.394-23.394 23.394-61.459.015-84.838z%22 fill=%22%23039CF2%22/%3E%3C/svg%3E'", to = _.a(({ direction: n, enabled: r, theme: e }) => ({
  width: 20,
  height: 24,
  paddingLeft: 2,
  paddingRight: 2,
  display: "inline-block",
  color: e.colors.primary,
  background: `url(${n === "left" ? pd : fd}) no-repeat center center`,
  backgroundSize: 12,
  opacity: r ? 1 : 0.3,
  cursor: r ? "pointer" : "default"
})), no = _.span(({ theme: n }) => ({
  width: 20,
  display: "inline-block",
  paddingLeft: 6,
  paddingRight: 6,
  textAlign: "center",
  fontSize: 18,
  color: ze(n.colors.grey)
})), On = _.a(({ active: n, theme: r }) => ({
  paddingLeft: 6,
  paddingRight: 6,
  display: "inline-block",
  textAlign: "center",
  cursor: "pointer",
  color: n ? r.colors.black : r.colors.primary,
  fontWeight: n ? 700 : 400
})), hd = _.div({
  userSelect: "none",
  display: "flex",
  fontSize: 18
});
class tp extends m.Component {
  constructor() {
    super(...arguments);
    k(this, "lastPage", () => Math.ceil(this.props.numberOfItems / this.props.pageSize));
    k(this, "center", () => Math.floor(this.props.numbersInMiddle / 2));
    k(this, "nextPage", () => {
      const e = this.props.activePage + 1;
      return e <= this.lastPage() ? e : this.props.activePage;
    });
    k(this, "previousPage", () => {
      const e = this.props.activePage - 1;
      return e >= 1 ? e : this.props.activePage;
    });
    k(this, "handleClick", (e) => {
      this.props.onChange(e);
    });
    k(this, "renderJumpToStart", () => /* @__PURE__ */ Q(wt, { children: [
      /* @__PURE__ */ v(On, { onClick: () => this.handleClick(1), active: !1, children: "1" }, "start"),
      /* @__PURE__ */ v(no, { children: "…" }),
      " "
    ] }));
    k(this, "renderJumpToEnd", () => /* @__PURE__ */ Q(wt, { children: [
      /* @__PURE__ */ v(no, { children: "…" }),
      /* @__PURE__ */ v(On, { onClick: () => this.handleClick(this.lastPage()), active: !1, children: this.lastPage() }, "end")
    ] }));
    k(this, "getPages", () => Array(this.props.numbersInMiddle).fill(void 0).map(this.isWithinInitialRange() ? this.fillStart : this.getActivePages).filter((e) => e !== void 0).sort((e, t) => e - t));
    k(this, "fillStart", (e, t) => this.props.numbersInMiddle - t <= this.lastPage() ? this.props.numbersInMiddle - t : void 0);
    k(this, "fillEnd", (e, t) => this.lastPage() - t);
    k(this, "getActivePages", (e, t) => {
      if (this.props.activePage + this.props.numbersInMiddle - this.center() > this.lastPage())
        return this.fillEnd(e, t);
      let o = this.props.activePage - t;
      return t > this.center() && this.props.activePage + t - this.center() <= this.lastPage() && (o = this.props.activePage + t - this.center()), o <= this.lastPage() ? o : void 0;
    });
    k(this, "isWithinInitialRange", () => this.props.activePage <= this.props.numbersInMiddle - this.center() || this.props.numbersInMiddle >= this.lastPage());
    k(this, "isWithinEndRange", () => this.props.activePage + this.props.numbersInMiddle - this.center() > this.lastPage() || this.props.numbersInMiddle >= this.lastPage());
  }
  render() {
    return this.lastPage() === 1 || this.lastPage() === 0 ? null : /* @__PURE__ */ Q(hd, { children: [
      /* @__PURE__ */ v(
        to,
        {
          direction: "left",
          enabled: this.props.activePage !== 1,
          onClick: () => this.handleClick(this.previousPage())
        }
      ),
      !this.isWithinInitialRange() && this.renderJumpToStart(),
      this.getPages().map((e) => /* @__PURE__ */ v(
        On,
        {
          onClick: () => this.handleClick(e),
          active: e === this.props.activePage,
          children: e
        },
        e
      )),
      !this.isWithinEndRange() && this.renderJumpToEnd(),
      /* @__PURE__ */ v(
        to,
        {
          direction: "right",
          enabled: this.props.activePage !== this.lastPage(),
          onClick: () => this.handleClick(this.nextPage())
        }
      )
    ] });
  }
}
const md = _.label`
  background-color: white;
  text-align: center;
  padding: 6px 24px;
  font-weight: 500;
  font-size: 16px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 0.1s ease-in-out;
  display: inline-block;

  :hover {
    cursor: pointer;
    background-color: #7e90ca;
  }

  &.checked {
    background-color: #2552ec;
    color: #fff;
  }

  &.unchecked {
    background-color: #e1e5f2;
    color: #68718c;
  }

  :first-of-type {
    border-radius: 18px 0 0 18px;
  }

  :last-of-type {
    border-radius: 0 18px 18px 0;
  }
`, gd = _.input`
  display: none;
  font-family: ${({ theme: n }) => n.bodyFont};
`, np = ({ checked: n, onToggle: r, items: e }) => /* @__PURE__ */ v(fe, { children: e.map((t, o) => /* @__PURE__ */ Q(m.Fragment, { children: [
  /* @__PURE__ */ v(
    md,
    {
      className: n === t.value ? "checked" : "unchecked",
      htmlFor: t.value,
      children: t.label
    }
  ),
  /* @__PURE__ */ v(
    gd,
    {
      id: t.value,
      checked: n === t.value,
      onChange: (s) => r(s.target.value),
      value: t.value,
      type: "radio"
    },
    o
  )
] }, o)) }), rp = ({ theme: n = He, children: r }) => /* @__PURE__ */ v(la, { theme: n, children: r });
export {
  rp as Alexandria,
  Rd as B1,
  Id as B2,
  Yd as B3,
  Ld as B4,
  Fd as B5,
  $d as B6,
  Nd as Badge,
  fe as Box,
  go as Button,
  us as ButtonGroup,
  Jd as Card,
  Qd as Checkbox,
  zd as Combobox,
  Zd as DatePicker,
  qd as Dropdown,
  ep as DropdownMenu,
  Hd as Grid,
  ms as H1,
  gs as H2,
  ys as H3,
  bs as H4,
  ws as H5,
  vs as H6,
  jd as Inline,
  Ys as Input,
  _d as L16,
  Un as L24,
  ze as L32,
  pe as L40,
  Pd as L56,
  ns as L64,
  Md as L72,
  Ed as L8,
  ho as L80,
  Dt as L88,
  ts as L96,
  Sd as L98,
  ft as Label,
  Od as LinkButton,
  Td as Message,
  yo as P,
  Wd as Page,
  tp as Paginator,
  Bs as Radio,
  Kd as RadioCard,
  Xd as RouteTabs,
  Cd as Spinner,
  Vn as SpinnerSvg,
  bo as Stack,
  np as Switch,
  Gd as Tab,
  Ud as Tabs,
  Ad as Text,
  Bd as TextArea,
  Vd as Toggle,
  _e as base,
  He as defaultTheme
};
